window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.AnswerContainerDown = function() {
	this.initialize(img.MainAssets_AnswerContainerDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,768,143);


(lib.AnswerContainerOver = function() {
	this.initialize(img.MainAssets_AnswerContainerOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,768,143);


(lib.AnswerSlot = function() {
	this.initialize(img.MainAssets_AnswerSlot);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,807,137);


(lib.BackDisabled = function() {
	this.initialize(img.MainAssets_BackDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,201,62);


(lib.BackOver = function() {
	this.initialize(img.MainAssets_BackOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,201,62);


(lib.BackUp = function() {
	this.initialize(img.MainAssets_BackUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,201,62);


(lib.BadDown = function() {
	this.initialize(img.MainAssets_BadDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.BadOver = function() {
	this.initialize(img.MainAssets_BadOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.BadUp = function() {
	this.initialize(img.MainAssets_BadUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.BottomBar = function() {
	this.initialize(img.MainAssets_BottomBar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1923,179);


(lib.BriefingBackground = function() {
	this.initialize(img.MainAssets_BriefingBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1921,1081);


(lib.BriefingBlackBar = function() {
	this.initialize(img.MainAssets_BriefingBlackBar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,37,852);


(lib.BriefingBodybackground = function() {
	this.initialize(img.MainAssets_BriefingBodybackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1268,867);


(lib.BriefingTimeLine = function() {
	this.initialize(img.MainAssets_BriefingTimeLine);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,189,1156);


(lib.BriefingTimelineBackground = function() {
	this.initialize(img.MainAssets_BriefingTimelineBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,72,1122);


(lib.BriefingTimelineBars = function() {
	this.initialize(img.MainAssets_BriefingTimelineBars);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,87,27);


(lib.ButtonOverWhite = function() {
	this.initialize(img.MainAssets_ButtonOverWhite);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,307,61);


(lib.ButtonOverWhitepngcopy = function() {
	this.initialize(img.MainAssets_ButtonOverWhitepngcopy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,307,61);


(lib.CloseButtonIcon = function() {
	this.initialize(img.MainAssets_CloseButtonIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,17,17);


(lib.CompletedKDConfirmationScreen = function() {
	this.initialize(img.MainAssets_CompletedKDConfirmationScreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,141,140);


(lib.ContinueButtonDisabled = function() {
	this.initialize(img.MainAssets_ContinueButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,309,63);


(lib.ContinueButtonHi = function() {
	this.initialize(img.MainAssets_ContinueButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,309,63);


(lib.ContinueButtonUp = function() {
	this.initialize(img.MainAssets_ContinueButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,309,63);


(lib.DashboardBG = function() {
	this.initialize(img.MainAssets_DashboardBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1603,903);


(lib.DashboardButton = function() {
	this.initialize(img.MainAssets_DashboardButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,160,130);


(lib.DashboardButtonOver = function() {
	this.initialize(img.MainAssets_DashboardButtonOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,160,130);


(lib.DashboardGraphLabel = function() {
	this.initialize(img.MainAssets_DashboardGraphLabel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,340,41);


(lib.DecisionButtonHi = function() {
	this.initialize(img.MainAssets_DecisionButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,724,180);


(lib.DecisionButtonUp = function() {
	this.initialize(img.MainAssets_DecisionButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,724,180);


(lib.DialogBackBackground = function() {
	this.initialize(img.MainAssets_DialogBackBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,89,47);


(lib.DialogBackButtonDisabled = function() {
	this.initialize(img.MainAssets_DialogBackButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,62,39);


(lib.DialogBackButtonDown = function() {
	this.initialize(img.MainAssets_DialogBackButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,62,39);


(lib.DialogBackButtonUp = function() {
	this.initialize(img.MainAssets_DialogBackButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,62,39);


(lib.DialogButtonRight = function() {
	this.initialize(img.MainAssets_DialogButtonRight);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,483,63);


(lib.DialogButtonUp = function() {
	this.initialize(img.MainAssets_DialogButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,768,143);


(lib.DialogButtonWrong = function() {
	this.initialize(img.MainAssets_DialogButtonWrong);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,483,63);


(lib.DialogNPCTextFieldBG1 = function() {
	this.initialize(img.MainAssets_DialogNPCTextFieldBG1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,765,323);


(lib.ExpandOptimal = function() {
	this.initialize(img.MainAssets_ExpandOptimal);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,23,25);


(lib.ExpandPlayerChoice = function() {
	this.initialize(img.MainAssets_ExpandPlayerChoice);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,23,25);


(lib.FeedbackBackground = function() {
	this.initialize(img.MainAssets_FeedbackBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.FeedbackBGpointer = function() {
	this.initialize(img.MainAssets_FeedbackBGpointer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,43,96);


(lib.FeedbackBlackBar = function() {
	this.initialize(img.MainAssets_FeedbackBlackBar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,22,174);


(lib.FeedbackContentContainer = function() {
	this.initialize(img.MainAssets_FeedbackContentContainer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1775,1080);


(lib.FeedbackIcon = function() {
	this.initialize(img.MainAssets_FeedbackIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,54,42);


(lib.FeedbackInactiveKD = function() {
	this.initialize(img.MainAssets_FeedbackInactiveKD);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,48,49);


(lib.FeedbackInactiveKDOver = function() {
	this.initialize(img.MainAssets_FeedbackInactiveKDOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,49,49);


(lib.FeedbackKDInfoExpansion = function() {
	this.initialize(img.MainAssets_FeedbackKDInfoExpansion);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,508,96);


(lib.FeedbackKDOptimal = function() {
	this.initialize(img.MainAssets_FeedbackKDOptimal);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,279,147);


(lib.FeedbackKDPlayerChoice = function() {
	this.initialize(img.MainAssets_FeedbackKDPlayerChoice);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,279,147);


(lib.FeedbackKDSmall = function() {
	this.initialize(img.MainAssets_FeedbackKDSmall);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,77,77);


(lib.FeedbackLongBar = function() {
	this.initialize(img.MainAssets_FeedbackLongBar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,21,1080);


(lib.FeedbackPointer = function() {
	this.initialize(img.MainAssets_FeedbackPointer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,25,48);


(lib.FeedbackSmallBar = function() {
	this.initialize(img.MainAssets_FeedbackSmallBar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,51,14);


(lib.FeedbackToolTipBlackScreen = function() {
	this.initialize(img.MainAssets_FeedbackToolTipBlackScreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,741,338);


(lib.FeedbackToolTipWhiteScreen = function() {
	this.initialize(img.MainAssets_FeedbackToolTipWhiteScreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,741,338);


(lib.GoodDown = function() {
	this.initialize(img.MainAssets_GoodDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.GoodOver = function() {
	this.initialize(img.MainAssets_GoodOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.GoodUp = function() {
	this.initialize(img.MainAssets_GoodUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.HideOptimalDown = function() {
	this.initialize(img.MainAssets_HideOptimalDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,409,66);


(lib.HideOptimalOver = function() {
	this.initialize(img.MainAssets_HideOptimalOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,410,66);


(lib.HideOptimalUp = function() {
	this.initialize(img.MainAssets_HideOptimalUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,409,66);


(lib.HUBLaptopOver = function() {
	this.initialize(img.MainAssets_HUBLaptopOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,320,242);


(lib.HUBLaptopUp = function() {
	this.initialize(img.MainAssets_HUBLaptopUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,291,213);


(lib.HUBmapCh1 = function() {
	this.initialize(img.MainAssets_HUBmapCh1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1922,1081);


(lib.HUBmapCh1jpgcopy = function() {
	this.initialize(img.MainAssets_HUBmapCh1jpgcopy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1922,1081);


(lib.HUBmapCh1_1 = function() {
	this.initialize(img.MainAssets_HUBmapCh1_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1921,1081);


(lib.HUBNewItemLabel1 = function() {
	this.initialize(img.MainAssets_HUBNewItemLabel1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,84,80);


(lib.HUBSmartphoneOver = function() {
	this.initialize(img.MainAssets_HUBSmartphoneOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,177,241);


(lib.HUBSmartphoneUp = function() {
	this.initialize(img.MainAssets_HUBSmartphoneUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,177,241);


(lib.HUBStakeholderButtonBGDisabled = function() {
	this.initialize(img.MainAssets_HUBStakeholderButtonBGDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,167,165);


(lib.HUBStakeholderButtonBGUp = function() {
	this.initialize(img.MainAssets_HUBStakeholderButtonBGUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,166,166);


(lib.HUBStakeholderButtonLabelDisabled = function() {
	this.initialize(img.MainAssets_HUBStakeholderButtonLabelDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,176,72);


(lib.HUBStakeholderButtonLabelOver = function() {
	this.initialize(img.MainAssets_HUBStakeholderButtonLabelOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,176,72);


(lib.HUBStakeholderButtonLabelUp = function() {
	this.initialize(img.MainAssets_HUBStakeholderButtonLabelUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,176,72);


(lib.HUBTeaCornerButtonBGDisabled = function() {
	this.initialize(img.MainAssets_HUBTeaCornerButtonBGDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,128,129);


(lib.HUBTeaCornerButtonBGUp = function() {
	this.initialize(img.MainAssets_HUBTeaCornerButtonBGUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,128,129);


(lib.HUBTeaCornerButtonLabelDisabled = function() {
	this.initialize(img.MainAssets_HUBTeaCornerButtonLabelDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,228,91);


(lib.HUBTeaCornerButtonLabelOver = function() {
	this.initialize(img.MainAssets_HUBTeaCornerButtonLabelOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,228,91);


(lib.HUBTeaCornerButtonLabelUp = function() {
	this.initialize(img.MainAssets_HUBTeaCornerButtonLabelUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,228,91);


(lib.KDExpansionPointer = function() {
	this.initialize(img.MainAssets_KDExpansionPointer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,24,47);


(lib.KeyDecAvailableBG = function() {
	this.initialize(img.MainAssets_KeyDecAvailableBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,660,809);


(lib.KeyDecButtonCompleted = function() {
	this.initialize(img.MainAssets_KeyDecButtonCompleted);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,48,49);


(lib.KeyDecButtonDown = function() {
	this.initialize(img.MainAssets_KeyDecButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,113,114);


(lib.KeyDecButtonHover = function() {
	this.initialize(img.MainAssets_KeyDecButtonHover);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,115);


(lib.KeyDecButtonLocked = function() {
	this.initialize(img.MainAssets_KeyDecButtonLocked);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,49,49);


(lib.KeyDecButtonUp = function() {
	this.initialize(img.MainAssets_KeyDecButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,113,109);


(lib.KeyDecDialogueDown = function() {
	this.initialize(img.MainAssets_KeyDecDialogueDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,99,99);


(lib.KeyDecDialogueOver = function() {
	this.initialize(img.MainAssets_KeyDecDialogueOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,116,116);


(lib.KeyDecDialogueUp = function() {
	this.initialize(img.MainAssets_KeyDecDialogueUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,109,108);


(lib.KeyDecDivider = function() {
	this.initialize(img.MainAssets_KeyDecDivider);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,40,13);


(lib.KeyDecDown = function() {
	this.initialize(img.MainAssets_KeyDecDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,120,121);


(lib.keyDecisionPlanComposer_AnswerContainer = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_AnswerContainer);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,920,846);


(lib.keyDecisionPlanComposer_AnswerDisabled = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_AnswerDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,832,161);


(lib.keyDecisionPlanComposer_AnswerDown = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_AnswerDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,877,169);


(lib.keyDecisionPlanComposer_AnswerOver = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_AnswerOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,832,161);


(lib.keyDecisionPlanComposer_AnswerPlaced = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_AnswerPlaced);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,807,136);


(lib.keyDecisionPlanComposer_AnswerPlacedOver = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_AnswerPlacedOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,807,136);


(lib.keyDecisionPlanComposer_AnswerUp = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_AnswerUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,832,161);


(lib.keyDecisionPlanComposer_ButtonDisabled = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_ButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,382,77);


(lib.keyDecisionPlanComposer_ButtonDown = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_ButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,382,77);


(lib.keyDecisionPlanComposer_ButtonOver = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_ButtonOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,382,77);


(lib.keyDecisionPlanComposer_ButtonUp = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_ButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,382,77);


(lib.keyDecisionPlanComposer_InputFieldActive = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_InputFieldActive);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,831,445);


(lib.keyDecisionPlanComposer_InputFieldInac = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_InputFieldInac);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,831,445);


(lib.keyDecisionPlanComposer_SubmitPlanIcon = function() {
	this.initialize(img.MainAssets_keyDecisionPlanComposer_SubmitPlanIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,44,44);


(lib.KeyDecLabel = function() {
	this.initialize(img.MainAssets_KeyDecLabel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,865,173);


(lib.LogoGOH = function() {
	this.initialize(img.MainAssets_LogoGOH);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,111,91);


(lib.LogoMoH = function() {
	this.initialize(img.MainAssets_LogoMoH);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,118);


(lib.LogoReady = function() {
	this.initialize(img.MainAssets_LogoReady);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,137,32);


(lib.MapBGConfirmationjpgcopy = function() {
	this.initialize(img.MainAssets_MapBGConfirmationjpgcopy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1921,1081);


(lib.MapInsetCh1 = function() {
	this.initialize(img.MainAssets_MapInsetCh1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,436,366);


(lib.MapInsetCh2 = function() {
	this.initialize(img.MainAssets_MapInsetCh2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,436,366);


(lib.MapNode = function() {
	this.initialize(img.MainAssets_MapNode);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,35,34);


(lib.MediumDown = function() {
	this.initialize(img.MainAssets_MediumDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.MediumOver = function() {
	this.initialize(img.MainAssets_MediumOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.MediumUp = function() {
	this.initialize(img.MainAssets_MediumUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.NewKDLabel = function() {
	this.initialize(img.MainAssets_NewKDLabel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,407,88);


(lib.NewKeyDecisionIndicator = function() {
	this.initialize(img.MainAssets_NewKeyDecisionIndicator);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,45);


(lib.NewTopicIcon = function() {
	this.initialize(img.MainAssets_NewTopicIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,55,36);


(lib.NodeColor07 = function() {
	this.initialize(img.MainAssets_NodeColor07);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,79,79);


(lib.NotificationBarEndpngcopy = function() {
	this.initialize(img.MainAssets_NotificationBarEndpngcopy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,570,104);


(lib.OptimalDown = function() {
	this.initialize(img.MainAssets_OptimalDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.OptimalOver = function() {
	this.initialize(img.MainAssets_OptimalOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.OptimalUp = function() {
	this.initialize(img.MainAssets_OptimalUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,95);


(lib.PieletjeBlack = function() {
	this.initialize(img.MainAssets_PieletjeBlack);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,60,47);


(lib.POI_NodeColor01 = function() {
	this.initialize(img.MainAssets_POI_NodeColor01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,79,79);


(lib.POI_NodeColor02 = function() {
	this.initialize(img.MainAssets_POI_NodeColor02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,79,79);


(lib.POI_NodeColor03 = function() {
	this.initialize(img.MainAssets_POI_NodeColor03);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,79,79);


(lib.POI_NodeColor04 = function() {
	this.initialize(img.MainAssets_POI_NodeColor04);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,79,79);


(lib.POI_NodeColor05 = function() {
	this.initialize(img.MainAssets_POI_NodeColor05);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,78,79);


(lib.POI_NodeColor06 = function() {
	this.initialize(img.MainAssets_POI_NodeColor06);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,79,79);


(lib.PoILabel0Over = function() {
	this.initialize(img.MainAssets_PoILabel0Over);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,138);


(lib.PoILabel0Up = function() {
	this.initialize(img.MainAssets_PoILabel0Up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,138);


(lib.PoILabel3Over = function() {
	this.initialize(img.MainAssets_PoILabel3Over);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,138);


(lib.PoILabel3Up = function() {
	this.initialize(img.MainAssets_PoILabel3Up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,138);


(lib.PoILTextLabelBGSmallWhite = function() {
	this.initialize(img.MainAssets_PoILTextLabelBGSmallWhite);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,355,70);


(lib.PoIPLocationDummy = function() {
	this.initialize(img.MainAssets_PoIPLocationDummy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,82,130);


(lib.PopUpBackButtonDisabled = function() {
	this.initialize(img.MainAssets_PopUpBackButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,238,66);


(lib.PopUpBackButtonOver = function() {
	this.initialize(img.MainAssets_PopUpBackButtonOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,238,66);


(lib.PopUpBackButtonUp = function() {
	this.initialize(img.MainAssets_PopUpBackButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,238,66);


(lib.PrintButtonDisabled = function() {
	this.initialize(img.MainAssets_PrintButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,32);


(lib.PrintButtonDown = function() {
	this.initialize(img.MainAssets_PrintButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,32);


(lib.PrintButtonUp = function() {
	this.initialize(img.MainAssets_PrintButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,119,32);


(lib.ShowOptimalDown = function() {
	this.initialize(img.MainAssets_ShowOptimalDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,409,66);


(lib.ShowOptimalOver = function() {
	this.initialize(img.MainAssets_ShowOptimalOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,410,66);


(lib.ShowOptimalUp = function() {
	this.initialize(img.MainAssets_ShowOptimalUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,409,66);


(lib.stakeholder_hasim = function() {
	this.initialize(img.MainAssets_stakeholder_hasim);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.stakeholder_hasim_disabled = function() {
	this.initialize(img.MainAssets_stakeholder_hasim_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.stakeholder_Nia = function() {
	this.initialize(img.MainAssets_stakeholder_Nia);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.stakeholder_nia_disabled = function() {
	this.initialize(img.MainAssets_stakeholder_nia_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.stakeholder_onneetse = function() {
	this.initialize(img.MainAssets_stakeholder_onneetse);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.stakeholder_onneetse_disabled = function() {
	this.initialize(img.MainAssets_stakeholder_onneetse_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.stakeholder_sarah = function() {
	this.initialize(img.MainAssets_stakeholder_sarah);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.stakeholder_sarah_disabled = function() {
	this.initialize(img.MainAssets_stakeholder_sarah_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,350,460);


(lib.StarOptimal = function() {
	this.initialize(img.MainAssets_StarOptimal);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,18,18);


(lib.StarPlayerChoiceEmpty = function() {
	this.initialize(img.MainAssets_StarPlayerChoiceEmpty);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,18,18);


(lib.StarPlayerChoiceFilled = function() {
	this.initialize(img.MainAssets_StarPlayerChoiceFilled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,18,18);


(lib.Tab1 = function() {
	this.initialize(img.MainAssets_Tab1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,389,83);


(lib.tab2 = function() {
	this.initialize(img.MainAssets_tab2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,389,65);


(lib.Tab2BGElement = function() {
	this.initialize(img.MainAssets_Tab2BGElement);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,689,659);


(lib.tab3 = function() {
	this.initialize(img.MainAssets_tab3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,389,65);


(lib.Tab3StaticImage = function() {
	this.initialize(img.MainAssets_Tab3StaticImage);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1501,669);


(lib.TeaCornerIcon = function() {
	this.initialize(img.MainAssets_TeaCornerIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,197,224);


(lib.TeaCornerIconDisabled = function() {
	this.initialize(img.MainAssets_TeaCornerIconDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,197,224);


(lib.TimelineBG = function() {
	this.initialize(img.MainAssets_TimelineBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,29,577);


(lib.TimerClock = function() {
	this.initialize(img.MainAssets_TimerClock);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,25,27);


(lib.timerKeyDecision_Neutral = function() {
	this.initialize(img.MainAssets_timerKeyDecision_Neutral);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,385,107);


(lib.timerKeyDecision_Urgent = function() {
	this.initialize(img.MainAssets_timerKeyDecision_Urgent);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,385,107);


(lib.TimingBG = function() {
	this.initialize(img.MainAssets_TimingBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,431,150);


(lib.TopBar = function() {
	this.initialize(img.MainAssets_TopBar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1923,202);


(lib.TopicButtonDisabled = function() {
	this.initialize(img.MainAssets_TopicButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,235,64);


(lib.TopicButtonDown = function() {
	this.initialize(img.MainAssets_TopicButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,235,64);


(lib.TopicButtonUp = function() {
	this.initialize(img.MainAssets_TopicButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,235,64);


(lib.TopLeftDisabled = function() {
	this.initialize(img.MainAssets_TopLeftDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,120,139);


(lib.TrendDownGreen = function() {
	this.initialize(img.MainAssets_TrendDownGreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,19,19);


(lib.TrendDownRed = function() {
	this.initialize(img.MainAssets_TrendDownRed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,19,19);


(lib.TrendUpGreen = function() {
	this.initialize(img.MainAssets_TrendUpGreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,19,19);


(lib.TrendUpRed = function() {
	this.initialize(img.MainAssets_TrendUpRed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,19,19);


(lib.ViewKDDisabled = function() {
	this.initialize(img.MainAssets_ViewKDDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,330,65);


(lib.ViewKDOver = function() {
	this.initialize(img.MainAssets_ViewKDOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,329,65);


(lib.ViewKDUp = function() {
	this.initialize(img.MainAssets_ViewKDUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,330,65);


(lib.Vinkje = function() {
	this.initialize(img.MainAssets_Vinkje);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,21,16);


(lib.VinkjeHi = function() {
	this.initialize(img.MainAssets_VinkjeHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,21,16);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Tween2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KeyDecButtonUp();
	this.instance.setTransform(-56.5,-54.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-56.5,-54.5,113,109);


(lib.TrendUpRed_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TrendUpRed();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TrendUpRed_1, new cjs.Rectangle(0,0,19,19), null);


(lib.TrendUpGreen_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TrendUpGreen();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TrendUpGreen_1, new cjs.Rectangle(0,0,19,19), null);


(lib.TrendDownGreen_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TrendDownGreen();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TrendDownGreen_1, new cjs.Rectangle(0,0,19,19), null);


(lib.TopBar_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TopBar();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TopBar_1, new cjs.Rectangle(0,0,1923,202), null);


(lib.ToolTipWhiteContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.toolTipTextField = new cjs.Text("Gather the paper line list data from CHWs on a weekly basis. If Teo collects them daily, he won’t be able to see any trends and properly prioritize areas. Compiling the data weekly will also make the overall workload more manageable.\nWaiting for a week to gather the paper line list data from CHWs can lead to a delay in identifying and addressing any emerging trends, which can result in a missed opportunity for early intervention.\nWaiting for a week to gather the paper line list data from CHWs can lead to a delay in identifying and addressing any emerging trends, which can result in a missed opportunity for early intervention. lead to a delay in identifying and addressing any emerging trends, which \nto a delay in identifying and addressing any emerging trends, which ", "20px 'Work Sans Medium'", "#324141");
	this.toolTipTextField.name = "toolTipTextField";
	this.toolTipTextField.lineHeight = 25;
	this.toolTipTextField.lineWidth = 700;
	this.toolTipTextField.parent = this;
	this.toolTipTextField.setTransform(22.8,16.2);
ranj.TextOffsetFixer.fix(this.toolTipTextField);

	this.instance = new lib.FeedbackToolTipWhiteScreen();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.toolTipTextField}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ToolTipWhiteContainer, new cjs.Rectangle(0,0,741,387.6), null);


(lib.ToolTipBlackContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.toolTipTextField = new cjs.Text("Gather the paper line list data from CHWs on a weekly basis. If Teo collects them daily, he won’t be able to see any trends and properly prioritize areas. Compiling the data weekly will also make the overall workload more manageable.\nWaiting for a week to gather the paper line list data from CHWs can lead to a delay in identifying and addressing any emerging trends, which can result in a missed opportunity for early intervention.", "20px 'Work Sans Medium'", "#FFFFFF");
	this.toolTipTextField.name = "toolTipTextField";
	this.toolTipTextField.lineHeight = 25;
	this.toolTipTextField.lineWidth = 603;
	this.toolTipTextField.parent = this;
	this.toolTipTextField.setTransform(64.35,48.3);
ranj.TextOffsetFixer.fix(this.toolTipTextField);

	this.instance = new lib.FeedbackToolTipBlackScreen();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.toolTipTextField}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ToolTipBlackContainer, new cjs.Rectangle(0,0,741,338), null);


(lib.TimingBG_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.WeekLabel = new cjs.Text("Week 2", "bold 51px 'Work Sans ExtraBold'", "#2C3C3C");
	this.WeekLabel.name = "WeekLabel";
	this.WeekLabel.lineHeight = 76;
	this.WeekLabel.lineWidth = 240;
	this.WeekLabel.parent = this;
	this.WeekLabel.setTransform(41.85,47.5);
ranj.TextOffsetFixer.fix(this.WeekLabel);

	this.ChapterLabel = new cjs.Text("Chapter 1", "22px 'Work Sans'", "#2C3C3C");
	this.ChapterLabel.name = "ChapterLabel";
	this.ChapterLabel.lineHeight = 28;
	this.ChapterLabel.lineWidth = 240;
	this.ChapterLabel.parent = this;
	this.ChapterLabel.setTransform(41.85,26.75);
ranj.TextOffsetFixer.fix(this.ChapterLabel);

	this.instance = new lib.TimingBG();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.ChapterLabel},{t:this.WeekLabel}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TimingBG_1, new cjs.Rectangle(0,0,431,150), null);


(lib.timerKeyDecision_Urgent_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.timerKeyDecision_Urgent();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.timerKeyDecision_Urgent_1, new cjs.Rectangle(0,0,385,107), null);


(lib.timerKeyDecision_Neutral_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.timerKeyDecision_Neutral();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.timerKeyDecision_Neutral_1, new cjs.Rectangle(0,0,385,107), null);


(lib.TabsBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#295B6D").s().p("Eh6FAD9IAAn5MD0LAAAIAAH5g");
	this.shape.setTransform(781.425,25.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TabsBar, new cjs.Rectangle(0,0,1562.9,50.7), null);


(lib.TabButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3,selecteUp:4,selectedOver:5,SelectedDown:6,SelectedDisabled:7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// SelectedUpLabelTextField
	this.selectedUpLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#1A3168");
	this.selectedUpLabelTextField.name = "selectedUpLabelTextField";
	this.selectedUpLabelTextField.lineHeight = 40;
	this.selectedUpLabelTextField.lineWidth = 391;
	this.selectedUpLabelTextField.parent = this;
	this.selectedUpLabelTextField.setTransform(34.45,3.05);
ranj.TextOffsetFixer.fix(this.selectedUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedUpLabelTextField).wait(8));

	// SelectedDisabledLabelTextField
	this.selectedDisabledLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#295B6D");
	this.selectedDisabledLabelTextField.name = "selectedDisabledLabelTextField";
	this.selectedDisabledLabelTextField.lineHeight = 40;
	this.selectedDisabledLabelTextField.lineWidth = 391;
	this.selectedDisabledLabelTextField.parent = this;
	this.selectedDisabledLabelTextField.setTransform(34.45,3.05);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField).wait(8));

	// SelectedDownLabelTextField
	this.selectedDownLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#5F9DB2");
	this.selectedDownLabelTextField.name = "selectedDownLabelTextField";
	this.selectedDownLabelTextField.lineHeight = 40;
	this.selectedDownLabelTextField.lineWidth = 391;
	this.selectedDownLabelTextField.parent = this;
	this.selectedDownLabelTextField.setTransform(34.45,3.05);
ranj.TextOffsetFixer.fix(this.selectedDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDownLabelTextField).wait(8));

	// SelectedOverLabelTextField
	this.selectedOverLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#5F9DB2");
	this.selectedOverLabelTextField.name = "selectedOverLabelTextField";
	this.selectedOverLabelTextField.lineHeight = 40;
	this.selectedOverLabelTextField.lineWidth = 391;
	this.selectedOverLabelTextField.parent = this;
	this.selectedOverLabelTextField.setTransform(34.45,3.05);
ranj.TextOffsetFixer.fix(this.selectedOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedOverLabelTextField).wait(8));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 40;
	this.upLabelTextField.lineWidth = 391;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(34.45,3.05);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(8));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#295B6D");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 40;
	this.disabledLabelTextField.lineWidth = 391;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(34.45,3.05);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(8));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#5F9DB2");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 40;
	this.downLabelTextField.lineWidth = 391;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(34.45,3.05);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(8));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "bold 32px 'Work Sans'", "#5F9DB2");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 40;
	this.overLabelTextField.lineWidth = 391;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(34.45,3.05);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(8));

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#295B6D").s().p("Egi8AD9IAAn5MBF4AAAIAAH5g");
	this.shape.setTransform(223.65,26.025);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#BFD7E0").s().p("Egi8AD9IAAn5MBF4AAAIAAH5g");
	this.shape_1.setTransform(223.65,26.025);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#EDF4F6").s().p("Egi8AEGIAAoLMBF4AAAIAAILg");
	this.shape_2.setTransform(223.65,26.725);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape}]},2).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0.6,447.3,52.3);


(lib.Tab3InformationSample2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.text = new cjs.Text("Tab3InformationSample2", "39px 'Times New Roman'", "#FF0000");
	this.text.lineHeight = 45;
	this.text.lineWidth = 428;
	this.text.parent = this;
	this.text.setTransform(299.7,297.65);
ranj.TextOffsetFixer.fix(this.text);

	this.instance = new lib.Tab3StaticImage();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.text}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Tab3InformationSample2, new cjs.Rectangle(0,0,1501,669), null);


(lib.Tab3InformationSample1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.text = new cjs.Text("Tab3InformationSample1", "39px 'Times New Roman'", "#FF0000");
	this.text.lineHeight = 45;
	this.text.lineWidth = 428;
	this.text.parent = this;
	this.text.setTransform(306.4,304.7);
ranj.TextOffsetFixer.fix(this.text);

	this.instance = new lib.Tab3StaticImage();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.text}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Tab3InformationSample1, new cjs.Rectangle(0,0,1501,669), null);


(lib.Tab3InformationImage = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Tab3StaticImage();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Tab3InformationImage, new cjs.Rectangle(0,0,1501,669), null);


(lib.PlanComposerKeyDecision_TabHover = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.tab2();
	this.instance.setTransform(0,-14);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_TabHover, new cjs.Rectangle(0,-14,389,65), null);


(lib.PlanComposerKeyDecision_SubmitIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_SubmitPlanIcon();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_SubmitIcon, new cjs.Rectangle(0,0,44,44), null);


(lib.PlanComposerKeyDecision_InactiveTab = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.tab3();
	this.instance.setTransform(0,-15);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_InactiveTab, new cjs.Rectangle(0,-15,389,65), null);


(lib.PlanComposerKeyDecision_ButtonUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_ButtonUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_ButtonUp, new cjs.Rectangle(0,0,382,77), null);


(lib.PlanComposerKeyDecision_ButtonOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_ButtonOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_ButtonOver, new cjs.Rectangle(0,0,382,77), null);


(lib.PlanComposerKeyDecision_ButtonDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_ButtonDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_ButtonDown, new cjs.Rectangle(0,0,382,77), null);


(lib.PlanComposerKeyDecision_ButtonDisabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_ButtonDisabled();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_ButtonDisabled, new cjs.Rectangle(0,0,382,77), null);


(lib.PlanComposerKeyDecision_AnsweSlot = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.AnswerSlot();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_AnsweSlot, new cjs.Rectangle(0,0,807,137), null);


(lib.PlanComposerKeyDecision_AnswerUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_AnswerUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_AnswerUp, new cjs.Rectangle(0,0,832,161), null);


(lib.PlanComposerKeyDecision_AnswerOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_AnswerOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_AnswerOver, new cjs.Rectangle(0,0,832,161), null);


(lib.PlanComposerKeyDecision_AnswerLocked = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_AnswerDisabled();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_AnswerLocked, new cjs.Rectangle(0,0,832,161), null);


(lib.PlanComposerKeyDecision_AnswerDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_AnswerDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_AnswerDown, new cjs.Rectangle(0,0,877,169), null);


(lib.PlanComposerKeyDecision_AnswerContainerInactive = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// InputfieldStates
	this.instance = new lib.keyDecisionPlanComposer_InputFieldInac();

	this.instance_1 = new lib.keyDecisionPlanComposer_InputFieldActive();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,831,445);


(lib.PlanComposerKeyDecision_AnswerBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_AnswerContainer();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_AnswerBackground, new cjs.Rectangle(0,0,920,846), null);


(lib.PlanComposerKeyDecision_ActiveTab = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Tab1();
	this.instance.setTransform(0,-14);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_ActiveTab, new cjs.Rectangle(0,-14,389,83), null);


(lib.NodeColor06 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.POI_NodeColor06();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NodeColor06, new cjs.Rectangle(0,0,79,79), null);


(lib.NodeColor05 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.POI_NodeColor05();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NodeColor05, new cjs.Rectangle(0,0,78,79), null);


(lib.NodeColor04 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.POI_NodeColor04();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NodeColor04, new cjs.Rectangle(0,0,79,79), null);


(lib.NodeColor03 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.POI_NodeColor03();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NodeColor03, new cjs.Rectangle(0,0,79,79), null);


(lib.NodeColor02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.POI_NodeColor02();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NodeColor02, new cjs.Rectangle(0,0,79,79), null);


(lib.NodeColor01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.POI_NodeColor01();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NodeColor01, new cjs.Rectangle(0,0,79,79), null);


(lib.newKeyDecIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.NewKeyDecisionIndicator();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.newKeyDecIcon, new cjs.Rectangle(0,0,50,45), null);


(lib.NewKDLabel_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.KDUnlockedText = new cjs.Text("Key decision unlocked!", "24px 'Work Sans Medium'", "#324141");
	this.KDUnlockedText.name = "KDUnlockedText";
	this.KDUnlockedText.lineHeight = 26;
	this.KDUnlockedText.lineWidth = 281;
	this.KDUnlockedText.parent = this;
	this.KDUnlockedText.setTransform(34.4,16.65);
ranj.TextOffsetFixer.fix(this.KDUnlockedText);

	this.instance = new lib.NewKDLabel();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.KDUnlockedText}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NewKDLabel_1, new cjs.Rectangle(0,0,407,88), null);


(lib.MapNodeSmall = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(107,71,49,0.6)").s().p("AhHBIQgegeAAgqQAAgqAegdQAdgeAqAAQAqAAAeAeQAeAdAAAqQAAAqgeAeQgeAegqAAQgqAAgdgeg");
	this.shape.setTransform(10.2,10.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MapNodeSmall, new cjs.Rectangle(0,0,20.4,20.4), null);


(lib.mapInsetChapter2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.text = new cjs.Text("Murelle", "bold 24px 'Work Sans ExtraBold'", "#324141");
	this.text.lineHeight = 37;
	this.text.lineWidth = 101;
	this.text.parent = this;
	this.text.setTransform(121.4,70.05);
ranj.TextOffsetFixer.fix(this.text);

	this.text_1 = new cjs.Text("Myro", "bold 24px 'Work Sans ExtraBold'", "#324141");
	this.text_1.lineHeight = 37;
	this.text_1.lineWidth = 71;
	this.text_1.parent = this;
	this.text_1.setTransform(270.25,157.45);
ranj.TextOffsetFixer.fix(this.text_1);

	this.text_2 = new cjs.Text("THISLAND", "34px 'Work Sans Light'", "#324141");
	this.text_2.lineHeight = 42;
	this.text_2.lineWidth = 182;
	this.text_2.parent = this;
	this.text_2.setTransform(106.65,210.65);
ranj.TextOffsetFixer.fix(this.text_2);

	this.instance = new lib.MapInsetCh2();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.text_2},{t:this.text_1},{t:this.text}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mapInsetChapter2, new cjs.Rectangle(0,0,436,366), null);


(lib.mapInsetChapter1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.text = new cjs.Text("Murelle", "bold 24px 'Work Sans ExtraBold'", "#324141");
	this.text.lineHeight = 37;
	this.text.lineWidth = 101;
	this.text.parent = this;
	this.text.setTransform(121.4,70.05);
ranj.TextOffsetFixer.fix(this.text);

	this.text_1 = new cjs.Text("Myro", "bold 24px 'Work Sans ExtraBold'", "#324141");
	this.text_1.lineHeight = 37;
	this.text_1.lineWidth = 71;
	this.text_1.parent = this;
	this.text_1.setTransform(270.25,157.45);
ranj.TextOffsetFixer.fix(this.text_1);

	this.text_2 = new cjs.Text("THISLAND", "34px 'Work Sans Light'", "#324141");
	this.text_2.lineHeight = 42;
	this.text_2.lineWidth = 182;
	this.text_2.parent = this;
	this.text_2.setTransform(106.65,210.65);
ranj.TextOffsetFixer.fix(this.text_2);

	this.instance = new lib.MapInsetCh1();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.text_2},{t:this.text_1},{t:this.text}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.mapInsetChapter1, new cjs.Rectangle(0,0,436,366), null);


(lib.locationContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.PoIPLocationDummy();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.locationContainer, new cjs.Rectangle(0,0,82,130), null);


(lib.KeyDecPopUpBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KeyDecAvailableBG();
	this.instance.setTransform(-552,-351);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecPopUpBG, new cjs.Rectangle(-552,-351,660,809), null);


(lib.KeyDecLabel_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.descriptionTextField = new cjs.Text("Make sure you have collected all the information you need before making a decision.", "21px 'Work Sans Medium'", "#2C3C3C");
	this.descriptionTextField.name = "descriptionTextField";
	this.descriptionTextField.lineHeight = 19;
	this.descriptionTextField.lineWidth = 615;
	this.descriptionTextField.parent = this;
	this.descriptionTextField.setTransform(180.05,59.6);
ranj.TextOffsetFixer.fix(this.descriptionTextField);

	this.titleTextField = new cjs.Text("Key decision", "bold 42px 'Work Sans ExtraBold'", "#2C3C3C");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.lineHeight = 63;
	this.titleTextField.lineWidth = 512;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(180.05,2);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.instance = new lib.KeyDecLabel();
	this.instance.setTransform(0,-5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.titleTextField},{t:this.descriptionTextField}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecLabel_1, new cjs.Rectangle(0,-5,865,173), null);


(lib.keyDecisionPlanComposer_AnswerSelectedUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_AnswerPlaced();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.keyDecisionPlanComposer_AnswerSelectedUp, new cjs.Rectangle(0,0,807,136), null);


(lib.keyDecisionPlanComposer_AnswerSelectedOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.keyDecisionPlanComposer_AnswerPlacedOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.keyDecisionPlanComposer_AnswerSelectedOver, new cjs.Rectangle(0,0,807,136), null);


(lib.KeyDecDivider_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KeyDecDivider();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecDivider_1, new cjs.Rectangle(0,0,40,13), null);


(lib.KeyDecButtonLocked_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KeyDecButtonLocked();
	this.instance.setTransform(5,4);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecButtonLocked_1, new cjs.Rectangle(5,4,49,49), null);


(lib.KeyDecButtonCompleted_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KeyDecButtonCompleted();
	this.instance.setTransform(6,5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecButtonCompleted_1, new cjs.Rectangle(6,5,48,49), null);


(lib.KeyDecActiveBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#324141").s().p("AhPJtIAAzZICfAAIAATZg");
	this.shape.setTransform(8,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecActiveBar, new cjs.Rectangle(0,5.1,16,124.20000000000002), null);


(lib.KDPopUpPointer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KDExpansionPointer();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KDPopUpPointer, new cjs.Rectangle(0,0,24,47), null);


(lib.KDContinueUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ViewKDUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KDContinueUp, new cjs.Rectangle(0,0,330,65), null);


(lib.KDContinueOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ViewKDOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KDContinueOver, new cjs.Rectangle(0,0,329,65), null);


(lib.KDContinueDisabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ViewKDDisabled();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KDContinueDisabled, new cjs.Rectangle(0,0,330,65), null);


(lib.KDconfirmationIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CompletedKDConfirmationScreen();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KDconfirmationIcon, new cjs.Rectangle(0,0,141,140), null);


(lib.GraphTitleLabel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.DashboardGraphLabel();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GraphTitleLabel, new cjs.Rectangle(0,0,340,41), null);


(lib.Graph = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.FeedbackTimelineInfoBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.actionNeededTextField2 = new cjs.Text("[Action that is needed]\n[Action that is needed]\n[Action that is needed]", "18px 'Open Sans'");
	this.actionNeededTextField2.name = "actionNeededTextField2";
	this.actionNeededTextField2.lineHeight = 21;
	this.actionNeededTextField2.lineWidth = 401;
	this.actionNeededTextField2.parent = this;
	this.actionNeededTextField2.setTransform(50.85,8.45);
ranj.TextOffsetFixer.fix(this.actionNeededTextField2);

	this.instance = new lib.FeedbackKDInfoExpansion();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.actionNeededTextField2}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTimelineInfoBar, new cjs.Rectangle(0,0,508,96), null);


(lib.FeedbackTimelineDivider = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackSmallBar();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTimelineDivider, new cjs.Rectangle(0,0,51,14), null);


(lib.FeedbackTimelineBlackBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackBlackBar();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTimelineBlackBar, new cjs.Rectangle(0,0,22,174), null);


(lib.FeedbackTimelineBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackLongBar();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTimelineBG, new cjs.Rectangle(0,0,21,1080), null);


(lib.FeedbackStarOptimal = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.StarOptimal();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackStarOptimal, new cjs.Rectangle(0,0,18,18), null);


(lib.FeedbackStarFilled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.StarPlayerChoiceFilled();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackStarFilled, new cjs.Rectangle(0,0,18,18), null);


(lib.FeedbackStarEmpty = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.StarPlayerChoiceEmpty();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackStarEmpty, new cjs.Rectangle(0,0,18,18), null);


(lib.FeedbackPointerWhite = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPointer();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPointerWhite, new cjs.Rectangle(0,0,25,48), null);


(lib.FeedbackPointer_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackBGpointer();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPointer_1, new cjs.Rectangle(0,0,43,96), null);


(lib.FeedbackPlayerChoiceUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.HideOptimalUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPlayerChoiceUp, new cjs.Rectangle(0,0,409,66), null);


(lib.FeedbackPlayerChoiceTooltip = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#324141").ss(5,0,1).p("AEZh7IjgDAIg5AxIg/g2IjZi6");
	this.shape.setTransform(29.3267,20.3276);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer_3
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("Ag+BZIjojmIJNgCIjuDtIg5Axg");
	this.shape_1.setTransform(29.3,17.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPlayerChoiceTooltip, new cjs.Rectangle(-1.3,3.5,61.3,31.200000000000003), null);


(lib.FeedbackPlayerChoiceOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.HideOptimalOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPlayerChoiceOver, new cjs.Rectangle(0,0,410,66), null);


(lib.FeedbackPlayerChoiceDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.HideOptimalDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPlayerChoiceDown, new cjs.Rectangle(0,0,409,66), null);


(lib.FeedbackOptimalUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ShowOptimalUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalUp, new cjs.Rectangle(0,0,409,66), null);


(lib.FeedbackOptimalTooltip = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.PieletjeBlack();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalTooltip, new cjs.Rectangle(0,0,60,47), null);


(lib.FeedbackOptimalOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ShowOptimalOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalOver, new cjs.Rectangle(0,0,410,66), null);


(lib.FeedbackOptimalDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ShowOptimalDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalDown, new cjs.Rectangle(0,0,409,66), null);


(lib.FeedbackOptimalAnswerUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.OptimalUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalAnswerUp, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackOptimalAnswerOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.OptimalOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalAnswerOver, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackOptimalAnswerDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.OptimalDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalAnswerDown, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackMediumUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.MediumUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackMediumUp, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackMediumOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.MediumOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackMediumOver, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackMediumDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.MediumDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackMediumDown, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackKDInactiveButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackInactiveKD();
	this.instance.setTransform(6,4);

	this.instance_1 = new lib.FeedbackInactiveKDOver();
	this.instance_1.setTransform(5,4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(5,4,49,49);


(lib.FeedbackInactiveKD_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackKDSmall();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackInactiveKD_1, new cjs.Rectangle(0,0,77,77), null);


(lib.FeedbackIcon_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackIcon();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackIcon_1, new cjs.Rectangle(0,0,54,42), null);


(lib.FeedbackGoodUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.GoodUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackGoodUp, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackGoodOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.GoodOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackGoodOver, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackGoodDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.GoodDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackGoodDown, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackExpandPlayerChoice = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ExpandPlayerChoice();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackExpandPlayerChoice, new cjs.Rectangle(0,0,23,25), null);


(lib.FeedbackExpandOptimal = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ExpandOptimal();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackExpandOptimal, new cjs.Rectangle(0,0,23,25), null);


(lib.FeedbackDividerWhiteScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(50,65,65,0.498)").ss(1,1,1).p("Eh+bAAAMD83AAA");
	this.shape.setTransform(809.175,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackDividerWhiteScreen, new cjs.Rectangle(-1,-1,1620.4,2), null);


(lib.FeedbackDividerBlackScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(255,255,255,0.498)").ss(1,1,1).p("Eh+bAAAMD83AAA");
	this.shape.setTransform(809.175,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackDividerBlackScreen, new cjs.Rectangle(-1,-1,1620.4,2), null);


(lib.FeedbackBadUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BadUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackBadUp, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackBadOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BadOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackBadOver, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackBadDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BadDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackBadDown, new cjs.Rectangle(0,0,586,95), null);


(lib.FeedbackAnswerBGWhite = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#F4F4F4").s().p("EiG4Aw8MAAAhh3MENwAAAMAAABh3g");
	this.shape.setTransform(864.0008,273.5004,1.0009,0.8732);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackAnswerBGWhite, new cjs.Rectangle(0,0,1728,547), null);


(lib.FeedbackAnswerBGBlack = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#2C3C3C").s().p("EiG4Aw8MAAAhh3MENwAAAMAAABh3g");
	this.shape.setTransform(864.0008,273.5004,1.0009,0.8732);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackAnswerBGBlack, new cjs.Rectangle(0,0,1728,547), null);


(lib.FeedbackActiveKDPlayerChoice = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackKDPlayerChoice();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackActiveKDPlayerChoice, new cjs.Rectangle(0,0,279,147), null);


(lib.FeedbackActiveKDOptimal = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackKDOptimal();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackActiveKDOptimal, new cjs.Rectangle(0,0,279,147), null);


(lib.DashboardLogoReady = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.LogoReady();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DashboardLogoReady, new cjs.Rectangle(0,0,137,32), null);


(lib.DashboardLogoGHO = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.LogoGOH();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DashboardLogoGHO, new cjs.Rectangle(0,0,111,91), null);


(lib.DashboardBG_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.DashboardBG();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DashboardBG_1, new cjs.Rectangle(0,0,1603,903), null);


(lib.CharacterPlaceholder = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1109,1081);


(lib.ChapterContentContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BriefingBodybackground();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChapterContentContainer, new cjs.Rectangle(0,0,1268,867), null);


(lib.BriefingTimelineSmallBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BriefingTimelineBars();
	this.instance.setTransform(34,23);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BriefingTimelineSmallBar, new cjs.Rectangle(34,23,87,27), null);


(lib.BriefingTimelineBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BriefingBlackBar();
	this.instance.setTransform(0,-133);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BriefingTimelineBar, new cjs.Rectangle(0,-133,37,852), null);


(lib.BriefingTimelineBackground_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BriefingTimelineBackground();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BriefingTimelineBackground_1, new cjs.Rectangle(0,0,72,1122), null);


(lib.BriefingTimeline = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BriefingTimeLine();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BriefingTimeline, new cjs.Rectangle(0,0,189,1156), null);


(lib.BottomBar_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BottomBar();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BottomBar_1, new cjs.Rectangle(0,0,1923,179), null);


(lib.BackUp_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BackUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BackUp_1, new cjs.Rectangle(0,0,201,62), null);


(lib.BackOver_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BackOver();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BackOver_1, new cjs.Rectangle(0,0,201,62), null);


(lib.BackDisabled_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BackDisabled();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BackDisabled_1, new cjs.Rectangle(0,0,201,62), null);


(lib.Timer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// TExt
	this.secondsSingleTimerTextField = new cjs.Text("0", "30px 'Arial'", "#FFFFFF");
	this.secondsSingleTimerTextField.name = "secondsSingleTimerTextField";
	this.secondsSingleTimerTextField.textAlign = "center";
	this.secondsSingleTimerTextField.lineHeight = 36;
	this.secondsSingleTimerTextField.lineWidth = 17;
	this.secondsSingleTimerTextField.parent = this;
	this.secondsSingleTimerTextField.setTransform(136.35,6);
ranj.TextOffsetFixer.fix(this.secondsSingleTimerTextField);

	this.secondsDoubleTimerTextField = new cjs.Text("0", "30px 'Arial'", "#FFFFFF");
	this.secondsDoubleTimerTextField.name = "secondsDoubleTimerTextField";
	this.secondsDoubleTimerTextField.textAlign = "center";
	this.secondsDoubleTimerTextField.lineHeight = 36;
	this.secondsDoubleTimerTextField.lineWidth = 17;
	this.secondsDoubleTimerTextField.parent = this;
	this.secondsDoubleTimerTextField.setTransform(115.35,6);
ranj.TextOffsetFixer.fix(this.secondsDoubleTimerTextField);

	this.minutesSingleTimerTextField = new cjs.Text("0", "30px 'Arial'", "#FFFFFF");
	this.minutesSingleTimerTextField.name = "minutesSingleTimerTextField";
	this.minutesSingleTimerTextField.textAlign = "center";
	this.minutesSingleTimerTextField.lineHeight = 36;
	this.minutesSingleTimerTextField.lineWidth = 17;
	this.minutesSingleTimerTextField.parent = this;
	this.minutesSingleTimerTextField.setTransform(84.35,6);
ranj.TextOffsetFixer.fix(this.minutesSingleTimerTextField);

	this.minutesDoubleTimerTextField = new cjs.Text("0", "30px 'Arial'", "#FFFFFF");
	this.minutesDoubleTimerTextField.name = "minutesDoubleTimerTextField";
	this.minutesDoubleTimerTextField.textAlign = "center";
	this.minutesDoubleTimerTextField.lineHeight = 36;
	this.minutesDoubleTimerTextField.lineWidth = 17;
	this.minutesDoubleTimerTextField.parent = this;
	this.minutesDoubleTimerTextField.setTransform(62.35,6);
ranj.TextOffsetFixer.fix(this.minutesDoubleTimerTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.minutesDoubleTimerTextField},{t:this.minutesSingleTimerTextField},{t:this.secondsDoubleTimerTextField},{t:this.secondsSingleTimerTextField}]}).wait(1));

	// Layer_4
	this.text = new cjs.Text(":", "20px 'Arial'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 24;
	this.text.lineWidth = 100;
	this.text.parent = this;
	this.text.setTransform(99,12);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	// Clock
	this.instance = new lib.TimerClock();
	this.instance.setTransform(12,10);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Timer, new cjs.Rectangle(0,0,158,48), null);


(lib.continueButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "18px 'Arial'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 20;
	this.disabledLabelTextField.lineWidth = 91;
	this.disabledLabelTextField.alpha = 0.29803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(47.5,2);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "18px 'Arial'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 20;
	this.downLabelTextField.lineWidth = 91;
	this.downLabelTextField.alpha = 0.29803922;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(47.5,2);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "18px 'Arial'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 20;
	this.overLabelTextField.lineWidth = 91;
	this.overLabelTextField.alpha = 0.29803922;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(47.5,2);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "18px 'Arial'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 20;
	this.upLabelTextField.lineWidth = 91;
	this.upLabelTextField.alpha = 0.29803922;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(47.5,2);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_1
	this.instance = new lib.PrintButtonUp();
	this.instance.setTransform(0,0,0.8,0.8);

	this.instance_1 = new lib.PrintButtonDown();
	this.instance_1.setTransform(0,0,0.8,0.8);

	this.instance_2 = new lib.PrintButtonDisabled();
	this.instance_2.setTransform(0,0,0.8,0.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// cloudstripe
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.4)").s().p("AgECHIAAkNIAJAAIAAENg");
	this.shape.setTransform(-73.525,17.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(4));

	// cloud
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.6)").s().p("AzSCHIAAkNMAmlAAAIAAENg");
	this.shape_1.setTransform(50.475,17.5);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-74,0,248,32);


(lib.PopupOverlayBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiV/hUXMEr/AAAMAAACovMkr/AAAg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(0,0,0,0.749)").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PopupOverlayBackground, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.KDBackButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Back", "28px 'Work Sans'", "#2C3C3C");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 202;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Back", "28px 'Work Sans'", "#2C3C3C");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 202;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Back", "28px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 202;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Back", "28px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 202;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.PopUpBackButtonUp();
	this.instance.setTransform(-155,-32);

	this.instance_1 = new lib.PopUpBackButtonOver();
	this.instance_1.setTransform(-155,-32);

	this.instance_2 = new lib.PopUpBackButtonDisabled();
	this.instance_2.setTransform(-155,-32);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-155,-32,238,66);


(lib.FeedbackPreviousButtonWhiteScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Previous", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "right";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(135.4,-22.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Previous", "28px 'Work Sans'", "#EEEAE5");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "right";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(135.4,-22.65);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Previous", "28px 'Work Sans'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "right";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(135.4,-22.65);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Previous", "28px 'Work Sans'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "right";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(135.4,-22.65);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.ContinueButtonUp();
	this.instance.setTransform(154,-32,1,1,0,0,180);

	this.instance_1 = new lib.ButtonOverWhite();
	this.instance_1.setTransform(153,-31,1,1,0,0,180);

	this.instance_2 = new lib.ContinueButtonDisabled();
	this.instance_2.setTransform(154,-32,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-155,-32,309,63);


(lib.FeedbackPreviousButtonBlackScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "right";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(135.4,-22.65);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#EEEAE5");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "right";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(135.4,-22.65);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "right";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(135.4,-22.65);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "right";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(135.4,-22.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// bg
	this.instance = new lib.ContinueButtonHi();
	this.instance.setTransform(154,-32,1,1,0,0,180);

	this.instance_1 = new lib.ContinueButtonUp();
	this.instance_1.setTransform(154,-32,1,1,0,0,180);

	this.instance_2 = new lib.ContinueButtonDisabled();
	this.instance_2.setTransform(154,-32,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-155,-32,309,63);


(lib.FeedbackNextButtonWhiteScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Next", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Next", "28px 'Work Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Next", "28px 'Work Sans'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Next", "28px 'Work Sans'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.ContinueButtonUp();
	this.instance.setTransform(-154.5,-31.5);

	this.instance_1 = new lib.ButtonOverWhitepngcopy();
	this.instance_1.setTransform(-155,-32);

	this.instance_2 = new lib.ContinueButtonDisabled();
	this.instance_2.setTransform(-154.5,-31.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-155,-32,309.5,63.5);


(lib.FeedbackNextButtonBlackScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#EEEAE5");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// bg
	this.instance = new lib.ContinueButtonHi();
	this.instance.setTransform(-154.5,-31.5);

	this.instance_1 = new lib.ContinueButtonUp();
	this.instance_1.setTransform(-154.5,-31.5);

	this.instance_2 = new lib.ContinueButtonDisabled();
	this.instance_2.setTransform(-154.5,-31.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-154.5,-31.5,309,63);


(lib.EmptySquare = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.012)").s().p("AjbDcIAAm3IG3AAIAAG3g");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmptySquare, new cjs.Rectangle(-22,-22,44,44), null);


(lib.ContinueButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#EEEAE5");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.ContinueButtonUp();
	this.instance.setTransform(-154.5,-31.5);

	this.instance_1 = new lib.ButtonOverWhite();
	this.instance_1.setTransform(-153,-31);

	this.instance_2 = new lib.ContinueButtonDisabled();
	this.instance_2.setTransform(-154.5,-31.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-154.5,-31.5,309,63);


(lib.CloseButtonBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CloseButtonIcon();
	this.instance.setTransform(-8.5,-8.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CloseButtonBase, new cjs.Rectangle(-8.5,-8.5,17,17), null);


(lib.EmptyContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.PlaceholderBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiV/hUXMEr/AAAMAAACovMkr/AAAg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#CCCCCC").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlaceholderBackground, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.LoadingBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiV/hUXMEr/AAAMAAACovMkr/AAAg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#CCCCCC").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingBackground, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.InternalStakeholder4Button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// positionDisabledLabelTextField
	this.positionDisabledLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#BBD2D7");
	this.positionDisabledLabelTextField.name = "positionDisabledLabelTextField";
	this.positionDisabledLabelTextField.textAlign = "center";
	this.positionDisabledLabelTextField.lineHeight = 12;
	this.positionDisabledLabelTextField.lineWidth = 152;
	this.positionDisabledLabelTextField.parent = this;
	this.positionDisabledLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDisabledLabelTextField).wait(4));

	// positionDownLabelTextField
	this.positionDownLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionDownLabelTextField.name = "positionDownLabelTextField";
	this.positionDownLabelTextField.textAlign = "center";
	this.positionDownLabelTextField.lineHeight = 12;
	this.positionDownLabelTextField.lineWidth = 152;
	this.positionDownLabelTextField.parent = this;
	this.positionDownLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDownLabelTextField).wait(4));

	// positionOverLabelTextField
	this.positionOverLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionOverLabelTextField.name = "positionOverLabelTextField";
	this.positionOverLabelTextField.textAlign = "center";
	this.positionOverLabelTextField.lineHeight = 12;
	this.positionOverLabelTextField.lineWidth = 152;
	this.positionOverLabelTextField.parent = this;
	this.positionOverLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionOverLabelTextField).wait(4));

	// positionUpLabelTextField
	this.positionUpLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#FFFFFF");
	this.positionUpLabelTextField.name = "positionUpLabelTextField";
	this.positionUpLabelTextField.textAlign = "center";
	this.positionUpLabelTextField.lineHeight = 12;
	this.positionUpLabelTextField.lineWidth = 152;
	this.positionUpLabelTextField.parent = this;
	this.positionUpLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionUpLabelTextField).wait(4));

	// nameDisabledLabelTextField
	this.nameDisabledLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#BBD2D7");
	this.nameDisabledLabelTextField.name = "nameDisabledLabelTextField";
	this.nameDisabledLabelTextField.textAlign = "center";
	this.nameDisabledLabelTextField.lineHeight = 27;
	this.nameDisabledLabelTextField.lineWidth = 152;
	this.nameDisabledLabelTextField.parent = this;
	this.nameDisabledLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDisabledLabelTextField).wait(4));

	// nameDownLabelTextField
	this.nameDownLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameDownLabelTextField.name = "nameDownLabelTextField";
	this.nameDownLabelTextField.textAlign = "center";
	this.nameDownLabelTextField.lineHeight = 27;
	this.nameDownLabelTextField.lineWidth = 152;
	this.nameDownLabelTextField.parent = this;
	this.nameDownLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDownLabelTextField).wait(4));

	// nameOverLabelTextField
	this.nameOverLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameOverLabelTextField.name = "nameOverLabelTextField";
	this.nameOverLabelTextField.textAlign = "center";
	this.nameOverLabelTextField.lineHeight = 27;
	this.nameOverLabelTextField.lineWidth = 152;
	this.nameOverLabelTextField.parent = this;
	this.nameOverLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameOverLabelTextField).wait(4));

	// nameUpLabelTextField
	this.nameUpLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#FFFFFF");
	this.nameUpLabelTextField.name = "nameUpLabelTextField";
	this.nameUpLabelTextField.textAlign = "center";
	this.nameUpLabelTextField.lineHeight = 27;
	this.nameUpLabelTextField.lineWidth = 152;
	this.nameUpLabelTextField.parent = this;
	this.nameUpLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameUpLabelTextField).wait(4));

	// Layer_3
	this.instance = new lib.HUBStakeholderButtonLabelUp();
	this.instance.setTransform(-86,-55);

	this.instance_1 = new lib.HUBStakeholderButtonLabelOver();
	this.instance_1.setTransform(-86,-55);

	this.instance_2 = new lib.HUBStakeholderButtonLabelDisabled();
	this.instance_2.setTransform(-87,-56);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// Layer_5 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AhDOTIpYpZQgdgcAAgnIAArbQAAgoAdgcIJYpZQAcgcAnAAQAoAAAcAcIJYJZQAdAcAAAoIAALbQAAAngdAcIpYJZQgcAcgoAAQgnAAgcgcg");
	mask.setTransform(0.0676,-118.225);

	// Layer_4
	this.instance_3 = new lib.stakeholder_onneetse();
	this.instance_3.setTransform(-81,-231,0.4594,0.4594);

	this.instance_4 = new lib.stakeholder_onneetse_disabled();
	this.instance_4.setTransform(-81,-231,0.4594,0.4594);

	var maskedShapeInstanceList = [this.instance_3,this.instance_4];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3,p:{y:-231}}]}).to({state:[{t:this.instance_3,p:{y:-238}}]},1).to({state:[{t:this.instance_4}]},2).wait(1));

	// Layer_2
	this.instance_5 = new lib.HUBStakeholderButtonBGUp();
	this.instance_5.setTransform(-81,-172);

	this.instance_6 = new lib.HUBStakeholderButtonBGDisabled();
	this.instance_6.setTransform(-81,-172);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5}]}).to({state:[{t:this.instance_6}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-87,-236.4,177,255.3);


(lib.InternalStakeholder3Button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// positionDisabledLabelTextField
	this.positionDisabledLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#BBD2D7");
	this.positionDisabledLabelTextField.name = "positionDisabledLabelTextField";
	this.positionDisabledLabelTextField.textAlign = "center";
	this.positionDisabledLabelTextField.lineHeight = 12;
	this.positionDisabledLabelTextField.lineWidth = 152;
	this.positionDisabledLabelTextField.parent = this;
	this.positionDisabledLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDisabledLabelTextField).wait(4));

	// positionDownLabelTextField
	this.positionDownLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionDownLabelTextField.name = "positionDownLabelTextField";
	this.positionDownLabelTextField.textAlign = "center";
	this.positionDownLabelTextField.lineHeight = 12;
	this.positionDownLabelTextField.lineWidth = 152;
	this.positionDownLabelTextField.parent = this;
	this.positionDownLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDownLabelTextField).wait(4));

	// positionOverLabelTextField
	this.positionOverLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionOverLabelTextField.name = "positionOverLabelTextField";
	this.positionOverLabelTextField.textAlign = "center";
	this.positionOverLabelTextField.lineHeight = 12;
	this.positionOverLabelTextField.lineWidth = 152;
	this.positionOverLabelTextField.parent = this;
	this.positionOverLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionOverLabelTextField).wait(4));

	// positionUpLabelTextField
	this.positionUpLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#FFFFFF");
	this.positionUpLabelTextField.name = "positionUpLabelTextField";
	this.positionUpLabelTextField.textAlign = "center";
	this.positionUpLabelTextField.lineHeight = 12;
	this.positionUpLabelTextField.lineWidth = 152;
	this.positionUpLabelTextField.parent = this;
	this.positionUpLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionUpLabelTextField).wait(4));

	// nameDisabledLabelTextField
	this.nameDisabledLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#BBD2D7");
	this.nameDisabledLabelTextField.name = "nameDisabledLabelTextField";
	this.nameDisabledLabelTextField.textAlign = "center";
	this.nameDisabledLabelTextField.lineHeight = 27;
	this.nameDisabledLabelTextField.lineWidth = 152;
	this.nameDisabledLabelTextField.parent = this;
	this.nameDisabledLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDisabledLabelTextField).wait(4));

	// nameDownLabelTextField
	this.nameDownLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameDownLabelTextField.name = "nameDownLabelTextField";
	this.nameDownLabelTextField.textAlign = "center";
	this.nameDownLabelTextField.lineHeight = 27;
	this.nameDownLabelTextField.lineWidth = 152;
	this.nameDownLabelTextField.parent = this;
	this.nameDownLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDownLabelTextField).wait(4));

	// nameOverLabelTextField
	this.nameOverLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameOverLabelTextField.name = "nameOverLabelTextField";
	this.nameOverLabelTextField.textAlign = "center";
	this.nameOverLabelTextField.lineHeight = 27;
	this.nameOverLabelTextField.lineWidth = 152;
	this.nameOverLabelTextField.parent = this;
	this.nameOverLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameOverLabelTextField).wait(4));

	// nameUpLabelTextField
	this.nameUpLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#FFFFFF");
	this.nameUpLabelTextField.name = "nameUpLabelTextField";
	this.nameUpLabelTextField.textAlign = "center";
	this.nameUpLabelTextField.lineHeight = 27;
	this.nameUpLabelTextField.lineWidth = 152;
	this.nameUpLabelTextField.parent = this;
	this.nameUpLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameUpLabelTextField).wait(4));

	// Layer_3
	this.instance = new lib.HUBStakeholderButtonLabelUp();
	this.instance.setTransform(-86,-55);

	this.instance_1 = new lib.HUBStakeholderButtonLabelOver();
	this.instance_1.setTransform(-86,-55);

	this.instance_2 = new lib.HUBStakeholderButtonLabelDisabled();
	this.instance_2.setTransform(-87,-56);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// Layer_5 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AhDOTIpYpZQgdgcAAgnIAArbQAAgoAdgcIJYpZQAcgcAnAAQAoAAAcAcIJYJZQAdAcAAAoIAALbQAAAngdAcIpYJZQgcAcgoAAQgnAAgcgcg");
	mask.setTransform(0.0676,-118.225);

	// Layer_4
	this.instance_3 = new lib.stakeholder_hasim();
	this.instance_3.setTransform(-72,-222,0.4313,0.4313);

	this.instance_4 = new lib.stakeholder_hasim_disabled();
	this.instance_4.setTransform(-72,-222,0.4313,0.4313);

	var maskedShapeInstanceList = [this.instance_3,this.instance_4];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3,p:{y:-222}}]}).to({state:[{t:this.instance_3,p:{y:-228}}]},1).to({state:[{t:this.instance_4}]},2).wait(1));

	// Layer_2
	this.instance_5 = new lib.HUBStakeholderButtonBGUp();
	this.instance_5.setTransform(-81,-172);

	this.instance_6 = new lib.HUBStakeholderButtonBGDisabled();
	this.instance_6.setTransform(-81,-172);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5}]}).to({state:[{t:this.instance_6}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-87,-228,177,246.9);


(lib.InternalStakeholder2Button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// positionDisabledLabelTextField
	this.positionDisabledLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#BBD2D7");
	this.positionDisabledLabelTextField.name = "positionDisabledLabelTextField";
	this.positionDisabledLabelTextField.textAlign = "center";
	this.positionDisabledLabelTextField.lineHeight = 12;
	this.positionDisabledLabelTextField.lineWidth = 152;
	this.positionDisabledLabelTextField.parent = this;
	this.positionDisabledLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDisabledLabelTextField).wait(4));

	// positionDownLabelTextField
	this.positionDownLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionDownLabelTextField.name = "positionDownLabelTextField";
	this.positionDownLabelTextField.textAlign = "center";
	this.positionDownLabelTextField.lineHeight = 12;
	this.positionDownLabelTextField.lineWidth = 152;
	this.positionDownLabelTextField.parent = this;
	this.positionDownLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDownLabelTextField).wait(4));

	// positionOverLabelTextField
	this.positionOverLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionOverLabelTextField.name = "positionOverLabelTextField";
	this.positionOverLabelTextField.textAlign = "center";
	this.positionOverLabelTextField.lineHeight = 12;
	this.positionOverLabelTextField.lineWidth = 152;
	this.positionOverLabelTextField.parent = this;
	this.positionOverLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionOverLabelTextField).wait(4));

	// positionUpLabelTextField
	this.positionUpLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#FFFFFF");
	this.positionUpLabelTextField.name = "positionUpLabelTextField";
	this.positionUpLabelTextField.textAlign = "center";
	this.positionUpLabelTextField.lineHeight = 12;
	this.positionUpLabelTextField.lineWidth = 152;
	this.positionUpLabelTextField.parent = this;
	this.positionUpLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionUpLabelTextField).wait(4));

	// nameDisabledLabelTextField
	this.nameDisabledLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#BBD2D7");
	this.nameDisabledLabelTextField.name = "nameDisabledLabelTextField";
	this.nameDisabledLabelTextField.textAlign = "center";
	this.nameDisabledLabelTextField.lineHeight = 27;
	this.nameDisabledLabelTextField.lineWidth = 152;
	this.nameDisabledLabelTextField.parent = this;
	this.nameDisabledLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDisabledLabelTextField).wait(4));

	// nameDownLabelTextField
	this.nameDownLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameDownLabelTextField.name = "nameDownLabelTextField";
	this.nameDownLabelTextField.textAlign = "center";
	this.nameDownLabelTextField.lineHeight = 27;
	this.nameDownLabelTextField.lineWidth = 152;
	this.nameDownLabelTextField.parent = this;
	this.nameDownLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDownLabelTextField).wait(4));

	// nameOverLabelTextField
	this.nameOverLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameOverLabelTextField.name = "nameOverLabelTextField";
	this.nameOverLabelTextField.textAlign = "center";
	this.nameOverLabelTextField.lineHeight = 27;
	this.nameOverLabelTextField.lineWidth = 152;
	this.nameOverLabelTextField.parent = this;
	this.nameOverLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameOverLabelTextField).wait(4));

	// nameUpLabelTextField
	this.nameUpLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#FFFFFF");
	this.nameUpLabelTextField.name = "nameUpLabelTextField";
	this.nameUpLabelTextField.textAlign = "center";
	this.nameUpLabelTextField.lineHeight = 27;
	this.nameUpLabelTextField.lineWidth = 152;
	this.nameUpLabelTextField.parent = this;
	this.nameUpLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameUpLabelTextField).wait(4));

	// Layer_3
	this.instance = new lib.HUBStakeholderButtonLabelUp();
	this.instance.setTransform(-86,-55);

	this.instance_1 = new lib.HUBStakeholderButtonLabelOver();
	this.instance_1.setTransform(-86,-55);

	this.instance_2 = new lib.HUBStakeholderButtonLabelDisabled();
	this.instance_2.setTransform(-87,-56);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// Layer_5 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AhDOTIpYpZQgdgcAAgnIAArbQAAgoAdgcIJYpZQAcgcAnAAQAoAAAcAcIJYJZQAdAcAAAoIAALbQAAAngdAcIpYJZQgcAcgoAAQgnAAgcgcg");
	mask.setTransform(0.0676,-118.225);

	// Layer_4
	this.instance_3 = new lib.stakeholder_sarah();
	this.instance_3.setTransform(-72,-219,0.3873,0.3873);

	this.instance_4 = new lib.stakeholder_sarah_disabled();
	this.instance_4.setTransform(-72,-220,0.3873,0.3873);

	var maskedShapeInstanceList = [this.instance_3,this.instance_4];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3,p:{y:-219}}]}).to({state:[{t:this.instance_3,p:{y:-218}}]},1).to({state:[{t:this.instance_4}]},2).wait(1));

	// Layer_2
	this.instance_5 = new lib.HUBStakeholderButtonBGUp();
	this.instance_5.setTransform(-81,-172);

	this.instance_6 = new lib.HUBStakeholderButtonBGDisabled();
	this.instance_6.setTransform(-81,-172);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5}]}).to({state:[{t:this.instance_6}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-87,-220,177,238.9);


(lib.InternalStakeholder1Button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// positionDisabledLabelTextField
	this.positionDisabledLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#BBD2D7");
	this.positionDisabledLabelTextField.name = "positionDisabledLabelTextField";
	this.positionDisabledLabelTextField.textAlign = "center";
	this.positionDisabledLabelTextField.lineHeight = 12;
	this.positionDisabledLabelTextField.lineWidth = 152;
	this.positionDisabledLabelTextField.parent = this;
	this.positionDisabledLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDisabledLabelTextField).wait(4));

	// positionDownLabelTextField
	this.positionDownLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionDownLabelTextField.name = "positionDownLabelTextField";
	this.positionDownLabelTextField.textAlign = "center";
	this.positionDownLabelTextField.lineHeight = 12;
	this.positionDownLabelTextField.lineWidth = 152;
	this.positionDownLabelTextField.parent = this;
	this.positionDownLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionDownLabelTextField).wait(4));

	// positionOverLabelTextField
	this.positionOverLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#2C3C3C");
	this.positionOverLabelTextField.name = "positionOverLabelTextField";
	this.positionOverLabelTextField.textAlign = "center";
	this.positionOverLabelTextField.lineHeight = 12;
	this.positionOverLabelTextField.lineWidth = 152;
	this.positionOverLabelTextField.parent = this;
	this.positionOverLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionOverLabelTextField).wait(4));

	// positionUpLabelTextField
	this.positionUpLabelTextField = new cjs.Text("Start", "17px 'Work Sans'", "#FFFFFF");
	this.positionUpLabelTextField.name = "positionUpLabelTextField";
	this.positionUpLabelTextField.textAlign = "center";
	this.positionUpLabelTextField.lineHeight = 12;
	this.positionUpLabelTextField.lineWidth = 152;
	this.positionUpLabelTextField.parent = this;
	this.positionUpLabelTextField.setTransform(0.15,-31.55);
ranj.TextOffsetFixer.fix(this.positionUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.positionUpLabelTextField).wait(4));

	// nameDisabledLabelTextField
	this.nameDisabledLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#BBD2D7");
	this.nameDisabledLabelTextField.name = "nameDisabledLabelTextField";
	this.nameDisabledLabelTextField.textAlign = "center";
	this.nameDisabledLabelTextField.lineHeight = 27;
	this.nameDisabledLabelTextField.lineWidth = 152;
	this.nameDisabledLabelTextField.parent = this;
	this.nameDisabledLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDisabledLabelTextField).wait(4));

	// nameDownLabelTextField
	this.nameDownLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameDownLabelTextField.name = "nameDownLabelTextField";
	this.nameDownLabelTextField.textAlign = "center";
	this.nameDownLabelTextField.lineHeight = 27;
	this.nameDownLabelTextField.lineWidth = 152;
	this.nameDownLabelTextField.parent = this;
	this.nameDownLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameDownLabelTextField).wait(4));

	// nameOverLabelTextField
	this.nameOverLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#2C3C3C");
	this.nameOverLabelTextField.name = "nameOverLabelTextField";
	this.nameOverLabelTextField.textAlign = "center";
	this.nameOverLabelTextField.lineHeight = 27;
	this.nameOverLabelTextField.lineWidth = 152;
	this.nameOverLabelTextField.parent = this;
	this.nameOverLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameOverLabelTextField).wait(4));

	// nameUpLabelTextField
	this.nameUpLabelTextField = new cjs.Text("Start", "bold 17px 'Work Sans ExtraBold'", "#FFFFFF");
	this.nameUpLabelTextField.name = "nameUpLabelTextField";
	this.nameUpLabelTextField.textAlign = "center";
	this.nameUpLabelTextField.lineHeight = 27;
	this.nameUpLabelTextField.lineWidth = 152;
	this.nameUpLabelTextField.parent = this;
	this.nameUpLabelTextField.setTransform(0.15,-49.05);
ranj.TextOffsetFixer.fix(this.nameUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameUpLabelTextField).wait(4));

	// Layer_3
	this.instance = new lib.HUBStakeholderButtonLabelUp();
	this.instance.setTransform(-86,-55);

	this.instance_1 = new lib.HUBStakeholderButtonLabelOver();
	this.instance_1.setTransform(-86,-55);

	this.instance_2 = new lib.HUBStakeholderButtonLabelDisabled();
	this.instance_2.setTransform(-87,-56);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// Layer_5 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AhDSqIpZpYQgcgcAAgoIAAwbQAAgoAcgcIJZpZQAcgcAnAAQAoAAAcAcIJYJZQAdAcAAAoIAAQbQAAAogdAcIpYJYQgcAdgoAAQgnAAgcgdg");
	mask.setTransform(0.075,-146.175);

	// Layer_4
	this.instance_3 = new lib.stakeholder_Nia();
	this.instance_3.setTransform(-79,-230,0.4499,0.4499);

	this.instance_4 = new lib.stakeholder_nia_disabled();
	this.instance_4.setTransform(-79,-231,0.4499,0.4499);

	var maskedShapeInstanceList = [this.instance_3,this.instance_4];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3,p:{x:-79,y:-230}}]}).to({state:[{t:this.instance_3,p:{x:-82,y:-238}}]},1).to({state:[{t:this.instance_4}]},2).wait(1));

	// Layer_2
	this.instance_5 = new lib.HUBStakeholderButtonBGUp();
	this.instance_5.setTransform(-81,-172);

	this.instance_6 = new lib.HUBStakeholderButtonBGDisabled();
	this.instance_6.setTransform(-81,-172);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5}]}).to({state:[{t:this.instance_6}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-87,-238,177,256.9);


(lib.HUBTeaCornerButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Start", "bold 18px 'Work Sans ExtraBold'", "#BBD2D7");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 28;
	this.disabledLabelTextField.lineWidth = 182;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-0.05,-35.15);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Start", "bold 18px 'Work Sans ExtraBold'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 28;
	this.downLabelTextField.lineWidth = 182;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-0.05,-35.15);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Start", "bold 18px 'Work Sans ExtraBold'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 28;
	this.overLabelTextField.lineWidth = 182;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-0.05,-35.15);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Start", "bold 18px 'Work Sans ExtraBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 28;
	this.upLabelTextField.lineWidth = 182;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-0.05,-35.15);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_3
	this.instance = new lib.HUBTeaCornerButtonLabelUp();
	this.instance.setTransform(-109,-60);

	this.instance_1 = new lib.HUBTeaCornerButtonLabelOver();
	this.instance_1.setTransform(-109,-60);

	this.instance_2 = new lib.HUBTeaCornerButtonLabelDisabled();
	this.instance_2.setTransform(-109,-60);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// Layer_5 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("Aj9DGQg5ghgxgyQiViTAAjUQAAjTCViVQAxgxA5ghQBxhCCMAAQDTAACVCUQCVCVAADTQAADUiVCTQiVCWjTAAQiMgBhxhCg");
	mask.setTransform(-1.5,-75.35);

	// Layer_4
	this.instance_3 = new lib.TeaCornerIcon();
	this.instance_3.setTransform(-53,-156,0.5511,0.5511);

	this.instance_4 = new lib.TeaCornerIconDisabled();
	this.instance_4.setTransform(-53,-157,0.556,0.556);

	var maskedShapeInstanceList = [this.instance_3,this.instance_4];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3,p:{y:-156}}]}).to({state:[{t:this.instance_3,p:{y:-160}}]},1).to({state:[{t:this.instance_4}]},2).wait(1));

	// Layer_2
	this.instance_5 = new lib.HUBTeaCornerButtonBGUp();
	this.instance_5.setTransform(-63,-159);

	this.instance_6 = new lib.HUBTeaCornerButtonBGDisabled();
	this.instance_6.setTransform(-63,-160);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5}]}).to({state:[{t:this.instance_6}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-250,-160,369,191);


(lib.PlaceholderCloseButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(6,1,1).p("AjIjIIDIDIIivCwADJjIIjJDIIDJDJ");
	this.shape.setTransform(-1.225,-2.475);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Laag_2
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("AHBAAQAAC6iDCEQiECDi6AAQi5AAiEiDQiEiEAAi6QAAi5CEiEQCEiDC5AAQC6AACECDQCDCEAAC5g");

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#333333").s().p("Ak9E+QiDiEAAi6QAAi5CDiEQCEiDC5gBQC6ABCECDQCECEgBC5QABC6iECEQiECDi6AAQi5AAiEiDg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlaceholderCloseButton, new cjs.Rectangle(-45.9,-45.9,91.9,91.9), null);


(lib.KeyDecisionUnderlayImageContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.KeyDecisionOverlayFader = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecisionOverlayFader, new cjs.Rectangle(-960,-540,1920,1080), null);


(lib.KeyDecisionAvailableBackdrop = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.349)").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecisionAvailableBackdrop, new cjs.Rectangle(-960,-540,1920,1080), null);


(lib.MapContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.KeyDecInfoBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_2
	this.actionNeededTextField2 = new cjs.Text("[Action that is needed]\n[Action that is needed]\n[Action that is needed]", "21px 'Open Sans'");
	this.actionNeededTextField2.name = "actionNeededTextField2";
	this.actionNeededTextField2.lineHeight = 25;
	this.actionNeededTextField2.lineWidth = 401;
	this.actionNeededTextField2.parent = this;
	this.actionNeededTextField2.setTransform(37.25,4.1);
ranj.TextOffsetFixer.fix(this.actionNeededTextField2);

	this.timeline.addTween(cjs.Tween.get(this.actionNeededTextField2).wait(1));

	// Layer_1
	this.instance = new lib.NotificationBarEndpngcopy();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecInfoBar, new cjs.Rectangle(0,0,570,104), null);


(lib.KeyDecButtonOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KeyDecButtonHover();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecButtonOver, new cjs.Rectangle(0,0,119,115), null);


(lib.KeyDecButtonDown_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.KeyDecButtonDown();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecButtonDown_1, new cjs.Rectangle(0,0,113,114), null);


(lib.HubKeyDecisionNotificationContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-584.4,-152.1,621.4,205.2);


(lib.HubButtonNewIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.newAmountTextField = new cjs.Text("1", "bold 32px 'Work Sans'", "#FFFFFF");
	this.newAmountTextField.name = "newAmountTextField";
	this.newAmountTextField.textAlign = "center";
	this.newAmountTextField.lineHeight = 40;
	this.newAmountTextField.lineWidth = 52;
	this.newAmountTextField.parent = this;
	this.newAmountTextField.setTransform(-1.55,-29);
ranj.TextOffsetFixer.fix(this.newAmountTextField);

	this.timeline.addTween(cjs.Tween.get(this.newAmountTextField).wait(1));

	// Layer_1
	this.instance = new lib.HUBNewItemLabel1();
	this.instance.setTransform(-42,-40);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubButtonNewIndicator, new cjs.Rectangle(-42,-40,84,80), null);


(lib.HubBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiV/hUXMEr/AAAMAAACovMkr/AAAg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#CCCCCC").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubBackground, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.TopicButtonUpBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TopicButtonUp();
	this.instance.setTransform(-117.5,-32);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TopicButtonUpBG, new cjs.Rectangle(-117.5,-32,235,64), null);


(lib.TopicButtonDownBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TopicButtonDown();
	this.instance.setTransform(-117.5,-32);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TopicButtonDownBG, new cjs.Rectangle(-117.5,-32,235,64), null);


(lib.TopicButtonDisabledBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TopicButtonDisabled();
	this.instance.setTransform(-117.5,-32);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TopicButtonDisabledBG, new cjs.Rectangle(-117.5,-32,235,64), null);


(lib.NpcTextPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// npcTextField
	this.npcTextField = new cjs.Text("These two communities are facing the highest burden from Enni Virus. They also report higher levels of mistrust towards the district \nhospital. \nHaving ITCs that are more community-based may encourage more cases to seek \nhealth services.", "22px 'Work Sans SemiBold'", "#FFFFFF");
	this.npcTextField.name = "npcTextField";
	this.npcTextField.lineHeight = 26;
	this.npcTextField.lineWidth = 671;
	this.npcTextField.parent = this;
	this.npcTextField.setTransform(-299.35,26.05);
ranj.TextOffsetFixer.fix(this.npcTextField);

	this.timeline.addTween(cjs.Tween.get(this.npcTextField).wait(1));

	// Laag_2
	this.instance = new lib.DialogNPCTextFieldBG1();
	this.instance.setTransform(-330,-34);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NpcTextPanel, new cjs.Rectangle(-330,-34,765,323), null);


(lib.NPCLabelPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.textField = new cjs.Text("Name NPCCCCC", "16px 'Open Sans'", "#FFFFFF");
	this.textField.name = "textField";
	this.textField.lineHeight = 26;
	this.textField.lineWidth = 123;
	this.textField.parent = this;
	this.textField.setTransform(-82.5,-9.85);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NPCLabelPanel, new cjs.Rectangle(-84.5,-11.8,126.6,43.8), null);


(lib.DialogScreenBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiWAhUXMEsBAAAMAAACovMksBAAAg");
	this.shape.setTransform(0.0004,0,0.9999,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#333333").s().p("EiWABUYMAAAiovMEsBAAAMAAACovg");
	this.shape_1.setTransform(0.0004,0,0.9999,1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DialogScreenBackground, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.DecisionScreenBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiWAhUXMEsBAAAMAAACovMksBAAAg");
	this.shape.setTransform(0.0004,0,0.9999,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#EEEAE6").s().p("EiWABUYMAAAiovMEsBAAAMAAACovg");
	this.shape_1.setTransform(0.0004,0,0.9999,1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DecisionScreenBackground, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.DecisionScreenBackgroun = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiWAhUXMEsBAAAMAAACovMksBAAAg");
	this.shape.setTransform(0.0004,0,0.9999,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#EEEAE6").s().p("EiWABUYMAAAiovMEsBAAAMAAACovg");
	this.shape_1.setTransform(0.0004,0,0.9999,1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DecisionScreenBackgroun, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.UnderlineMC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFF8E0").s().p("EgmCAFKIAAqTMBMFAAAIAAKTg");
	this.shape.setTransform(244.5,34);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.UnderlineMC, new cjs.Rectangle(1,1,487,66), null);


(lib.newIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.NewTopicIcon();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.newIndicator, new cjs.Rectangle(0,0,55,36), null);


(lib.AnswerTimer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// flash0_ai
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape.setTransform(120.45,23.95,0.962,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_1.setTransform(105.7,23.95,0.962,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_2.setTransform(828.85,23.95,0.962,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_3.setTransform(814.124,23.95,0.962,1);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_4.setTransform(799.35,23.95,0.962,1);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_5.setTransform(784.6,23.95,0.962,1);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_6.setTransform(769.874,23.95,0.962,1);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_7.setTransform(755.1,23.95,0.962,1);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_8.setTransform(740.374,23.95,0.962,1);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_9.setTransform(725.624,23.95,0.962,1);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_10.setTransform(710.85,23.95,0.962,1);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_11.setTransform(696.124,23.95,0.962,1);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_12.setTransform(681.374,23.95,0.962,1);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_13.setTransform(666.6,23.95,0.962,1);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_14.setTransform(651.85,23.95,0.962,1);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_15.setTransform(637.1,23.95,0.962,1);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_16.setTransform(622.324,23.95,0.962,1);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_17.setTransform(607.6,23.95,0.962,1);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_18.setTransform(592.8,23.95,0.962,1);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_19.setTransform(578.1,23.95,0.962,1);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_20.setTransform(563.35,23.95,0.962,1);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_21.setTransform(548.574,23.95,0.962,1);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_22.setTransform(533.85,23.95,0.962,1);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_23.setTransform(519.1,23.95,0.962,1);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_24.setTransform(504.324,23.95,0.962,1);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_25.setTransform(489.574,23.95,0.962,1);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_26.setTransform(474.85,23.95,0.962,1);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_27.setTransform(460.05,23.95,0.962,1);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_28.setTransform(445.324,23.95,0.962,1);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_29.setTransform(430.574,23.95,0.962,1);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_30.setTransform(415.8,23.95,0.962,1);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_31.setTransform(401.1,23.95,0.962,1);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_32.setTransform(386.3,23.95,0.962,1);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_33.setTransform(371.574,23.95,0.962,1);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_34.setTransform(356.824,23.95,0.962,1);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_35.setTransform(342.05,23.95,0.962,1);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_36.setTransform(327.3,23.95,0.962,1);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_37.setTransform(312.574,23.95,0.962,1);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_38.setTransform(297.774,23.95,0.962,1);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_39.setTransform(283.05,23.95,0.962,1);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_40.setTransform(268.324,23.95,0.962,1);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_41.setTransform(253.524,23.95,0.962,1);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_42.setTransform(238.8,23.95,0.962,1);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_43.setTransform(224.074,23.95,0.962,1);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_44.setTransform(209.3,23.95,0.962,1);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_45.setTransform(194.55,23.95,0.962,1);

	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.f("rgba(255,255,255,0.6)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_46.setTransform(179.824,23.95,0.962,1);

	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_47.setTransform(165.05,23.95,0.962,1);

	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_48.setTransform(150.3,23.95,0.962,1);

	this.shape_49 = new cjs.Shape();
	this.shape_49.graphics.f("rgba(255,255,255,0.6)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_49.setTransform(135.55,23.95,0.962,1);

	this.shape_50 = new cjs.Shape();
	this.shape_50.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_50.setTransform(828.85,23.95,0.962,1);

	this.shape_51 = new cjs.Shape();
	this.shape_51.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_51.setTransform(814.124,23.95,0.962,1);

	this.shape_52 = new cjs.Shape();
	this.shape_52.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_52.setTransform(799.35,23.95,0.962,1);

	this.shape_53 = new cjs.Shape();
	this.shape_53.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_53.setTransform(784.6,23.95,0.962,1);

	this.shape_54 = new cjs.Shape();
	this.shape_54.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_54.setTransform(769.874,23.95,0.962,1);

	this.shape_55 = new cjs.Shape();
	this.shape_55.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_55.setTransform(755.1,23.95,0.962,1);

	this.shape_56 = new cjs.Shape();
	this.shape_56.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_56.setTransform(740.374,23.95,0.962,1);

	this.shape_57 = new cjs.Shape();
	this.shape_57.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_57.setTransform(725.624,23.95,0.962,1);

	this.shape_58 = new cjs.Shape();
	this.shape_58.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_58.setTransform(710.85,23.95,0.962,1);

	this.shape_59 = new cjs.Shape();
	this.shape_59.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_59.setTransform(696.124,23.95,0.962,1);

	this.shape_60 = new cjs.Shape();
	this.shape_60.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_60.setTransform(681.374,23.95,0.962,1);

	this.shape_61 = new cjs.Shape();
	this.shape_61.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_61.setTransform(666.6,23.95,0.962,1);

	this.shape_62 = new cjs.Shape();
	this.shape_62.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_62.setTransform(651.85,23.95,0.962,1);

	this.shape_63 = new cjs.Shape();
	this.shape_63.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_63.setTransform(637.1,23.95,0.962,1);

	this.shape_64 = new cjs.Shape();
	this.shape_64.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_64.setTransform(622.324,23.95,0.962,1);

	this.shape_65 = new cjs.Shape();
	this.shape_65.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_65.setTransform(607.6,23.95,0.962,1);

	this.shape_66 = new cjs.Shape();
	this.shape_66.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_66.setTransform(592.8,23.95,0.962,1);

	this.shape_67 = new cjs.Shape();
	this.shape_67.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_67.setTransform(578.1,23.95,0.962,1);

	this.shape_68 = new cjs.Shape();
	this.shape_68.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_68.setTransform(563.35,23.95,0.962,1);

	this.shape_69 = new cjs.Shape();
	this.shape_69.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_69.setTransform(548.574,23.95,0.962,1);

	this.shape_70 = new cjs.Shape();
	this.shape_70.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_70.setTransform(533.85,23.95,0.962,1);

	this.shape_71 = new cjs.Shape();
	this.shape_71.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_71.setTransform(519.1,23.95,0.962,1);

	this.shape_72 = new cjs.Shape();
	this.shape_72.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_72.setTransform(504.324,23.95,0.962,1);

	this.shape_73 = new cjs.Shape();
	this.shape_73.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_73.setTransform(489.574,23.95,0.962,1);

	this.shape_74 = new cjs.Shape();
	this.shape_74.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_74.setTransform(474.85,23.95,0.962,1);

	this.shape_75 = new cjs.Shape();
	this.shape_75.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_75.setTransform(460.05,23.95,0.962,1);

	this.shape_76 = new cjs.Shape();
	this.shape_76.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_76.setTransform(445.324,23.95,0.962,1);

	this.shape_77 = new cjs.Shape();
	this.shape_77.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_77.setTransform(430.574,23.95,0.962,1);

	this.shape_78 = new cjs.Shape();
	this.shape_78.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_78.setTransform(415.8,23.95,0.962,1);

	this.shape_79 = new cjs.Shape();
	this.shape_79.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_79.setTransform(401.1,23.95,0.962,1);

	this.shape_80 = new cjs.Shape();
	this.shape_80.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_80.setTransform(386.3,23.95,0.962,1);

	this.shape_81 = new cjs.Shape();
	this.shape_81.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_81.setTransform(371.574,23.95,0.962,1);

	this.shape_82 = new cjs.Shape();
	this.shape_82.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_82.setTransform(356.824,23.95,0.962,1);

	this.shape_83 = new cjs.Shape();
	this.shape_83.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_83.setTransform(342.05,23.95,0.962,1);

	this.shape_84 = new cjs.Shape();
	this.shape_84.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_84.setTransform(327.3,23.95,0.962,1);

	this.shape_85 = new cjs.Shape();
	this.shape_85.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_85.setTransform(312.574,23.95,0.962,1);

	this.shape_86 = new cjs.Shape();
	this.shape_86.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_86.setTransform(297.774,23.95,0.962,1);

	this.shape_87 = new cjs.Shape();
	this.shape_87.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_87.setTransform(283.05,23.95,0.962,1);

	this.shape_88 = new cjs.Shape();
	this.shape_88.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_88.setTransform(268.324,23.95,0.962,1);

	this.shape_89 = new cjs.Shape();
	this.shape_89.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_89.setTransform(253.524,23.95,0.962,1);

	this.shape_90 = new cjs.Shape();
	this.shape_90.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_90.setTransform(238.8,23.95,0.962,1);

	this.shape_91 = new cjs.Shape();
	this.shape_91.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_91.setTransform(224.074,23.95,0.962,1);

	this.shape_92 = new cjs.Shape();
	this.shape_92.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_92.setTransform(209.3,23.95,0.962,1);

	this.shape_93 = new cjs.Shape();
	this.shape_93.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_93.setTransform(194.55,23.95,0.962,1);

	this.shape_94 = new cjs.Shape();
	this.shape_94.graphics.f("rgba(255,255,255,0.251)").s().p("Ag7BtIAAjaIB2AAIAADag");
	this.shape_94.setTransform(179.824,23.95,0.962,1);

	this.shape_95 = new cjs.Shape();
	this.shape_95.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_95.setTransform(165.05,23.95,0.962,1);

	this.shape_96 = new cjs.Shape();
	this.shape_96.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_96.setTransform(150.3,23.95,0.962,1);

	this.shape_97 = new cjs.Shape();
	this.shape_97.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_97.setTransform(135.55,23.95,0.962,1);

	this.shape_98 = new cjs.Shape();
	this.shape_98.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_98.setTransform(135.55,23.95,0.962,1);

	this.shape_99 = new cjs.Shape();
	this.shape_99.graphics.f("rgba(255,255,255,0.251)").s().p("Ag6BtIAAjaIB1AAIAADag");
	this.shape_99.setTransform(135.55,23.95,0.962,1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_49},{t:this.shape_48,p:{x:150.3}},{t:this.shape_47,p:{x:165.05}},{t:this.shape_46},{t:this.shape_45,p:{x:194.55}},{t:this.shape_44,p:{x:209.3}},{t:this.shape_43,p:{x:224.074}},{t:this.shape_42,p:{x:238.8}},{t:this.shape_41,p:{x:253.524}},{t:this.shape_40,p:{x:268.324}},{t:this.shape_39,p:{x:283.05}},{t:this.shape_38,p:{x:297.774}},{t:this.shape_37,p:{x:312.574}},{t:this.shape_36,p:{x:327.3}},{t:this.shape_35,p:{x:342.05}},{t:this.shape_34,p:{x:356.824}},{t:this.shape_33,p:{x:371.574}},{t:this.shape_32,p:{x:386.3}},{t:this.shape_31,p:{x:401.1}},{t:this.shape_30,p:{x:415.8}},{t:this.shape_29,p:{x:430.574}},{t:this.shape_28,p:{x:445.324}},{t:this.shape_27,p:{x:460.05}},{t:this.shape_26,p:{x:474.85}},{t:this.shape_25,p:{x:489.574}},{t:this.shape_24,p:{x:504.324}},{t:this.shape_23,p:{x:519.1}},{t:this.shape_22,p:{x:533.85}},{t:this.shape_21,p:{x:548.574}},{t:this.shape_20,p:{x:563.35}},{t:this.shape_19,p:{x:578.1}},{t:this.shape_18,p:{x:592.8}},{t:this.shape_17,p:{x:607.6}},{t:this.shape_16,p:{x:622.324}},{t:this.shape_15,p:{x:637.1}},{t:this.shape_14,p:{x:651.85}},{t:this.shape_13,p:{x:666.6}},{t:this.shape_12,p:{x:681.374}},{t:this.shape_11,p:{x:696.124}},{t:this.shape_10,p:{x:710.85}},{t:this.shape_9,p:{x:725.624}},{t:this.shape_8,p:{x:740.374}},{t:this.shape_7,p:{x:755.1}},{t:this.shape_6,p:{x:769.874}},{t:this.shape_5,p:{x:784.6}},{t:this.shape_4,p:{x:799.35}},{t:this.shape_3,p:{x:814.124}},{t:this.shape_2,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]}).to({state:[{t:this.shape_48,p:{x:135.55}},{t:this.shape_47,p:{x:150.3}},{t:this.shape_45,p:{x:165.05}},{t:this.shape_46},{t:this.shape_44,p:{x:194.55}},{t:this.shape_42,p:{x:209.3}},{t:this.shape_43,p:{x:224.074}},{t:this.shape_39,p:{x:238.8}},{t:this.shape_41,p:{x:253.524}},{t:this.shape_40,p:{x:268.324}},{t:this.shape_36,p:{x:283.05}},{t:this.shape_38,p:{x:297.774}},{t:this.shape_37,p:{x:312.574}},{t:this.shape_35,p:{x:327.3}},{t:this.shape_32,p:{x:342.05}},{t:this.shape_34,p:{x:356.824}},{t:this.shape_33,p:{x:371.574}},{t:this.shape_31,p:{x:386.3}},{t:this.shape_30,p:{x:401.1}},{t:this.shape_27,p:{x:415.8}},{t:this.shape_29,p:{x:430.574}},{t:this.shape_28,p:{x:445.324}},{t:this.shape_26,p:{x:460.05}},{t:this.shape_23,p:{x:474.85}},{t:this.shape_25,p:{x:489.574}},{t:this.shape_24,p:{x:504.324}},{t:this.shape_22,p:{x:519.1}},{t:this.shape_20,p:{x:533.85}},{t:this.shape_21,p:{x:548.574}},{t:this.shape_19,p:{x:563.35}},{t:this.shape_18,p:{x:578.1}},{t:this.shape_17,p:{x:592.8}},{t:this.shape_15,p:{x:607.6}},{t:this.shape_16,p:{x:622.324}},{t:this.shape_14,p:{x:637.1}},{t:this.shape_13,p:{x:651.85}},{t:this.shape_10,p:{x:666.6}},{t:this.shape_12,p:{x:681.374}},{t:this.shape_11,p:{x:696.124}},{t:this.shape_7,p:{x:710.85}},{t:this.shape_9,p:{x:725.624}},{t:this.shape_8,p:{x:740.374}},{t:this.shape_5,p:{x:755.1}},{t:this.shape_6,p:{x:769.874}},{t:this.shape_4,p:{x:784.6}},{t:this.shape_2,p:{x:799.35}},{t:this.shape_3,p:{x:814.124}},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_48,p:{x:135.55}},{t:this.shape_47,p:{x:150.3}},{t:this.shape_45,p:{x:165.05}},{t:this.shape_43,p:{x:179.824}},{t:this.shape_44,p:{x:194.55}},{t:this.shape_42,p:{x:209.3}},{t:this.shape_41,p:{x:224.074}},{t:this.shape_39,p:{x:238.8}},{t:this.shape_40,p:{x:253.524}},{t:this.shape_38,p:{x:268.324}},{t:this.shape_36,p:{x:283.05}},{t:this.shape_37,p:{x:297.774}},{t:this.shape_34,p:{x:312.574}},{t:this.shape_35,p:{x:327.3}},{t:this.shape_32,p:{x:342.05}},{t:this.shape_33,p:{x:356.824}},{t:this.shape_29,p:{x:371.574}},{t:this.shape_31,p:{x:386.3}},{t:this.shape_30,p:{x:401.1}},{t:this.shape_27,p:{x:415.8}},{t:this.shape_28,p:{x:430.574}},{t:this.shape_25,p:{x:445.324}},{t:this.shape_26,p:{x:460.05}},{t:this.shape_23,p:{x:474.85}},{t:this.shape_24,p:{x:489.574}},{t:this.shape_21,p:{x:504.324}},{t:this.shape_22,p:{x:519.1}},{t:this.shape_20,p:{x:533.85}},{t:this.shape_16,p:{x:548.574}},{t:this.shape_19,p:{x:563.35}},{t:this.shape_18,p:{x:578.1}},{t:this.shape_17,p:{x:592.8}},{t:this.shape_15,p:{x:607.6}},{t:this.shape_12,p:{x:622.324}},{t:this.shape_14,p:{x:637.1}},{t:this.shape_13,p:{x:651.85}},{t:this.shape_10,p:{x:666.6}},{t:this.shape_11,p:{x:681.374}},{t:this.shape_9,p:{x:696.124}},{t:this.shape_7,p:{x:710.85}},{t:this.shape_8,p:{x:725.624}},{t:this.shape_6,p:{x:740.374}},{t:this.shape_5,p:{x:755.1}},{t:this.shape_3,p:{x:769.874}},{t:this.shape_4,p:{x:784.6}},{t:this.shape_2,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_47,p:{x:135.55}},{t:this.shape_45,p:{x:150.3}},{t:this.shape_44,p:{x:165.05}},{t:this.shape_43,p:{x:179.824}},{t:this.shape_42,p:{x:194.55}},{t:this.shape_39,p:{x:209.3}},{t:this.shape_41,p:{x:224.074}},{t:this.shape_36,p:{x:238.8}},{t:this.shape_40,p:{x:253.524}},{t:this.shape_38,p:{x:268.324}},{t:this.shape_35,p:{x:283.05}},{t:this.shape_37,p:{x:297.774}},{t:this.shape_34,p:{x:312.574}},{t:this.shape_32,p:{x:327.3}},{t:this.shape_31,p:{x:342.05}},{t:this.shape_33,p:{x:356.824}},{t:this.shape_29,p:{x:371.574}},{t:this.shape_30,p:{x:386.3}},{t:this.shape_27,p:{x:401.1}},{t:this.shape_26,p:{x:415.8}},{t:this.shape_28,p:{x:430.574}},{t:this.shape_25,p:{x:445.324}},{t:this.shape_23,p:{x:460.05}},{t:this.shape_22,p:{x:474.85}},{t:this.shape_24,p:{x:489.574}},{t:this.shape_21,p:{x:504.324}},{t:this.shape_20,p:{x:519.1}},{t:this.shape_19,p:{x:533.85}},{t:this.shape_16,p:{x:548.574}},{t:this.shape_18,p:{x:563.35}},{t:this.shape_17,p:{x:578.1}},{t:this.shape_15,p:{x:592.8}},{t:this.shape_14,p:{x:607.6}},{t:this.shape_12,p:{x:622.324}},{t:this.shape_13,p:{x:637.1}},{t:this.shape_10,p:{x:651.85}},{t:this.shape_7,p:{x:666.6}},{t:this.shape_11,p:{x:681.374}},{t:this.shape_9,p:{x:696.124}},{t:this.shape_5,p:{x:710.85}},{t:this.shape_8,p:{x:725.624}},{t:this.shape_6,p:{x:740.374}},{t:this.shape_4,p:{x:755.1}},{t:this.shape_3,p:{x:769.874}},{t:this.shape_2,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_45,p:{x:135.55}},{t:this.shape_44,p:{x:150.3}},{t:this.shape_42,p:{x:165.05}},{t:this.shape_43,p:{x:179.824}},{t:this.shape_39,p:{x:194.55}},{t:this.shape_36,p:{x:209.3}},{t:this.shape_41,p:{x:224.074}},{t:this.shape_35,p:{x:238.8}},{t:this.shape_40,p:{x:253.524}},{t:this.shape_38,p:{x:268.324}},{t:this.shape_32,p:{x:283.05}},{t:this.shape_37,p:{x:297.774}},{t:this.shape_34,p:{x:312.574}},{t:this.shape_31,p:{x:327.3}},{t:this.shape_30,p:{x:342.05}},{t:this.shape_33,p:{x:356.824}},{t:this.shape_29,p:{x:371.574}},{t:this.shape_27,p:{x:386.3}},{t:this.shape_26,p:{x:401.1}},{t:this.shape_23,p:{x:415.8}},{t:this.shape_28,p:{x:430.574}},{t:this.shape_25,p:{x:445.324}},{t:this.shape_22,p:{x:460.05}},{t:this.shape_20,p:{x:474.85}},{t:this.shape_24,p:{x:489.574}},{t:this.shape_21,p:{x:504.324}},{t:this.shape_19,p:{x:519.1}},{t:this.shape_18,p:{x:533.85}},{t:this.shape_16,p:{x:548.574}},{t:this.shape_17,p:{x:563.35}},{t:this.shape_15,p:{x:578.1}},{t:this.shape_14,p:{x:592.8}},{t:this.shape_13,p:{x:607.6}},{t:this.shape_12,p:{x:622.324}},{t:this.shape_10,p:{x:637.1}},{t:this.shape_7,p:{x:651.85}},{t:this.shape_5,p:{x:666.6}},{t:this.shape_11,p:{x:681.374}},{t:this.shape_9,p:{x:696.124}},{t:this.shape_4,p:{x:710.85}},{t:this.shape_8,p:{x:725.624}},{t:this.shape_6,p:{x:740.374}},{t:this.shape_2,p:{x:755.1}},{t:this.shape_3,p:{x:769.874}},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_45,p:{x:135.55}},{t:this.shape_44,p:{x:150.3}},{t:this.shape_42,p:{x:165.05}},{t:this.shape_41,p:{x:179.824}},{t:this.shape_39,p:{x:194.55}},{t:this.shape_36,p:{x:209.3}},{t:this.shape_40,p:{x:224.074}},{t:this.shape_35,p:{x:238.8}},{t:this.shape_38,p:{x:253.524}},{t:this.shape_37,p:{x:268.324}},{t:this.shape_32,p:{x:283.05}},{t:this.shape_34,p:{x:297.774}},{t:this.shape_33,p:{x:312.574}},{t:this.shape_31,p:{x:327.3}},{t:this.shape_30,p:{x:342.05}},{t:this.shape_29,p:{x:356.824}},{t:this.shape_28,p:{x:371.574}},{t:this.shape_27,p:{x:386.3}},{t:this.shape_26,p:{x:401.1}},{t:this.shape_23,p:{x:415.8}},{t:this.shape_25,p:{x:430.574}},{t:this.shape_24,p:{x:445.324}},{t:this.shape_22,p:{x:460.05}},{t:this.shape_20,p:{x:474.85}},{t:this.shape_21,p:{x:489.574}},{t:this.shape_16,p:{x:504.324}},{t:this.shape_19,p:{x:519.1}},{t:this.shape_18,p:{x:533.85}},{t:this.shape_12,p:{x:548.574}},{t:this.shape_17,p:{x:563.35}},{t:this.shape_15,p:{x:578.1}},{t:this.shape_14,p:{x:592.8}},{t:this.shape_13,p:{x:607.6}},{t:this.shape_11,p:{x:622.324}},{t:this.shape_10,p:{x:637.1}},{t:this.shape_7,p:{x:651.85}},{t:this.shape_5,p:{x:666.6}},{t:this.shape_9,p:{x:681.374}},{t:this.shape_8,p:{x:696.124}},{t:this.shape_4,p:{x:710.85}},{t:this.shape_6,p:{x:725.624}},{t:this.shape_3,p:{x:740.374}},{t:this.shape_2,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_44,p:{x:135.55}},{t:this.shape_42,p:{x:150.3}},{t:this.shape_39,p:{x:165.05}},{t:this.shape_41,p:{x:179.824}},{t:this.shape_36,p:{x:194.55}},{t:this.shape_35,p:{x:209.3}},{t:this.shape_40,p:{x:224.074}},{t:this.shape_32,p:{x:238.8}},{t:this.shape_38,p:{x:253.524}},{t:this.shape_37,p:{x:268.324}},{t:this.shape_31,p:{x:283.05}},{t:this.shape_34,p:{x:297.774}},{t:this.shape_33,p:{x:312.574}},{t:this.shape_30,p:{x:327.3}},{t:this.shape_27,p:{x:342.05}},{t:this.shape_29,p:{x:356.824}},{t:this.shape_28,p:{x:371.574}},{t:this.shape_26,p:{x:386.3}},{t:this.shape_23,p:{x:401.1}},{t:this.shape_22,p:{x:415.8}},{t:this.shape_25,p:{x:430.574}},{t:this.shape_24,p:{x:445.324}},{t:this.shape_20,p:{x:460.05}},{t:this.shape_19,p:{x:474.85}},{t:this.shape_21,p:{x:489.574}},{t:this.shape_16,p:{x:504.324}},{t:this.shape_18,p:{x:519.1}},{t:this.shape_17,p:{x:533.85}},{t:this.shape_12,p:{x:548.574}},{t:this.shape_15,p:{x:563.35}},{t:this.shape_14,p:{x:578.1}},{t:this.shape_13,p:{x:592.8}},{t:this.shape_10,p:{x:607.6}},{t:this.shape_11,p:{x:622.324}},{t:this.shape_7,p:{x:637.1}},{t:this.shape_5,p:{x:651.85}},{t:this.shape_4,p:{x:666.6}},{t:this.shape_9,p:{x:681.374}},{t:this.shape_8,p:{x:696.124}},{t:this.shape_2,p:{x:710.85}},{t:this.shape_6,p:{x:725.624}},{t:this.shape_3,p:{x:740.374}},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_44,p:{x:135.55}},{t:this.shape_42,p:{x:150.3}},{t:this.shape_39,p:{x:165.05}},{t:this.shape_40,p:{x:179.824}},{t:this.shape_36,p:{x:194.55}},{t:this.shape_35,p:{x:209.3}},{t:this.shape_38,p:{x:224.074}},{t:this.shape_32,p:{x:238.8}},{t:this.shape_37,p:{x:253.524}},{t:this.shape_34,p:{x:268.324}},{t:this.shape_31,p:{x:283.05}},{t:this.shape_33,p:{x:297.774}},{t:this.shape_29,p:{x:312.574}},{t:this.shape_30,p:{x:327.3}},{t:this.shape_27,p:{x:342.05}},{t:this.shape_28,p:{x:356.824}},{t:this.shape_25,p:{x:371.574}},{t:this.shape_26,p:{x:386.3}},{t:this.shape_23,p:{x:401.1}},{t:this.shape_22,p:{x:415.8}},{t:this.shape_24,p:{x:430.574}},{t:this.shape_21,p:{x:445.324}},{t:this.shape_20,p:{x:460.05}},{t:this.shape_19,p:{x:474.85}},{t:this.shape_16,p:{x:489.574}},{t:this.shape_12,p:{x:504.324}},{t:this.shape_18,p:{x:519.1}},{t:this.shape_17,p:{x:533.85}},{t:this.shape_11,p:{x:548.574}},{t:this.shape_15,p:{x:563.35}},{t:this.shape_14,p:{x:578.1}},{t:this.shape_13,p:{x:592.8}},{t:this.shape_10,p:{x:607.6}},{t:this.shape_9,p:{x:622.324}},{t:this.shape_7,p:{x:637.1}},{t:this.shape_5,p:{x:651.85}},{t:this.shape_4,p:{x:666.6}},{t:this.shape_8,p:{x:681.374}},{t:this.shape_6,p:{x:696.124}},{t:this.shape_2,p:{x:710.85}},{t:this.shape_3,p:{x:725.624}},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_44,p:{x:135.55}},{t:this.shape_42,p:{x:150.3}},{t:this.shape_39,p:{x:165.05}},{t:this.shape_38,p:{x:179.824}},{t:this.shape_36,p:{x:194.55}},{t:this.shape_35,p:{x:209.3}},{t:this.shape_37,p:{x:224.074}},{t:this.shape_32,p:{x:238.8}},{t:this.shape_34,p:{x:253.524}},{t:this.shape_33,p:{x:268.324}},{t:this.shape_31,p:{x:283.05}},{t:this.shape_29,p:{x:297.774}},{t:this.shape_28,p:{x:312.574}},{t:this.shape_30,p:{x:327.3}},{t:this.shape_27,p:{x:342.05}},{t:this.shape_25,p:{x:356.824}},{t:this.shape_24,p:{x:371.574}},{t:this.shape_26,p:{x:386.3}},{t:this.shape_23,p:{x:401.1}},{t:this.shape_22,p:{x:415.8}},{t:this.shape_21,p:{x:430.574}},{t:this.shape_16,p:{x:445.324}},{t:this.shape_20,p:{x:460.05}},{t:this.shape_19,p:{x:474.85}},{t:this.shape_12,p:{x:489.574}},{t:this.shape_11,p:{x:504.324}},{t:this.shape_18,p:{x:519.1}},{t:this.shape_17,p:{x:533.85}},{t:this.shape_9,p:{x:548.574}},{t:this.shape_15,p:{x:563.35}},{t:this.shape_14,p:{x:578.1}},{t:this.shape_13,p:{x:592.8}},{t:this.shape_10,p:{x:607.6}},{t:this.shape_8,p:{x:622.324}},{t:this.shape_7,p:{x:637.1}},{t:this.shape_5,p:{x:651.85}},{t:this.shape_4,p:{x:666.6}},{t:this.shape_6,p:{x:681.374}},{t:this.shape_3,p:{x:696.124}},{t:this.shape_2,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_42,p:{x:135.55}},{t:this.shape_39,p:{x:150.3}},{t:this.shape_36,p:{x:165.05}},{t:this.shape_38,p:{x:179.824}},{t:this.shape_35,p:{x:194.55}},{t:this.shape_32,p:{x:209.3}},{t:this.shape_37,p:{x:224.074}},{t:this.shape_31,p:{x:238.8}},{t:this.shape_34,p:{x:253.524}},{t:this.shape_33,p:{x:268.324}},{t:this.shape_30,p:{x:283.05}},{t:this.shape_29,p:{x:297.774}},{t:this.shape_28,p:{x:312.574}},{t:this.shape_27,p:{x:327.3}},{t:this.shape_26,p:{x:342.05}},{t:this.shape_25,p:{x:356.824}},{t:this.shape_24,p:{x:371.574}},{t:this.shape_23,p:{x:386.3}},{t:this.shape_22,p:{x:401.1}},{t:this.shape_20,p:{x:415.8}},{t:this.shape_21,p:{x:430.574}},{t:this.shape_16,p:{x:445.324}},{t:this.shape_19,p:{x:460.05}},{t:this.shape_18,p:{x:474.85}},{t:this.shape_12,p:{x:489.574}},{t:this.shape_11,p:{x:504.324}},{t:this.shape_17,p:{x:519.1}},{t:this.shape_15,p:{x:533.85}},{t:this.shape_9,p:{x:548.574}},{t:this.shape_14,p:{x:563.35}},{t:this.shape_13,p:{x:578.1}},{t:this.shape_10,p:{x:592.8}},{t:this.shape_7,p:{x:607.6}},{t:this.shape_8,p:{x:622.324}},{t:this.shape_5,p:{x:637.1}},{t:this.shape_4,p:{x:651.85}},{t:this.shape_2,p:{x:666.6}},{t:this.shape_6,p:{x:681.374}},{t:this.shape_3,p:{x:696.124}},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_42,p:{x:135.55}},{t:this.shape_39,p:{x:150.3}},{t:this.shape_36,p:{x:165.05}},{t:this.shape_37,p:{x:179.824}},{t:this.shape_35,p:{x:194.55}},{t:this.shape_32,p:{x:209.3}},{t:this.shape_34,p:{x:224.074}},{t:this.shape_31,p:{x:238.8}},{t:this.shape_33,p:{x:253.524}},{t:this.shape_29,p:{x:268.324}},{t:this.shape_30,p:{x:283.05}},{t:this.shape_28,p:{x:297.774}},{t:this.shape_25,p:{x:312.574}},{t:this.shape_27,p:{x:327.3}},{t:this.shape_26,p:{x:342.05}},{t:this.shape_24,p:{x:356.824}},{t:this.shape_21,p:{x:371.574}},{t:this.shape_23,p:{x:386.3}},{t:this.shape_22,p:{x:401.1}},{t:this.shape_20,p:{x:415.8}},{t:this.shape_16,p:{x:430.574}},{t:this.shape_12,p:{x:445.324}},{t:this.shape_19,p:{x:460.05}},{t:this.shape_18,p:{x:474.85}},{t:this.shape_11,p:{x:489.574}},{t:this.shape_9,p:{x:504.324}},{t:this.shape_17,p:{x:519.1}},{t:this.shape_15,p:{x:533.85}},{t:this.shape_8,p:{x:548.574}},{t:this.shape_14,p:{x:563.35}},{t:this.shape_13,p:{x:578.1}},{t:this.shape_10,p:{x:592.8}},{t:this.shape_7,p:{x:607.6}},{t:this.shape_6,p:{x:622.324}},{t:this.shape_5,p:{x:637.1}},{t:this.shape_4,p:{x:651.85}},{t:this.shape_2,p:{x:666.6}},{t:this.shape_3,p:{x:681.374}},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_42,p:{x:135.55}},{t:this.shape_39,p:{x:150.3}},{t:this.shape_36,p:{x:165.05}},{t:this.shape_34,p:{x:179.824}},{t:this.shape_35,p:{x:194.55}},{t:this.shape_32,p:{x:209.3}},{t:this.shape_33,p:{x:224.074}},{t:this.shape_31,p:{x:238.8}},{t:this.shape_29,p:{x:253.524}},{t:this.shape_28,p:{x:268.324}},{t:this.shape_30,p:{x:283.05}},{t:this.shape_25,p:{x:297.774}},{t:this.shape_24,p:{x:312.574}},{t:this.shape_27,p:{x:327.3}},{t:this.shape_26,p:{x:342.05}},{t:this.shape_21,p:{x:356.824}},{t:this.shape_16,p:{x:371.574}},{t:this.shape_23,p:{x:386.3}},{t:this.shape_22,p:{x:401.1}},{t:this.shape_20,p:{x:415.8}},{t:this.shape_12,p:{x:430.574}},{t:this.shape_11,p:{x:445.324}},{t:this.shape_19,p:{x:460.05}},{t:this.shape_18,p:{x:474.85}},{t:this.shape_9,p:{x:489.574}},{t:this.shape_8,p:{x:504.324}},{t:this.shape_17,p:{x:519.1}},{t:this.shape_15,p:{x:533.85}},{t:this.shape_6,p:{x:548.574}},{t:this.shape_14,p:{x:563.35}},{t:this.shape_13,p:{x:578.1}},{t:this.shape_10,p:{x:592.8}},{t:this.shape_7,p:{x:607.6}},{t:this.shape_3,p:{x:622.324}},{t:this.shape_5,p:{x:637.1}},{t:this.shape_4,p:{x:651.85}},{t:this.shape_2,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_39,p:{x:135.55}},{t:this.shape_36,p:{x:150.3}},{t:this.shape_35,p:{x:165.05}},{t:this.shape_34,p:{x:179.824}},{t:this.shape_32,p:{x:194.55}},{t:this.shape_31,p:{x:209.3}},{t:this.shape_33,p:{x:224.074}},{t:this.shape_30,p:{x:238.8}},{t:this.shape_29,p:{x:253.524}},{t:this.shape_28,p:{x:268.324}},{t:this.shape_27,p:{x:283.05}},{t:this.shape_25,p:{x:297.774}},{t:this.shape_24,p:{x:312.574}},{t:this.shape_26,p:{x:327.3}},{t:this.shape_23,p:{x:342.05}},{t:this.shape_21,p:{x:356.824}},{t:this.shape_16,p:{x:371.574}},{t:this.shape_22,p:{x:386.3}},{t:this.shape_20,p:{x:401.1}},{t:this.shape_19,p:{x:415.8}},{t:this.shape_12,p:{x:430.574}},{t:this.shape_11,p:{x:445.324}},{t:this.shape_18,p:{x:460.05}},{t:this.shape_17,p:{x:474.85}},{t:this.shape_9,p:{x:489.574}},{t:this.shape_8,p:{x:504.324}},{t:this.shape_15,p:{x:519.1}},{t:this.shape_14,p:{x:533.85}},{t:this.shape_6,p:{x:548.574}},{t:this.shape_13,p:{x:563.35}},{t:this.shape_10,p:{x:578.1}},{t:this.shape_7,p:{x:592.8}},{t:this.shape_5,p:{x:607.6}},{t:this.shape_3,p:{x:622.324}},{t:this.shape_4,p:{x:637.1}},{t:this.shape_2,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_36,p:{x:135.55}},{t:this.shape_35,p:{x:150.3}},{t:this.shape_32,p:{x:165.05}},{t:this.shape_34,p:{x:179.824}},{t:this.shape_31,p:{x:194.55}},{t:this.shape_30,p:{x:209.3}},{t:this.shape_33,p:{x:224.074}},{t:this.shape_27,p:{x:238.8}},{t:this.shape_29,p:{x:253.524}},{t:this.shape_28,p:{x:268.324}},{t:this.shape_26,p:{x:283.05}},{t:this.shape_25,p:{x:297.774}},{t:this.shape_24,p:{x:312.574}},{t:this.shape_23,p:{x:327.3}},{t:this.shape_22,p:{x:342.05}},{t:this.shape_21,p:{x:356.824}},{t:this.shape_16,p:{x:371.574}},{t:this.shape_20,p:{x:386.3}},{t:this.shape_19,p:{x:401.1}},{t:this.shape_18,p:{x:415.8}},{t:this.shape_12,p:{x:430.574}},{t:this.shape_11,p:{x:445.324}},{t:this.shape_17,p:{x:460.05}},{t:this.shape_15,p:{x:474.85}},{t:this.shape_9,p:{x:489.574}},{t:this.shape_8,p:{x:504.324}},{t:this.shape_14,p:{x:519.1}},{t:this.shape_13,p:{x:533.85}},{t:this.shape_6,p:{x:548.574}},{t:this.shape_10,p:{x:563.35}},{t:this.shape_7,p:{x:578.1}},{t:this.shape_5,p:{x:592.8}},{t:this.shape_4,p:{x:607.6}},{t:this.shape_3,p:{x:622.324}},{t:this.shape_2,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_35,p:{x:135.55}},{t:this.shape_32,p:{x:150.3}},{t:this.shape_31,p:{x:165.05}},{t:this.shape_34,p:{x:179.824}},{t:this.shape_30,p:{x:194.55}},{t:this.shape_27,p:{x:209.3}},{t:this.shape_33,p:{x:224.074}},{t:this.shape_26,p:{x:238.8}},{t:this.shape_29,p:{x:253.524}},{t:this.shape_28,p:{x:268.324}},{t:this.shape_23,p:{x:283.05}},{t:this.shape_25,p:{x:297.774}},{t:this.shape_24,p:{x:312.574}},{t:this.shape_22,p:{x:327.3}},{t:this.shape_20,p:{x:342.05}},{t:this.shape_21,p:{x:356.824}},{t:this.shape_16,p:{x:371.574}},{t:this.shape_19,p:{x:386.3}},{t:this.shape_18,p:{x:401.1}},{t:this.shape_17,p:{x:415.8}},{t:this.shape_12,p:{x:430.574}},{t:this.shape_11,p:{x:445.324}},{t:this.shape_15,p:{x:460.05}},{t:this.shape_14,p:{x:474.85}},{t:this.shape_9,p:{x:489.574}},{t:this.shape_8,p:{x:504.324}},{t:this.shape_13,p:{x:519.1}},{t:this.shape_10,p:{x:533.85}},{t:this.shape_6,p:{x:548.574}},{t:this.shape_7,p:{x:563.35}},{t:this.shape_5,p:{x:578.1}},{t:this.shape_4,p:{x:592.8}},{t:this.shape_2,p:{x:607.6}},{t:this.shape_3,p:{x:622.324}},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_35,p:{x:135.55}},{t:this.shape_32,p:{x:150.3}},{t:this.shape_31,p:{x:165.05}},{t:this.shape_33,p:{x:179.824}},{t:this.shape_30,p:{x:194.55}},{t:this.shape_27,p:{x:209.3}},{t:this.shape_29,p:{x:224.074}},{t:this.shape_26,p:{x:238.8}},{t:this.shape_28,p:{x:253.524}},{t:this.shape_25,p:{x:268.324}},{t:this.shape_23,p:{x:283.05}},{t:this.shape_24,p:{x:297.774}},{t:this.shape_21,p:{x:312.574}},{t:this.shape_22,p:{x:327.3}},{t:this.shape_20,p:{x:342.05}},{t:this.shape_16,p:{x:356.824}},{t:this.shape_12,p:{x:371.574}},{t:this.shape_19,p:{x:386.3}},{t:this.shape_18,p:{x:401.1}},{t:this.shape_17,p:{x:415.8}},{t:this.shape_11,p:{x:430.574}},{t:this.shape_9,p:{x:445.324}},{t:this.shape_15,p:{x:460.05}},{t:this.shape_14,p:{x:474.85}},{t:this.shape_8,p:{x:489.574}},{t:this.shape_6,p:{x:504.324}},{t:this.shape_13,p:{x:519.1}},{t:this.shape_10,p:{x:533.85}},{t:this.shape_3,p:{x:548.574}},{t:this.shape_7,p:{x:563.35}},{t:this.shape_5,p:{x:578.1}},{t:this.shape_4,p:{x:592.8}},{t:this.shape_2,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_32,p:{x:135.55}},{t:this.shape_31,p:{x:150.3}},{t:this.shape_30,p:{x:165.05}},{t:this.shape_33,p:{x:179.824}},{t:this.shape_27,p:{x:194.55}},{t:this.shape_26,p:{x:209.3}},{t:this.shape_29,p:{x:224.074}},{t:this.shape_23,p:{x:238.8}},{t:this.shape_28,p:{x:253.524}},{t:this.shape_25,p:{x:268.324}},{t:this.shape_22,p:{x:283.05}},{t:this.shape_24,p:{x:297.774}},{t:this.shape_21,p:{x:312.574}},{t:this.shape_20,p:{x:327.3}},{t:this.shape_19,p:{x:342.05}},{t:this.shape_16,p:{x:356.824}},{t:this.shape_12,p:{x:371.574}},{t:this.shape_18,p:{x:386.3}},{t:this.shape_17,p:{x:401.1}},{t:this.shape_15,p:{x:415.8}},{t:this.shape_11,p:{x:430.574}},{t:this.shape_9,p:{x:445.324}},{t:this.shape_14,p:{x:460.05}},{t:this.shape_13,p:{x:474.85}},{t:this.shape_8,p:{x:489.574}},{t:this.shape_6,p:{x:504.324}},{t:this.shape_10,p:{x:519.1}},{t:this.shape_7,p:{x:533.85}},{t:this.shape_3,p:{x:548.574}},{t:this.shape_5,p:{x:563.35}},{t:this.shape_4,p:{x:578.1}},{t:this.shape_2,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_31,p:{x:135.55}},{t:this.shape_30,p:{x:150.3}},{t:this.shape_27,p:{x:165.05}},{t:this.shape_33,p:{x:179.824}},{t:this.shape_26,p:{x:194.55}},{t:this.shape_23,p:{x:209.3}},{t:this.shape_29,p:{x:224.074}},{t:this.shape_22,p:{x:238.8}},{t:this.shape_28,p:{x:253.524}},{t:this.shape_25,p:{x:268.324}},{t:this.shape_20,p:{x:283.05}},{t:this.shape_24,p:{x:297.774}},{t:this.shape_21,p:{x:312.574}},{t:this.shape_19,p:{x:327.3}},{t:this.shape_18,p:{x:342.05}},{t:this.shape_16,p:{x:356.824}},{t:this.shape_12,p:{x:371.574}},{t:this.shape_17,p:{x:386.3}},{t:this.shape_15,p:{x:401.1}},{t:this.shape_14,p:{x:415.8}},{t:this.shape_11,p:{x:430.574}},{t:this.shape_9,p:{x:445.324}},{t:this.shape_13,p:{x:460.05}},{t:this.shape_10,p:{x:474.85}},{t:this.shape_8,p:{x:489.574}},{t:this.shape_6,p:{x:504.324}},{t:this.shape_7,p:{x:519.1}},{t:this.shape_5,p:{x:533.85}},{t:this.shape_3,p:{x:548.574}},{t:this.shape_4,p:{x:563.35}},{t:this.shape_2,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_30,p:{x:135.55}},{t:this.shape_27,p:{x:150.3}},{t:this.shape_26,p:{x:165.05}},{t:this.shape_33,p:{x:179.824}},{t:this.shape_23,p:{x:194.55}},{t:this.shape_22,p:{x:209.3}},{t:this.shape_29,p:{x:224.074}},{t:this.shape_20,p:{x:238.8}},{t:this.shape_28,p:{x:253.524}},{t:this.shape_25,p:{x:268.324}},{t:this.shape_19,p:{x:283.05}},{t:this.shape_24,p:{x:297.774}},{t:this.shape_21,p:{x:312.574}},{t:this.shape_18,p:{x:327.3}},{t:this.shape_17,p:{x:342.05}},{t:this.shape_16,p:{x:356.824}},{t:this.shape_12,p:{x:371.574}},{t:this.shape_15,p:{x:386.3}},{t:this.shape_14,p:{x:401.1}},{t:this.shape_13,p:{x:415.8}},{t:this.shape_11,p:{x:430.574}},{t:this.shape_9,p:{x:445.324}},{t:this.shape_10,p:{x:460.05}},{t:this.shape_7,p:{x:474.85}},{t:this.shape_8,p:{x:489.574}},{t:this.shape_6,p:{x:504.324}},{t:this.shape_5,p:{x:519.1}},{t:this.shape_4,p:{x:533.85}},{t:this.shape_3,p:{x:548.574}},{t:this.shape_2,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_27,p:{x:135.55}},{t:this.shape_26,p:{x:150.3}},{t:this.shape_23,p:{x:165.05}},{t:this.shape_33,p:{x:179.824}},{t:this.shape_22,p:{x:194.55}},{t:this.shape_20,p:{x:209.3}},{t:this.shape_29,p:{x:224.074}},{t:this.shape_19,p:{x:238.8}},{t:this.shape_28,p:{x:253.524}},{t:this.shape_25,p:{x:268.324}},{t:this.shape_18,p:{x:283.05}},{t:this.shape_24,p:{x:297.774}},{t:this.shape_21,p:{x:312.574}},{t:this.shape_17,p:{x:327.3}},{t:this.shape_15,p:{x:342.05}},{t:this.shape_16,p:{x:356.824}},{t:this.shape_12,p:{x:371.574}},{t:this.shape_14,p:{x:386.3}},{t:this.shape_13,p:{x:401.1}},{t:this.shape_10,p:{x:415.8}},{t:this.shape_11,p:{x:430.574}},{t:this.shape_9,p:{x:445.324}},{t:this.shape_7,p:{x:460.05}},{t:this.shape_5,p:{x:474.85}},{t:this.shape_8,p:{x:489.574}},{t:this.shape_6,p:{x:504.324}},{t:this.shape_4,p:{x:519.1}},{t:this.shape_2,p:{x:533.85}},{t:this.shape_3,p:{x:548.574}},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_27,p:{x:135.55}},{t:this.shape_26,p:{x:150.3}},{t:this.shape_23,p:{x:165.05}},{t:this.shape_29,p:{x:179.824}},{t:this.shape_22,p:{x:194.55}},{t:this.shape_20,p:{x:209.3}},{t:this.shape_28,p:{x:224.074}},{t:this.shape_19,p:{x:238.8}},{t:this.shape_25,p:{x:253.524}},{t:this.shape_24,p:{x:268.324}},{t:this.shape_18,p:{x:283.05}},{t:this.shape_21,p:{x:297.774}},{t:this.shape_16,p:{x:312.574}},{t:this.shape_17,p:{x:327.3}},{t:this.shape_15,p:{x:342.05}},{t:this.shape_12,p:{x:356.824}},{t:this.shape_11,p:{x:371.574}},{t:this.shape_14,p:{x:386.3}},{t:this.shape_13,p:{x:401.1}},{t:this.shape_10,p:{x:415.8}},{t:this.shape_9,p:{x:430.574}},{t:this.shape_8,p:{x:445.324}},{t:this.shape_7,p:{x:460.05}},{t:this.shape_5,p:{x:474.85}},{t:this.shape_6,p:{x:489.574}},{t:this.shape_3,p:{x:504.324}},{t:this.shape_4,p:{x:519.1}},{t:this.shape_2,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_26,p:{x:135.55}},{t:this.shape_23,p:{x:150.3}},{t:this.shape_22,p:{x:165.05}},{t:this.shape_29,p:{x:179.824}},{t:this.shape_20,p:{x:194.55}},{t:this.shape_19,p:{x:209.3}},{t:this.shape_28,p:{x:224.074}},{t:this.shape_18,p:{x:238.8}},{t:this.shape_25,p:{x:253.524}},{t:this.shape_24,p:{x:268.324}},{t:this.shape_17,p:{x:283.05}},{t:this.shape_21,p:{x:297.774}},{t:this.shape_16,p:{x:312.574}},{t:this.shape_15,p:{x:327.3}},{t:this.shape_14,p:{x:342.05}},{t:this.shape_12,p:{x:356.824}},{t:this.shape_11,p:{x:371.574}},{t:this.shape_13,p:{x:386.3}},{t:this.shape_10,p:{x:401.1}},{t:this.shape_7,p:{x:415.8}},{t:this.shape_9,p:{x:430.574}},{t:this.shape_8,p:{x:445.324}},{t:this.shape_5,p:{x:460.05}},{t:this.shape_4,p:{x:474.85}},{t:this.shape_6,p:{x:489.574}},{t:this.shape_3,p:{x:504.324}},{t:this.shape_2,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_23,p:{x:135.55}},{t:this.shape_22,p:{x:150.3}},{t:this.shape_20,p:{x:165.05}},{t:this.shape_29,p:{x:179.824}},{t:this.shape_19,p:{x:194.55}},{t:this.shape_18,p:{x:209.3}},{t:this.shape_28,p:{x:224.074}},{t:this.shape_17,p:{x:238.8}},{t:this.shape_25,p:{x:253.524}},{t:this.shape_24,p:{x:268.324}},{t:this.shape_15,p:{x:283.05}},{t:this.shape_21,p:{x:297.774}},{t:this.shape_16,p:{x:312.574}},{t:this.shape_14,p:{x:327.3}},{t:this.shape_13,p:{x:342.05}},{t:this.shape_12,p:{x:356.824}},{t:this.shape_11,p:{x:371.574}},{t:this.shape_10,p:{x:386.3}},{t:this.shape_7,p:{x:401.1}},{t:this.shape_5,p:{x:415.8}},{t:this.shape_9,p:{x:430.574}},{t:this.shape_8,p:{x:445.324}},{t:this.shape_4,p:{x:460.05}},{t:this.shape_2,p:{x:474.85}},{t:this.shape_6,p:{x:489.574}},{t:this.shape_3,p:{x:504.324}},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_23,p:{x:135.55}},{t:this.shape_22,p:{x:150.3}},{t:this.shape_20,p:{x:165.05}},{t:this.shape_28,p:{x:179.824}},{t:this.shape_19,p:{x:194.55}},{t:this.shape_18,p:{x:209.3}},{t:this.shape_25,p:{x:224.074}},{t:this.shape_17,p:{x:238.8}},{t:this.shape_24,p:{x:253.524}},{t:this.shape_21,p:{x:268.324}},{t:this.shape_15,p:{x:283.05}},{t:this.shape_16,p:{x:297.774}},{t:this.shape_12,p:{x:312.574}},{t:this.shape_14,p:{x:327.3}},{t:this.shape_13,p:{x:342.05}},{t:this.shape_11,p:{x:356.824}},{t:this.shape_9,p:{x:371.574}},{t:this.shape_10,p:{x:386.3}},{t:this.shape_7,p:{x:401.1}},{t:this.shape_5,p:{x:415.8}},{t:this.shape_8,p:{x:430.574}},{t:this.shape_6,p:{x:445.324}},{t:this.shape_4,p:{x:460.05}},{t:this.shape_2,p:{x:474.85}},{t:this.shape_3,p:{x:489.574}},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_23,p:{x:135.55}},{t:this.shape_22,p:{x:150.3}},{t:this.shape_20,p:{x:165.05}},{t:this.shape_25,p:{x:179.824}},{t:this.shape_19,p:{x:194.55}},{t:this.shape_18,p:{x:209.3}},{t:this.shape_24,p:{x:224.074}},{t:this.shape_17,p:{x:238.8}},{t:this.shape_21,p:{x:253.524}},{t:this.shape_16,p:{x:268.324}},{t:this.shape_15,p:{x:283.05}},{t:this.shape_12,p:{x:297.774}},{t:this.shape_11,p:{x:312.574}},{t:this.shape_14,p:{x:327.3}},{t:this.shape_13,p:{x:342.05}},{t:this.shape_9,p:{x:356.824}},{t:this.shape_8,p:{x:371.574}},{t:this.shape_10,p:{x:386.3}},{t:this.shape_7,p:{x:401.1}},{t:this.shape_5,p:{x:415.8}},{t:this.shape_6,p:{x:430.574}},{t:this.shape_3,p:{x:445.324}},{t:this.shape_4,p:{x:460.05}},{t:this.shape_2,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_22,p:{x:135.55}},{t:this.shape_20,p:{x:150.3}},{t:this.shape_19,p:{x:165.05}},{t:this.shape_25,p:{x:179.824}},{t:this.shape_18,p:{x:194.55}},{t:this.shape_17,p:{x:209.3}},{t:this.shape_24,p:{x:224.074}},{t:this.shape_15,p:{x:238.8}},{t:this.shape_21,p:{x:253.524}},{t:this.shape_16,p:{x:268.324}},{t:this.shape_14,p:{x:283.05}},{t:this.shape_12,p:{x:297.774}},{t:this.shape_11,p:{x:312.574}},{t:this.shape_13,p:{x:327.3}},{t:this.shape_10,p:{x:342.05}},{t:this.shape_9,p:{x:356.824}},{t:this.shape_8,p:{x:371.574}},{t:this.shape_7,p:{x:386.3}},{t:this.shape_5,p:{x:401.1}},{t:this.shape_4,p:{x:415.8}},{t:this.shape_6,p:{x:430.574}},{t:this.shape_3,p:{x:445.324}},{t:this.shape_2,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_20,p:{x:135.55}},{t:this.shape_19,p:{x:150.3}},{t:this.shape_18,p:{x:165.05}},{t:this.shape_25,p:{x:179.824}},{t:this.shape_17,p:{x:194.55}},{t:this.shape_15,p:{x:209.3}},{t:this.shape_24,p:{x:224.074}},{t:this.shape_14,p:{x:238.8}},{t:this.shape_21,p:{x:253.524}},{t:this.shape_16,p:{x:268.324}},{t:this.shape_13,p:{x:283.05}},{t:this.shape_12,p:{x:297.774}},{t:this.shape_11,p:{x:312.574}},{t:this.shape_10,p:{x:327.3}},{t:this.shape_7,p:{x:342.05}},{t:this.shape_9,p:{x:356.824}},{t:this.shape_8,p:{x:371.574}},{t:this.shape_5,p:{x:386.3}},{t:this.shape_4,p:{x:401.1}},{t:this.shape_2,p:{x:415.8}},{t:this.shape_6,p:{x:430.574}},{t:this.shape_3,p:{x:445.324}},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_20,p:{x:135.55}},{t:this.shape_19,p:{x:150.3}},{t:this.shape_18,p:{x:165.05}},{t:this.shape_24,p:{x:179.824}},{t:this.shape_17,p:{x:194.55}},{t:this.shape_15,p:{x:209.3}},{t:this.shape_21,p:{x:224.074}},{t:this.shape_14,p:{x:238.8}},{t:this.shape_16,p:{x:253.524}},{t:this.shape_12,p:{x:268.324}},{t:this.shape_13,p:{x:283.05}},{t:this.shape_11,p:{x:297.774}},{t:this.shape_9,p:{x:312.574}},{t:this.shape_10,p:{x:327.3}},{t:this.shape_7,p:{x:342.05}},{t:this.shape_8,p:{x:356.824}},{t:this.shape_6,p:{x:371.574}},{t:this.shape_5,p:{x:386.3}},{t:this.shape_4,p:{x:401.1}},{t:this.shape_2,p:{x:415.8}},{t:this.shape_3,p:{x:430.574}},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_20,p:{x:135.55}},{t:this.shape_19,p:{x:150.3}},{t:this.shape_18,p:{x:165.05}},{t:this.shape_21,p:{x:179.824}},{t:this.shape_17,p:{x:194.55}},{t:this.shape_15,p:{x:209.3}},{t:this.shape_16,p:{x:224.074}},{t:this.shape_14,p:{x:238.8}},{t:this.shape_12,p:{x:253.524}},{t:this.shape_11,p:{x:268.324}},{t:this.shape_13,p:{x:283.05}},{t:this.shape_9,p:{x:297.774}},{t:this.shape_8,p:{x:312.574}},{t:this.shape_10,p:{x:327.3}},{t:this.shape_7,p:{x:342.05}},{t:this.shape_6,p:{x:356.824}},{t:this.shape_3,p:{x:371.574}},{t:this.shape_5,p:{x:386.3}},{t:this.shape_4,p:{x:401.1}},{t:this.shape_2,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_19,p:{x:135.55}},{t:this.shape_18,p:{x:150.3}},{t:this.shape_17,p:{x:165.05}},{t:this.shape_21,p:{x:179.824}},{t:this.shape_15,p:{x:194.55}},{t:this.shape_14,p:{x:209.3}},{t:this.shape_16,p:{x:224.074}},{t:this.shape_13,p:{x:238.8}},{t:this.shape_12,p:{x:253.524}},{t:this.shape_11,p:{x:268.324}},{t:this.shape_10,p:{x:283.05}},{t:this.shape_9,p:{x:297.774}},{t:this.shape_8,p:{x:312.574}},{t:this.shape_7,p:{x:327.3}},{t:this.shape_5,p:{x:342.05}},{t:this.shape_6,p:{x:356.824}},{t:this.shape_3,p:{x:371.574}},{t:this.shape_4,p:{x:386.3}},{t:this.shape_2,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_18,p:{x:135.55}},{t:this.shape_17,p:{x:150.3}},{t:this.shape_15,p:{x:165.05}},{t:this.shape_21,p:{x:179.824}},{t:this.shape_14,p:{x:194.55}},{t:this.shape_13,p:{x:209.3}},{t:this.shape_16,p:{x:224.074}},{t:this.shape_10,p:{x:238.8}},{t:this.shape_12,p:{x:253.524}},{t:this.shape_11,p:{x:268.324}},{t:this.shape_7,p:{x:283.05}},{t:this.shape_9,p:{x:297.774}},{t:this.shape_8,p:{x:312.574}},{t:this.shape_5,p:{x:327.3}},{t:this.shape_4,p:{x:342.05}},{t:this.shape_6,p:{x:356.824}},{t:this.shape_3,p:{x:371.574}},{t:this.shape_2,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_17,p:{x:135.55}},{t:this.shape_15,p:{x:150.3}},{t:this.shape_14,p:{x:165.05}},{t:this.shape_21,p:{x:179.824}},{t:this.shape_13,p:{x:194.55}},{t:this.shape_10,p:{x:209.3}},{t:this.shape_16,p:{x:224.074}},{t:this.shape_7,p:{x:238.8}},{t:this.shape_12,p:{x:253.524}},{t:this.shape_11,p:{x:268.324}},{t:this.shape_5,p:{x:283.05}},{t:this.shape_9,p:{x:297.774}},{t:this.shape_8,p:{x:312.574}},{t:this.shape_4,p:{x:327.3}},{t:this.shape_2,p:{x:342.05}},{t:this.shape_6,p:{x:356.824}},{t:this.shape_3,p:{x:371.574}},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_17,p:{x:135.55}},{t:this.shape_15,p:{x:150.3}},{t:this.shape_14,p:{x:165.05}},{t:this.shape_16,p:{x:179.824}},{t:this.shape_13,p:{x:194.55}},{t:this.shape_10,p:{x:209.3}},{t:this.shape_12,p:{x:224.074}},{t:this.shape_7,p:{x:238.8}},{t:this.shape_11,p:{x:253.524}},{t:this.shape_9,p:{x:268.324}},{t:this.shape_5,p:{x:283.05}},{t:this.shape_8,p:{x:297.774}},{t:this.shape_6,p:{x:312.574}},{t:this.shape_4,p:{x:327.3}},{t:this.shape_2,p:{x:342.05}},{t:this.shape_3,p:{x:356.824}},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_17,p:{x:135.55}},{t:this.shape_15,p:{x:150.3}},{t:this.shape_14,p:{x:165.05}},{t:this.shape_12,p:{x:179.824}},{t:this.shape_13,p:{x:194.55}},{t:this.shape_10,p:{x:209.3}},{t:this.shape_11,p:{x:224.074}},{t:this.shape_7,p:{x:238.8}},{t:this.shape_9,p:{x:253.524}},{t:this.shape_8,p:{x:268.324}},{t:this.shape_5,p:{x:283.05}},{t:this.shape_6,p:{x:297.774}},{t:this.shape_3,p:{x:312.574}},{t:this.shape_4,p:{x:327.3}},{t:this.shape_2,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_15,p:{x:135.55}},{t:this.shape_14,p:{x:150.3}},{t:this.shape_13,p:{x:165.05}},{t:this.shape_12,p:{x:179.824}},{t:this.shape_10,p:{x:194.55}},{t:this.shape_7,p:{x:209.3}},{t:this.shape_11,p:{x:224.074}},{t:this.shape_5,p:{x:238.8}},{t:this.shape_9,p:{x:253.524}},{t:this.shape_8,p:{x:268.324}},{t:this.shape_4,p:{x:283.05}},{t:this.shape_6,p:{x:297.774}},{t:this.shape_3,p:{x:312.574}},{t:this.shape_2,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_14,p:{x:135.55}},{t:this.shape_13,p:{x:150.3}},{t:this.shape_10,p:{x:165.05}},{t:this.shape_12,p:{x:179.824}},{t:this.shape_7,p:{x:194.55}},{t:this.shape_5,p:{x:209.3}},{t:this.shape_11,p:{x:224.074}},{t:this.shape_4,p:{x:238.8}},{t:this.shape_9,p:{x:253.524}},{t:this.shape_8,p:{x:268.324}},{t:this.shape_2,p:{x:283.05}},{t:this.shape_6,p:{x:297.774}},{t:this.shape_3,p:{x:312.574}},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_14,p:{x:135.55}},{t:this.shape_13,p:{x:150.3}},{t:this.shape_10,p:{x:165.05}},{t:this.shape_11,p:{x:179.824}},{t:this.shape_7,p:{x:194.55}},{t:this.shape_5,p:{x:209.3}},{t:this.shape_9,p:{x:224.074}},{t:this.shape_4,p:{x:238.8}},{t:this.shape_8,p:{x:253.524}},{t:this.shape_6,p:{x:268.324}},{t:this.shape_2,p:{x:283.05}},{t:this.shape_3,p:{x:297.774}},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_14,p:{x:135.55}},{t:this.shape_13,p:{x:150.3}},{t:this.shape_10,p:{x:165.05}},{t:this.shape_9,p:{x:179.824}},{t:this.shape_7,p:{x:194.55}},{t:this.shape_5,p:{x:209.3}},{t:this.shape_8,p:{x:224.074}},{t:this.shape_4,p:{x:238.8}},{t:this.shape_6,p:{x:253.524}},{t:this.shape_3,p:{x:268.324}},{t:this.shape_2,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_13,p:{x:135.55}},{t:this.shape_10,p:{x:150.3}},{t:this.shape_7,p:{x:165.05}},{t:this.shape_9,p:{x:179.824}},{t:this.shape_5,p:{x:194.55}},{t:this.shape_4,p:{x:209.3}},{t:this.shape_8,p:{x:224.074}},{t:this.shape_2,p:{x:238.8}},{t:this.shape_6,p:{x:253.524}},{t:this.shape_3,p:{x:268.324}},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_13,p:{x:135.55}},{t:this.shape_10,p:{x:150.3}},{t:this.shape_7,p:{x:165.05}},{t:this.shape_8,p:{x:179.824}},{t:this.shape_5,p:{x:194.55}},{t:this.shape_4,p:{x:209.3}},{t:this.shape_6,p:{x:224.074}},{t:this.shape_2,p:{x:238.8}},{t:this.shape_3,p:{x:253.524}},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_13,p:{x:135.55}},{t:this.shape_10,p:{x:150.3}},{t:this.shape_7,p:{x:165.05}},{t:this.shape_6,p:{x:179.824}},{t:this.shape_5,p:{x:194.55}},{t:this.shape_4,p:{x:209.3}},{t:this.shape_3,p:{x:224.074}},{t:this.shape_2,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_10,p:{x:135.55}},{t:this.shape_7,p:{x:150.3}},{t:this.shape_5,p:{x:165.05}},{t:this.shape_6,p:{x:179.824}},{t:this.shape_4,p:{x:194.55}},{t:this.shape_2,p:{x:209.3}},{t:this.shape_3,p:{x:224.074}},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_10,p:{x:135.55}},{t:this.shape_7,p:{x:150.3}},{t:this.shape_5,p:{x:165.05}},{t:this.shape_3,p:{x:179.824}},{t:this.shape_4,p:{x:194.55}},{t:this.shape_2,p:{x:209.3}},{t:this.shape_91},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_7,p:{x:135.55}},{t:this.shape_5,p:{x:150.3}},{t:this.shape_4,p:{x:165.05}},{t:this.shape_3,p:{x:179.824}},{t:this.shape_2,p:{x:194.55}},{t:this.shape_92,p:{x:209.3}},{t:this.shape_91},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_5,p:{x:135.55}},{t:this.shape_4,p:{x:150.3}},{t:this.shape_2,p:{x:165.05}},{t:this.shape_3,p:{x:179.824}},{t:this.shape_93,p:{x:194.55}},{t:this.shape_92,p:{x:209.3}},{t:this.shape_91},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_5,p:{x:135.55}},{t:this.shape_4,p:{x:150.3}},{t:this.shape_2,p:{x:165.05}},{t:this.shape_94},{t:this.shape_93,p:{x:194.55}},{t:this.shape_92,p:{x:209.3}},{t:this.shape_91},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_4,p:{x:135.55}},{t:this.shape_2,p:{x:150.3}},{t:this.shape_95,p:{x:165.05}},{t:this.shape_94},{t:this.shape_93,p:{x:194.55}},{t:this.shape_92,p:{x:209.3}},{t:this.shape_91},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_2,p:{x:135.55}},{t:this.shape_96,p:{x:150.3}},{t:this.shape_95,p:{x:165.05}},{t:this.shape_94},{t:this.shape_93,p:{x:194.55}},{t:this.shape_92,p:{x:209.3}},{t:this.shape_91},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_97,p:{x:135.55}},{t:this.shape_96,p:{x:150.3}},{t:this.shape_95,p:{x:165.05}},{t:this.shape_94},{t:this.shape_93,p:{x:194.55}},{t:this.shape_92,p:{x:209.3}},{t:this.shape_91},{t:this.shape_90,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84,p:{x:327.3}},{t:this.shape_83,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80,p:{x:386.3}},{t:this.shape_79,p:{x:401.1}},{t:this.shape_78,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75,p:{x:460.05}},{t:this.shape_74,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71,p:{x:519.1}},{t:this.shape_70,p:{x:533.85}},{t:this.shape_69},{t:this.shape_68,p:{x:563.35}},{t:this.shape_67,p:{x:578.1}},{t:this.shape_66,p:{x:592.8}},{t:this.shape_65,p:{x:607.6}},{t:this.shape_64},{t:this.shape_63,p:{x:637.1}},{t:this.shape_62,p:{x:651.85}},{t:this.shape_61,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55,p:{x:755.1}},{t:this.shape_54},{t:this.shape_53,p:{x:784.6}},{t:this.shape_52,p:{x:799.35}},{t:this.shape_51},{t:this.shape_50,p:{x:828.85}},{t:this.shape_1},{t:this.shape,p:{x:120.45}}]},1).to({state:[{t:this.shape_98,p:{x:135.55}},{t:this.shape_97,p:{x:150.3}},{t:this.shape_96,p:{x:165.05}},{t:this.shape_94},{t:this.shape_95,p:{x:194.55}},{t:this.shape_93,p:{x:209.3}},{t:this.shape_91},{t:this.shape_92,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_90,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_87,p:{x:327.3}},{t:this.shape_84,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_83,p:{x:386.3}},{t:this.shape_80,p:{x:401.1}},{t:this.shape_79,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_78,p:{x:460.05}},{t:this.shape_75,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_74,p:{x:519.1}},{t:this.shape_71,p:{x:533.85}},{t:this.shape_69},{t:this.shape_70,p:{x:563.35}},{t:this.shape_68,p:{x:578.1}},{t:this.shape_67,p:{x:592.8}},{t:this.shape_66,p:{x:607.6}},{t:this.shape_64},{t:this.shape_65,p:{x:637.1}},{t:this.shape_63,p:{x:651.85}},{t:this.shape_62,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_61,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_58,p:{x:755.1}},{t:this.shape_54},{t:this.shape_55,p:{x:784.6}},{t:this.shape_53,p:{x:799.35}},{t:this.shape_51},{t:this.shape_52,p:{x:828.85}},{t:this.shape,p:{x:105.7}},{t:this.shape_50,p:{x:120.45}}]},1).to({state:[{t:this.shape_99},{t:this.shape_98,p:{x:150.3}},{t:this.shape_97,p:{x:165.05}},{t:this.shape_94},{t:this.shape_96,p:{x:194.55}},{t:this.shape_95,p:{x:209.3}},{t:this.shape_91},{t:this.shape_93,p:{x:238.8}},{t:this.shape_89},{t:this.shape_88},{t:this.shape_92,p:{x:283.05}},{t:this.shape_86},{t:this.shape_85},{t:this.shape_90,p:{x:327.3}},{t:this.shape_87,p:{x:342.05}},{t:this.shape_82},{t:this.shape_81},{t:this.shape_84,p:{x:386.3}},{t:this.shape_83,p:{x:401.1}},{t:this.shape_80,p:{x:415.8}},{t:this.shape_77},{t:this.shape_76},{t:this.shape_79,p:{x:460.05}},{t:this.shape_78,p:{x:474.85}},{t:this.shape_73},{t:this.shape_72},{t:this.shape_75,p:{x:519.1}},{t:this.shape_74,p:{x:533.85}},{t:this.shape_69},{t:this.shape_71,p:{x:563.35}},{t:this.shape_70,p:{x:578.1}},{t:this.shape_68,p:{x:592.8}},{t:this.shape_67,p:{x:607.6}},{t:this.shape_64},{t:this.shape_66,p:{x:637.1}},{t:this.shape_65,p:{x:651.85}},{t:this.shape_63,p:{x:666.6}},{t:this.shape_60},{t:this.shape_59},{t:this.shape_62,p:{x:710.85}},{t:this.shape_57},{t:this.shape_56},{t:this.shape_61,p:{x:755.1}},{t:this.shape_54},{t:this.shape_58,p:{x:784.6}},{t:this.shape_55,p:{x:799.35}},{t:this.shape_51},{t:this.shape_53,p:{x:828.85}},{t:this.shape_52,p:{x:105.7}},{t:this.shape_50,p:{x:120.45}}]},1).wait(1));

	// Layer_1
	this.shape_100 = new cjs.Shape();
	this.shape_100.graphics.f("rgba(27,41,52,0.749)").s().p("Eg7ZADsIAAnXMB2zAAAIAAHXg");
	this.shape_100.setTransform(502.006,23.575,1.3204,1);

	this.timeline.addTween(cjs.Tween.get(this.shape_100).wait(51));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1004,47.2);


(lib.AnswerShineMC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.lf(["rgba(255,247,224,0.4)","rgba(255,255,255,0)"],[0,1],-50.1,17.2,50.1,-17.3).s().p("Au2xsIPqlYMAODAowIvqFZg");
	this.shape.setTransform(95.1,147.725);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.AnswerShineMC, new cjs.Rectangle(0,0,190.2,295.5), null);


(lib.ReturnButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// BAck
	this.backLabel = new cjs.Text("BACK", "18px 'Arial'", "#FFFFFF");
	this.backLabel.name = "backLabel";
	this.backLabel.textAlign = "center";
	this.backLabel.lineHeight = 18;
	this.backLabel.lineWidth = 58;
	this.backLabel.parent = this;
	this.backLabel.setTransform(44,16);
ranj.TextOffsetFixer.fix(this.backLabel);

	this.timeline.addTween(cjs.Tween.get(this.backLabel).wait(4));

	// Layer_3
	this.instance = new lib.DialogBackButtonUp();
	this.instance.setTransform(13,7);

	this.instance_1 = new lib.DialogBackButtonDown();
	this.instance_1.setTransform(13,7);

	this.instance_2 = new lib.DialogBackButtonDisabled();
	this.instance_2.setTransform(13,7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// BG
	this.instance_3 = new lib.DialogBackBackground();

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,89,47);


(lib.BackButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// BAck
	this.endLabel = new cjs.Text("END", "18px 'Arial'", "#FFFFFF");
	this.endLabel.name = "endLabel";
	this.endLabel.textAlign = "center";
	this.endLabel.lineHeight = 18;
	this.endLabel.lineWidth = 58;
	this.endLabel.parent = this;
	this.endLabel.setTransform(44,16);
ranj.TextOffsetFixer.fix(this.endLabel);

	this.timeline.addTween(cjs.Tween.get(this.endLabel).wait(4));

	// Layer_3
	this.instance = new lib.DialogBackButtonUp();
	this.instance.setTransform(13,7);

	this.instance_1 = new lib.DialogBackButtonDown();
	this.instance_1.setTransform(13,7);

	this.instance_2 = new lib.DialogBackButtonDisabled();
	this.instance_2.setTransform(13,7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// BG
	this.instance_3 = new lib.DialogBackBackground();

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,89,47);


(lib.DecisionImageContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-481,-541,962,1082);


(lib.DecisionButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,selectedUp:4,"selectedOver":5,selectedDown:6,selectedDisabled:7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// selectedDisabledLabelTextField
	this.selectedDisabledLabelTextField = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#A79EB1");
	this.selectedDisabledLabelTextField.name = "selectedDisabledLabelTextField";
	this.selectedDisabledLabelTextField.lineHeight = 21;
	this.selectedDisabledLabelTextField.lineWidth = 608;
	this.selectedDisabledLabelTextField.parent = this;
	this.selectedDisabledLabelTextField.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField).wait(8));

	// selectedDownLabelTextField
	this.selectedDisabledLabelTextField_1 = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#FFFFFF");
	this.selectedDisabledLabelTextField_1.name = "selectedDisabledLabelTextField_1";
	this.selectedDisabledLabelTextField_1.lineHeight = 21;
	this.selectedDisabledLabelTextField_1.lineWidth = 608;
	this.selectedDisabledLabelTextField_1.parent = this;
	this.selectedDisabledLabelTextField_1.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField_1);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField_1).wait(8));

	// selectedOverLabelTextField
	this.selectedDisabledLabelTextField_2 = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#A79EB1");
	this.selectedDisabledLabelTextField_2.name = "selectedDisabledLabelTextField_2";
	this.selectedDisabledLabelTextField_2.lineHeight = 21;
	this.selectedDisabledLabelTextField_2.lineWidth = 608;
	this.selectedDisabledLabelTextField_2.parent = this;
	this.selectedDisabledLabelTextField_2.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField_2);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField_2).wait(8));

	// selectedUpLabelTextField
	this.selectedDisabledLabelTextField_3 = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#2C3C3C");
	this.selectedDisabledLabelTextField_3.name = "selectedDisabledLabelTextField_3";
	this.selectedDisabledLabelTextField_3.lineHeight = 21;
	this.selectedDisabledLabelTextField_3.lineWidth = 608;
	this.selectedDisabledLabelTextField_3.parent = this;
	this.selectedDisabledLabelTextField_3.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField_3);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField_3).wait(8));

	// disabledLabelTextField
	this.selectedDisabledLabelTextField_4 = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#A79EB1");
	this.selectedDisabledLabelTextField_4.name = "selectedDisabledLabelTextField_4";
	this.selectedDisabledLabelTextField_4.lineHeight = 21;
	this.selectedDisabledLabelTextField_4.lineWidth = 608;
	this.selectedDisabledLabelTextField_4.parent = this;
	this.selectedDisabledLabelTextField_4.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField_4);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField_4).wait(8));

	// downLabelTextField
	this.selectedDisabledLabelTextField_5 = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#FFFFFF");
	this.selectedDisabledLabelTextField_5.name = "selectedDisabledLabelTextField_5";
	this.selectedDisabledLabelTextField_5.lineHeight = 21;
	this.selectedDisabledLabelTextField_5.lineWidth = 608;
	this.selectedDisabledLabelTextField_5.parent = this;
	this.selectedDisabledLabelTextField_5.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField_5);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField_5).wait(8));

	// overLabelTextField
	this.selectedDisabledLabelTextField_6 = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#A79EB1");
	this.selectedDisabledLabelTextField_6.name = "selectedDisabledLabelTextField_6";
	this.selectedDisabledLabelTextField_6.lineHeight = 21;
	this.selectedDisabledLabelTextField_6.lineWidth = 608;
	this.selectedDisabledLabelTextField_6.parent = this;
	this.selectedDisabledLabelTextField_6.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField_6);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField_6).wait(8));

	// upLabelTextField
	this.selectedDisabledLabelTextField_7 = new cjs.Text("Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet", "24px 'Work Sans'", "#2C3C3C");
	this.selectedDisabledLabelTextField_7.name = "selectedDisabledLabelTextField_7";
	this.selectedDisabledLabelTextField_7.lineHeight = 21;
	this.selectedDisabledLabelTextField_7.lineWidth = 608;
	this.selectedDisabledLabelTextField_7.parent = this;
	this.selectedDisabledLabelTextField_7.setTransform(-277,-44);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField_7);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField_7).wait(8));

	// vinkje
	this.instance = new lib.Vinkje();
	this.instance.setTransform(-320,-35);

	this.instance_1 = new lib.VinkjeHi();
	this.instance_1.setTransform(-320,-35);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance}]},4).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},2).wait(1));

	// BG
	this.instance_2 = new lib.DecisionButtonUp();
	this.instance_2.setTransform(-348,-65);

	this.instance_3 = new lib.DecisionButtonHi();
	this.instance_3.setTransform(-348,-61);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2,p:{y:-65}}]}).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_2,p:{y:-61}}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_2,p:{y:-61}}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-348,-65,724,196.5);


(lib.BriefingBackground_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiV/hUXMEr/AAAMAAACovMkr/AAAg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#CCCCCC").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BriefingBackground_1, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.PoiCharacterIconContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.PoIPLocationDummy();
	this.instance.setTransform(-41,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PoiCharacterIconContainer, new cjs.Rectangle(-41,-65,82,130), null);


(lib.MapLocationNode = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.instance = new lib.MapNode();
	this.instance.setTransform(-19,-19);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MapLocationNode, new cjs.Rectangle(-19,-19,35,34), null);


(lib.MapLocationCharacterMenuItemLabel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("[Location]", "18px 'Work Sans'");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 26;
	this.disabledLabelTextField.lineWidth = 279;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-128.85,-21.8);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(1));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("[Location]", "18px 'Work Sans'");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 26;
	this.downLabelTextField.lineWidth = 279;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-128.85,-21.8);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(1));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("[Location]", "18px 'Work Sans'");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 26;
	this.overLabelTextField.lineWidth = 279;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-128.85,-21.8);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(1));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("[Location]", "18px 'Work Sans'");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 26;
	this.upLabelTextField.lineWidth = 279;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-128.85,-21.8);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(1));

	// PoILTextLabelBGSmallWhite_png
	this.instance = new lib.PoILTextLabelBGSmallWhite();
	this.instance.setTransform(-177.5,-40);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MapLocationCharacterMenuItemLabel, new cjs.Rectangle(-177.5,-40,355,70), null);


(lib.TrendDownRed_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TrendDownRed();

	this.instance_1 = new lib.TrendUpRed_1();
	this.instance_1.setTransform(7.5,8,1,1,0,0,0,7.5,8);

	this.instance_2 = new lib.TrendUpGreen_1();
	this.instance_2.setTransform(7.6,8,1,1,0,0,0,8,8);

	this.instance_3 = new lib.TrendDownGreen_1();
	this.instance_3.setTransform(7.5,8,1,1,0,0,0,7.5,8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-0.4,0,19.4,19);


(lib.timerKeyDecision = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// TextRegular
	this.textField = new cjs.Text("Soft push text goes here\nSoft push text goes here", "18px 'Work Sans'", "#FFFFFF");
	this.textField.name = "textField";
	this.textField.lineHeight = 23;
	this.textField.lineWidth = 247;
	this.textField.parent = this;
	this.textField.setTransform(33,2.35);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(2));

	// Layer_1
	this.timerKeyDecision_Neutral = new lib.timerKeyDecision_Neutral_1();
	this.timerKeyDecision_Neutral.name = "timerKeyDecision_Neutral";
	this.timerKeyDecision_Neutral.setTransform(164.45,27.6,1,1,0,0,0,170.5,29.5);

	this.timerKeyDecision_Urgent = new lib.timerKeyDecision_Urgent_1();
	this.timerKeyDecision_Urgent.name = "timerKeyDecision_Urgent";
	this.timerKeyDecision_Urgent.setTransform(164.65,27.15,1,1,0,0,0,171,29);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.timerKeyDecision_Neutral}]}).to({state:[{t:this.timerKeyDecision_Urgent}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.3,-1.9,385.3,107.10000000000001);


(lib.TabButtonPlanComposer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,"selecteUp":4,"selectedOver":5,"SelectedDown":6,"SelectedDisabled":7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// SelectedUpLabelTextField
	this.selectedUpLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#324141");
	this.selectedUpLabelTextField.name = "selectedUpLabelTextField";
	this.selectedUpLabelTextField.lineHeight = 28;
	this.selectedUpLabelTextField.lineWidth = 319;
	this.selectedUpLabelTextField.parent = this;
	this.selectedUpLabelTextField.setTransform(34.45,-14.85);
ranj.TextOffsetFixer.fix(this.selectedUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedUpLabelTextField).wait(8));

	// SelectedDisabledLabelTextField
	this.selectedDisabledLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#295B6D");
	this.selectedDisabledLabelTextField.name = "selectedDisabledLabelTextField";
	this.selectedDisabledLabelTextField.lineHeight = 28;
	this.selectedDisabledLabelTextField.lineWidth = 319;
	this.selectedDisabledLabelTextField.parent = this;
	this.selectedDisabledLabelTextField.setTransform(34.45,-14.85);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField).wait(8));

	// SelectedDownLabelTextField
	this.selectedDownLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#324141");
	this.selectedDownLabelTextField.name = "selectedDownLabelTextField";
	this.selectedDownLabelTextField.lineHeight = 28;
	this.selectedDownLabelTextField.lineWidth = 319;
	this.selectedDownLabelTextField.parent = this;
	this.selectedDownLabelTextField.setTransform(34.45,-14.85);
ranj.TextOffsetFixer.fix(this.selectedDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDownLabelTextField).wait(8));

	// SelectedOverLabelTextField
	this.selectedOverLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#324141");
	this.selectedOverLabelTextField.name = "selectedOverLabelTextField";
	this.selectedOverLabelTextField.lineHeight = 28;
	this.selectedOverLabelTextField.lineWidth = 319;
	this.selectedOverLabelTextField.parent = this;
	this.selectedOverLabelTextField.setTransform(34.45,-14.85);
ranj.TextOffsetFixer.fix(this.selectedOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedOverLabelTextField).wait(8));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#324141");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 28;
	this.upLabelTextField.lineWidth = 319;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(34.45,-14.85);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(8));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#295B6D");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 28;
	this.disabledLabelTextField.lineWidth = 319;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(34.45,-14.85);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(8));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 28;
	this.downLabelTextField.lineWidth = 319;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(34.45,-14.85);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(8));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "bold 26px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 28;
	this.overLabelTextField.lineWidth = 319;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(34.45,-14.85);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(8));

	// Layer_1
	this.instance = new lib.PlanComposerKeyDecision_InactiveTab();
	this.instance.setTransform(194.5,34.55,1,1,0,0,0,194.5,33.5);

	this.instance_1 = new lib.PlanComposerKeyDecision_TabHover();
	this.instance_1.setTransform(194.5,35.05,1,1,0,0,0,194.5,34);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#295B6D").s().p("Egi8AFDIAAqFMBF4AAAIAAKFg");
	this.shape.setTransform(223.65,18.075);

	this.instance_2 = new lib.PlanComposerKeyDecision_ActiveTab();
	this.instance_2.setTransform(194.5,33.5,1,1,0,0,0,194.5,33.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.shape}]},2).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.shape}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-16.8,447.3,85.8);


(lib.NewKDAnim = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.newKeyDecision = new lib.newKeyDecIcon();
	this.newKeyDecision.name = "newKeyDecision";
	this.newKeyDecision.setTransform(106.8,18.7,0.0678,0.0678,0,0,0,25.1,22.9);
	this.newKeyDecision._off = true;

	this.timeline.addTween(cjs.Tween.get(this.newKeyDecision).wait(49).to({_off:false},0).to({regX:25,regY:22.5,scaleX:1,scaleY:1,y:18.65},10).wait(56));

	// Layer_1
	this.instance = new lib.Tween2("synched",0);
	this.instance.setTransform(23.95,39.4,1.3159,1.3159,-52.7013,0,0,0.4,0.4);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:0,regY:0,scaleX:0.8,scaleY:0.8,rotation:0,x:56.5,y:54.5},19).to({scaleX:1,scaleY:1},30).to({scaleX:0.8,scaleY:0.8},30).to({scaleX:1,scaleY:1},35).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-78.8,-63.1,210.60000000000002,205.2);


(lib.HubTimeline = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.keyDecisionsContainer = new lib.HubKeyDecisionNotificationContainer();
	this.keyDecisionsContainer.name = "keyDecisionsContainer";
	this.keyDecisionsContainer.setTransform(167.85,229.75);

	this.instance = new lib.TimelineBG();
	this.instance.setTransform(118.45,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.keyDecisionsContainer}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubTimeline, new cjs.Rectangle(118.5,0,29,577), null);


(lib.FeedbackTooltipBodyWhite = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.ToolTipPointer = new lib.FeedbackPlayerChoiceTooltip();
	this.ToolTipPointer.name = "ToolTipPointer";
	this.ToolTipPointer.setTransform(370.5,349.05,1,1,0,0,0,29,23.5);

	this.timeline.addTween(cjs.Tween.get(this.ToolTipPointer).wait(1));

	// Layer_1
	this.ToolTipContainer = new lib.ToolTipWhiteContainer();
	this.ToolTipContainer.name = "ToolTipContainer";
	this.ToolTipContainer.setTransform(370.5,169,1,1,0,0,0,370.5,169);

	this.timeline.addTween(cjs.Tween.get(this.ToolTipContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTooltipBodyWhite, new cjs.Rectangle(0,0,741,387.6), null);


(lib.FeedbackTooltipBodyBlack = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.ToolTipPointer = new lib.FeedbackOptimalTooltip();
	this.ToolTipPointer.name = "ToolTipPointer";
	this.ToolTipPointer.setTransform(370.5,352.25,1,1,0,0,0,30,23.5);

	this.timeline.addTween(cjs.Tween.get(this.ToolTipPointer).wait(1));

	// Layer_1
	this.ToolTipContainer = new lib.ToolTipBlackContainer();
	this.ToolTipContainer.name = "ToolTipContainer";
	this.ToolTipContainer.setTransform(370.5,169,1,1,0,0,0,370.5,169);

	this.timeline.addTween(cjs.Tween.get(this.ToolTipContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTooltipBodyBlack, new cjs.Rectangle(0,0,741,375.8), null);


(lib.FeedbackOptimalStars = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackStarOptimal();
	this.instance.setTransform(43.4,9,1,1,0,0,0,9,9);

	this.instance_1 = new lib.FeedbackStarOptimal();
	this.instance_1.setTransform(26.2,-11.35,1,1,0,0,0,9,9);

	this.instance_2 = new lib.FeedbackStarOptimal();
	this.instance_2.setTransform(9,9,1,1,0,0,0,9,9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackOptimalStars, new cjs.Rectangle(0,-20.3,52.4,38.3), null);


(lib.FeedbackMediumStars = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackStarFilled();
	this.instance.setTransform(26.2,-11.35,1,1,0,0,0,9,9);

	this.instance_1 = new lib.FeedbackStarEmpty();
	this.instance_1.setTransform(43.4,9,1,1,0,0,0,9,9);

	this.instance_2 = new lib.FeedbackStarFilled();
	this.instance_2.setTransform(9,9,1,1,0,0,0,9,9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackMediumStars, new cjs.Rectangle(0,-20.3,52.4,38.3), null);


(lib.FeedbackKDstates = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.FeedbackInactiveKD = new lib.FeedbackInactiveKD_1();
	this.FeedbackInactiveKD.name = "FeedbackInactiveKD";
	this.FeedbackInactiveKD.setTransform(38.5,86.5,1,1,0,0,0,38.5,38.5);

	this.FeedbackActiveKDPlayerChoice = new lib.FeedbackActiveKDPlayerChoice();
	this.FeedbackActiveKDPlayerChoice.name = "FeedbackActiveKDPlayerChoice";
	this.FeedbackActiveKDPlayerChoice.setTransform(104.85,87.95,1,1,0,0,0,139.5,73.5);

	this.FeedbackActiveKDOptimal = new lib.FeedbackActiveKDOptimal();
	this.FeedbackActiveKDOptimal.name = "FeedbackActiveKDOptimal";
	this.FeedbackActiveKDOptimal.setTransform(104.85,87.95,1,1,0,0,0,139.5,73.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.FeedbackInactiveKD}]}).to({state:[{t:this.FeedbackInactiveKD},{t:this.FeedbackActiveKDPlayerChoice}]},1).to({state:[{t:this.FeedbackInactiveKD},{t:this.FeedbackActiveKDPlayerChoice},{t:this.FeedbackActiveKDOptimal}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-34.6,14.5,279,147);


(lib.FeedbackInactiveKDstate = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.buttonFeedbackInactive = new lib.FeedbackKDInactiveButton();
	this.buttonFeedbackInactive.name = "buttonFeedbackInactive";
	this.buttonFeedbackInactive.setTransform(24,24.5,1,1,0,0,0,30,28.5);

	this.timeline.addTween(cjs.Tween.get(this.buttonFeedbackInactive).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackInactiveKDstate, new cjs.Rectangle(0,0,48,49), null);


(lib.FeedbackGoodStars = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackStarFilled();
	this.instance.setTransform(43.4,9,1,1,0,0,0,9,9);

	this.instance_1 = new lib.FeedbackStarFilled();
	this.instance_1.setTransform(26.2,-11.35,1,1,0,0,0,9,9);

	this.instance_2 = new lib.FeedbackStarFilled();
	this.instance_2.setTransform(9,9,1,1,0,0,0,9,9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackGoodStars, new cjs.Rectangle(0,-20.3,52.4,38.3), null);


(lib.FeedbackBadStars = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackStarEmpty();
	this.instance.setTransform(43.4,9,1,1,0,0,0,9,9);

	this.instance_1 = new lib.FeedbackStarEmpty();
	this.instance_1.setTransform(26.2,-11.35,1,1,0,0,0,9,9);

	this.instance_2 = new lib.FeedbackStarFilled();
	this.instance_2.setTransform(9,9,1,1,0,0,0,9,9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackBadStars, new cjs.Rectangle(0,-20.3,52.4,38.3), null);


(lib.DataElementTwoLines = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Title
	this.DataTitleTextField = new cjs.Text("Data Title\nData Title", "20px 'Work Sans'", "#295B6D");
	this.DataTitleTextField.name = "DataTitleTextField";
	this.DataTitleTextField.lineHeight = 25;
	this.DataTitleTextField.lineWidth = 317;
	this.DataTitleTextField.parent = this;
	this.DataTitleTextField.setTransform(48.55,-28.4);
ranj.TextOffsetFixer.fix(this.DataTitleTextField);

	this.timeline.addTween(cjs.Tween.get(this.DataTitleTextField).wait(1));

	// Nr
	this.DataNrTextField = new cjs.Text("Nr.", "bold 44px 'Work Sans ExtraBold'", "#295B6D");
	this.DataNrTextField.name = "DataNrTextField";
	this.DataNrTextField.lineHeight = 66;
	this.DataNrTextField.lineWidth = 317;
	this.DataNrTextField.parent = this;
	this.DataNrTextField.setTransform(48.55,16.8);
ranj.TextOffsetFixer.fix(this.DataNrTextField);

	this.timeline.addTween(cjs.Tween.get(this.DataNrTextField).wait(1));

	// Arrow
	this.Trend = new lib.TrendDownRed_1();
	this.Trend.name = "Trend";
	this.Trend.setTransform(59.85,86.95,1,1,0,0,0,8,8);

	this.timeline.addTween(cjs.Tween.get(this.Trend).wait(1));

	// TrendGreen
	this.TrendIndicatorGoodTextField = new cjs.Text("trendIndicator", "38px 'Work Sans Light'", "#779936");
	this.TrendIndicatorGoodTextField.name = "TrendIndicatorGoodTextField";
	this.TrendIndicatorGoodTextField.lineHeight = 47;
	this.TrendIndicatorGoodTextField.lineWidth = 296;
	this.TrendIndicatorGoodTextField.parent = this;
	this.TrendIndicatorGoodTextField.setTransform(76.1,64.8);
ranj.TextOffsetFixer.fix(this.TrendIndicatorGoodTextField);

	this.timeline.addTween(cjs.Tween.get(this.TrendIndicatorGoodTextField).wait(1));

	// TrendRed
	this.TrendIndicatorBadTextField = new cjs.Text("trendIndicator", "38px 'Work Sans Light'", "#E94B3D");
	this.TrendIndicatorBadTextField.name = "TrendIndicatorBadTextField";
	this.TrendIndicatorBadTextField.lineHeight = 47;
	this.TrendIndicatorBadTextField.lineWidth = 296;
	this.TrendIndicatorBadTextField.parent = this;
	this.TrendIndicatorBadTextField.setTransform(76.1,64.8);
ranj.TextOffsetFixer.fix(this.TrendIndicatorBadTextField);

	this.timeline.addTween(cjs.Tween.get(this.TrendIndicatorBadTextField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DataElementTwoLines, new cjs.Rectangle(46.6,-30.4,327.79999999999995,152.3), null);


(lib.DataElement = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Title
	this.DataTitleTextField = new cjs.Text("Data Title", "20px 'Work Sans'", "#295B6D");
	this.DataTitleTextField.name = "DataTitleTextField";
	this.DataTitleTextField.lineHeight = 25;
	this.DataTitleTextField.lineWidth = 317;
	this.DataTitleTextField.parent = this;
	this.DataTitleTextField.setTransform(49.05,4.6);
ranj.TextOffsetFixer.fix(this.DataTitleTextField);

	this.timeline.addTween(cjs.Tween.get(this.DataTitleTextField).wait(1));

	// Nr
	this.DataNrTextField = new cjs.Text("Nr.", "bold 44px 'Work Sans ExtraBold'", "#295B6D");
	this.DataNrTextField.name = "DataNrTextField";
	this.DataNrTextField.lineHeight = 66;
	this.DataNrTextField.lineWidth = 317;
	this.DataNrTextField.parent = this;
	this.DataNrTextField.setTransform(48.55,16.8);
ranj.TextOffsetFixer.fix(this.DataNrTextField);

	this.timeline.addTween(cjs.Tween.get(this.DataNrTextField).wait(1));

	// Arrow
	this.Trend = new lib.TrendDownRed_1();
	this.Trend.name = "Trend";
	this.Trend.setTransform(59.85,86.95,1,1,0,0,0,8,8);

	this.timeline.addTween(cjs.Tween.get(this.Trend).wait(1));

	// TrendGreen
	this.TrendIndicatorGoodTextField = new cjs.Text("trendIndicator", "38px 'Work Sans Light'", "#779936");
	this.TrendIndicatorGoodTextField.name = "TrendIndicatorGoodTextField";
	this.TrendIndicatorGoodTextField.lineHeight = 47;
	this.TrendIndicatorGoodTextField.lineWidth = 296;
	this.TrendIndicatorGoodTextField.parent = this;
	this.TrendIndicatorGoodTextField.setTransform(76.1,64.8);
ranj.TextOffsetFixer.fix(this.TrendIndicatorGoodTextField);

	this.timeline.addTween(cjs.Tween.get(this.TrendIndicatorGoodTextField).wait(1));

	// TrendRed
	this.TrendIndicatorBadTextField = new cjs.Text("trendIndicator", "38px 'Work Sans Light'", "#E94B3D");
	this.TrendIndicatorBadTextField.name = "TrendIndicatorBadTextField";
	this.TrendIndicatorBadTextField.lineHeight = 47;
	this.TrendIndicatorBadTextField.lineWidth = 296;
	this.TrendIndicatorBadTextField.parent = this;
	this.TrendIndicatorBadTextField.setTransform(76.1,64.8);
ranj.TextOffsetFixer.fix(this.TrendIndicatorBadTextField);

	this.timeline.addTween(cjs.Tween.get(this.TrendIndicatorBadTextField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DataElement, new cjs.Rectangle(46.6,2.6,327.79999999999995,119.30000000000001), null);


(lib.DataDashboardIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// newIndicator
	this.newIndicator = new lib.HubButtonNewIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(115.5,-73.15);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Data Dashboard", "bold 18px 'Work Sans ExtraBold'", "#BBD2D7");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 28;
	this.disabledLabelTextField.lineWidth = 182;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-0.05,37.95);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Data Dashboard", "bold 18px 'Work Sans ExtraBold'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 28;
	this.downLabelTextField.lineWidth = 182;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-0.05,37.95);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Data Dashboard", "bold 18px 'Work Sans ExtraBold'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 28;
	this.overLabelTextField.lineWidth = 182;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-0.05,37.95);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Data Dashboard", "bold 18px 'Work Sans ExtraBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 28;
	this.upLabelTextField.lineWidth = 182;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-0.05,37.95);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_10
	this.instance = new lib.HUBTeaCornerButtonLabelUp();
	this.instance.setTransform(-109,13);

	this.instance_1 = new lib.HUBTeaCornerButtonLabelOver();
	this.instance_1.setTransform(-109,12);

	this.instance_2 = new lib.HUBTeaCornerButtonLabelDisabled();
	this.instance_2.setTransform(-109,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	// Layer_1
	this.instance_3 = new lib.DashboardButton();
	this.instance_3.setTransform(-64,-90);

	this.instance_4 = new lib.DashboardButtonOver();
	this.instance_4.setTransform(-64,-90);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3}]}).to({state:[{t:this.instance_4}]},1).wait(3));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-109,-113.1,266.5,217.1);


(lib.DashboardTab3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.imageContainer = new lib.Tab3InformationImage();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(750.5,334.5,1,1,0,0,0,750.5,334.5);

	this.instance = new lib.EmptyContainer();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.imageContainer}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DashboardTab3, new cjs.Rectangle(0,0,1501,669), null);


(lib.DashboardTab2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// CategoryTitles
	this.ThirdCategoryTitleTextField = new cjs.Text("Category title here", "18px 'Work Sans Light'", "#295B6D");
	this.ThirdCategoryTitleTextField.name = "ThirdCategoryTitleTextField";
	this.ThirdCategoryTitleTextField.lineHeight = 23;
	this.ThirdCategoryTitleTextField.lineWidth = 253;
	this.ThirdCategoryTitleTextField.alpha = 0.60000000;
	this.ThirdCategoryTitleTextField.parent = this;
	this.ThirdCategoryTitleTextField.setTransform(2,423.7);
ranj.TextOffsetFixer.fix(this.ThirdCategoryTitleTextField);

	this.SecondCategoryTitleTextField = new cjs.Text("Category title here", "18px 'Work Sans Light'", "#295B6D");
	this.SecondCategoryTitleTextField.name = "SecondCategoryTitleTextField";
	this.SecondCategoryTitleTextField.lineHeight = 23;
	this.SecondCategoryTitleTextField.lineWidth = 253;
	this.SecondCategoryTitleTextField.alpha = 0.60000000;
	this.SecondCategoryTitleTextField.parent = this;
	this.SecondCategoryTitleTextField.setTransform(2,255.55);
ranj.TextOffsetFixer.fix(this.SecondCategoryTitleTextField);

	this.FirstCategoryTitleTextField = new cjs.Text("Category title here", "18px 'Work Sans Light'", "#295B6D");
	this.FirstCategoryTitleTextField.name = "FirstCategoryTitleTextField";
	this.FirstCategoryTitleTextField.lineHeight = 23;
	this.FirstCategoryTitleTextField.lineWidth = 253;
	this.FirstCategoryTitleTextField.alpha = 0.60000000;
	this.FirstCategoryTitleTextField.parent = this;
	this.FirstCategoryTitleTextField.setTransform(2,55.05);
ranj.TextOffsetFixer.fix(this.FirstCategoryTitleTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.FirstCategoryTitleTextField},{t:this.SecondCategoryTitleTextField},{t:this.ThirdCategoryTitleTextField}]}).wait(1));

	// Layer_1
	this.instance = new lib.DashboardLogoReady();
	this.instance.setTransform(1382.9,10.45,1,1,0,0,0,68.5,16);

	this.LabelTab2 = new cjs.Text("Showing data from Northeast region of Thisland (total population 4.2m)", "italic 20px 'Work Sans Light'", "#295B6D");
	this.LabelTab2.name = "LabelTab2";
	this.LabelTab2.lineHeight = 31;
	this.LabelTab2.lineWidth = 708;
	this.LabelTab2.parent = this;
	this.LabelTab2.setTransform(2,2);
ranj.TextOffsetFixer.fix(this.LabelTab2);

	this.DataElement6 = new lib.DataElementTwoLines();
	this.DataElement6.name = "DataElement6";
	this.DataElement6.setTransform(490.65,577.15,1,1,0,0,0,184.2,86.5);

	this.DataElement5 = new lib.DataElementTwoLines();
	this.DataElement5.name = "DataElement5";
	this.DataElement5.setTransform(137.15,577.15,1,1,0,0,0,184.2,86.5);

	this.DataElement8 = new lib.DataElementTwoLines();
	this.DataElement8.name = "DataElement8";
	this.DataElement8.setTransform(1197.65,577.15,1,1,0,0,0,184.2,86.5);

	this.DataElement7 = new lib.DataElementTwoLines();
	this.DataElement7.name = "DataElement7";
	this.DataElement7.setTransform(844.15,577.15,1,1,0,0,0,184.2,86.5);

	this.DataElement4 = new lib.DataElement();
	this.DataElement4.name = "DataElement4";
	this.DataElement4.setTransform(490.65,374.8,1,1,0,0,0,184.2,86.5);

	this.DataElement3 = new lib.DataElement();
	this.DataElement3.name = "DataElement3";
	this.DataElement3.setTransform(137.15,374.8,1,1,0,0,0,184.2,86.5);

	this.DataElement2 = new lib.DataElementTwoLines();
	this.DataElement2.name = "DataElement2";
	this.DataElement2.setTransform(490.65,207.95,1,1,0,0,0,184.2,86.5);

	this.DataElement1 = new lib.DataElementTwoLines();
	this.DataElement1.name = "DataElement1";
	this.DataElement1.setTransform(137.15,207.95,1,1,0,0,0,184.2,86.5);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#295B6D").ss(1,1,1).p("EhsXgcsMDYvAAAEhsXACbMDYvAAAEhsXActMDYvAAA");
	this.shape.setTransform(694.275,263.125);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.DataElement1},{t:this.DataElement2},{t:this.DataElement3},{t:this.DataElement4},{t:this.DataElement7},{t:this.DataElement8},{t:this.DataElement5},{t:this.DataElement6},{t:this.LabelTab2},{t:this.instance}]}).wait(1));

	// BGitem
	this.instance_1 = new lib.Tab2BGElement();
	this.instance_1.setTransform(789,2);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DashboardTab2, new cjs.Rectangle(-0.5,-5.5,1478.5,666.5), null);


(lib.DashboardLogoWHO = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.LogoMoH();

	this.instance_1 = new lib.DashboardLogoReady();
	this.instance_1.setTransform(62.6,59,1,1,0,0,0,68.5,16);

	this.instance_2 = new lib.DashboardLogoGHO();
	this.instance_2.setTransform(59.5,59,1,1,0,0,0,55.5,45.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.9,0,137,118);


(lib.TransitionScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// locationTextField
	this.continueButton = new lib.ContinueButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(-415.5,99.75);

	this.locationTextField = new cjs.Text("[Location]", "bold 50px 'Work Sans ExtraBold'", "#2C3C3C");
	this.locationTextField.name = "locationTextField";
	this.locationTextField.lineHeight = 48;
	this.locationTextField.lineWidth = 1132;
	this.locationTextField.parent = this;
	this.locationTextField.setTransform(-568,-407.05);
ranj.TextOffsetFixer.fix(this.locationTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.locationTextField},{t:this.continueButton}]}).wait(1));

	// premiseTextField
	this.bodyTextField = new cjs.Text("[Premise of this turn]\n[Premise of this turn]\n[Premise of this turn]\n[Premise of this turn]\n[Premise of this turn]\n[Premise of this turn]\n[Premise of this turn]\n[Premise of this turn]", "28px 'Work Sans'", "#2C3C3C");
	this.bodyTextField.name = "bodyTextField";
	this.bodyTextField.lineHeight = 35;
	this.bodyTextField.lineWidth = 872;
	this.bodyTextField.parent = this;
	this.bodyTextField.setTransform(-568,-303);
ranj.TextOffsetFixer.fix(this.bodyTextField);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextField).wait(1));

	// travelLabelTextField
	this.travelLabelTextField = new cjs.Text("Travel to:", "28px 'Work Sans'", "#2C3C3C");
	this.travelLabelTextField.name = "travelLabelTextField";
	this.travelLabelTextField.lineHeight = 35;
	this.travelLabelTextField.lineWidth = 962;
	this.travelLabelTextField.parent = this;
	this.travelLabelTextField.setTransform(-568,-394.05);
ranj.TextOffsetFixer.fix(this.travelLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.travelLabelTextField).wait(1));

	// imageContainer
	this.imageContainer = new lib.EmptyContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(-960,-540);

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TransitionScreenSkin, new cjs.Rectangle(-962,-542,1925,1085), null);


(lib.PlaceholderScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// continueButton
	this.continueButton = new lib.ContinueButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(682.35,389.1);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// contentTextField
	this.contentTextField = new cjs.Text("[Body]", "48px 'Open Sans'");
	this.contentTextField.name = "contentTextField";
	this.contentTextField.textAlign = "center";
	this.contentTextField.lineHeight = 67;
	this.contentTextField.lineWidth = 1704;
	this.contentTextField.parent = this;
	this.contentTextField.setTransform(0,-430.7);
ranj.TextOffsetFixer.fix(this.contentTextField);

	this.timeline.addTween(cjs.Tween.get(this.contentTextField).wait(1));

	// bg
	this.bg = new lib.PlaceholderBackground();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlaceholderScreenSkin, new cjs.Rectangle(-960.5,-540.5,1921,1081), null);


(lib.LoadingScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// contentTextField
	this.loadingTextField = new cjs.Text("Loading...", "bold 72px 'Work Sans'");
	this.loadingTextField.name = "loadingTextField";
	this.loadingTextField.textAlign = "center";
	this.loadingTextField.lineHeight = 86;
	this.loadingTextField.lineWidth = 1704;
	this.loadingTextField.parent = this;
	this.loadingTextField.setTransform(0,-52.15);
ranj.TextOffsetFixer.fix(this.loadingTextField);

	this.timeline.addTween(cjs.Tween.get(this.loadingTextField).wait(1));

	// bg
	this.bg = new lib.LoadingBackground();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingScreenSkin, new cjs.Rectangle(-960.5,-540.5,1921,1081), null);


(lib.KeyDecisionUnderlayScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// topBar
	this.topBar = new lib.TopBar_1();
	this.topBar.name = "topBar";
	this.topBar.setTransform(0,-439,1,1,0,0,0,960.5,101);

	this.timeline.addTween(cjs.Tween.get(this.topBar).wait(1));

	// bottomBar
	this.bottomBar = new lib.BottomBar_1();
	this.bottomBar.name = "bottomBar";
	this.bottomBar.setTransform(0,450.5,1,1,0,0,0,960.5,89.5);

	this.timeline.addTween(cjs.Tween.get(this.bottomBar).wait(1));

	// imageContainer
	this.imageContainer = new lib.KeyDecisionUnderlayImageContainer();
	this.imageContainer.name = "imageContainer";

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecisionUnderlayScreenSkin, new cjs.Rectangle(-961,-541,1923.5,1082), null);


(lib.KeyDecisionConfirmationScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// text
	this.continueButton = new lib.ContinueButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(-459.45,173.25,1,1,0,0,0,10.5,1);

	this.bodyTextField = new cjs.Text("You've just submitted your key decision and are now being informed on how things will proceed, after which you can click continue to, well, continue playing.", "24px 'Work Sans Medium'", "#324141");
	this.bodyTextField.name = "bodyTextField";
	this.bodyTextField.lineHeight = 30;
	this.bodyTextField.lineWidth = 616;
	this.bodyTextField.parent = this;
	this.bodyTextField.setTransform(-622.45,-73.75);
ranj.TextOffsetFixer.fix(this.bodyTextField);

	this.titleTextField = new cjs.Text("Key decision submitted", "bold 50px 'Work Sans ExtraBold'", "#324141");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.lineHeight = 74;
	this.titleTextField.lineWidth = 616;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(-622.45,-175.6);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.titleTextField},{t:this.bodyTextField},{t:this.continueButton}]}).wait(1));

	// overlayforreadability
	this.instance = new lib.KDconfirmationIcon();
	this.instance.setTransform(-694.95,-109.65,1,1,0,0,0,70.5,70);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(255,255,255,0.498)").ss(1,1,1).p("Ehy2g3sMDljAAAIAKAAMAAABvZIgKAA");
	this.shape.setTransform(225.95,-183.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.278)").s().p("EiV/BUYMAAAiovMBGdAAAMDliAAAMAAABvZMAAAA5Wg");
	this.shape_1.setTransform(0.0125,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape},{t:this.instance}]}).wait(1));

	// bg
	this.instance_1 = new lib.MapBGConfirmationjpgcopy();
	this.instance_1.setTransform(-960,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecisionConfirmationScreenSkin, new cjs.Rectangle(-960,-541,1922,1082), null);


(lib.DecisionScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// dilemmaTextField
	this.dilemmaTextField = new cjs.Text("[Text Lorem ipsum dolor sit amet.]", "italic 32px 'Work Sans'", "#2C3C3C");
	this.dilemmaTextField.name = "dilemmaTextField";
	this.dilemmaTextField.lineHeight = 48;
	this.dilemmaTextField.lineWidth = 502;
	this.dilemmaTextField.parent = this;
	this.dilemmaTextField.setTransform(254.05,-445.6);
ranj.TextOffsetFixer.fix(this.dilemmaTextField);

	this.timeline.addTween(cjs.Tween.get(this.dilemmaTextField).wait(1));

	// continueButton
	this.continueButton = new lib.ContinueButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(619.5,469);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// optionButtons
	this.option4 = new lib.DecisionButton();
	this.option4.name = "option4";
	this.option4.setTransform(428,335.3);

	this.option3 = new lib.DecisionButton();
	this.option3.name = "option3";
	this.option3.setTransform(428,178.4);

	this.option2 = new lib.DecisionButton();
	this.option2.name = "option2";
	this.option2.setTransform(428,21.5);

	this.option1 = new lib.DecisionButton();
	this.option1.name = "option1";
	this.option1.setTransform(428,-135.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.option1},{t:this.option2},{t:this.option3},{t:this.option4}]}).wait(1));

	// imageContainer
	this.imageContainer = new lib.DecisionImageContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(-344,16);

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	// background
	this.bg = new lib.DecisionScreenBackground();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DecisionScreenSkin, new cjs.Rectangle(-960.5,-540.5,1921,1081), null);


(lib.ConversationStatementScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// characternameTextField
	this.characterNameTextField = new cjs.Text("[Name]", "italic 32px 'Work Sans'", "#2C3C3C");
	this.characterNameTextField.name = "characterNameTextField";
	this.characterNameTextField.lineHeight = 48;
	this.characterNameTextField.lineWidth = 634;
	this.characterNameTextField.parent = this;
	this.characterNameTextField.setTransform(262,-472);
ranj.TextOffsetFixer.fix(this.characterNameTextField);

	this.timeline.addTween(cjs.Tween.get(this.characterNameTextField).wait(1));

	// characterfunctionSubTextField
	this.characterFunctionSubTextField = new cjs.Text("[function]\n[function]", "24px 'Work Sans'", "#2C3C3C");
	this.characterFunctionSubTextField.name = "characterFunctionSubTextField";
	this.characterFunctionSubTextField.lineHeight = 30;
	this.characterFunctionSubTextField.lineWidth = 634;
	this.characterFunctionSubTextField.parent = this;
	this.characterFunctionSubTextField.setTransform(262,-421);
ranj.TextOffsetFixer.fix(this.characterFunctionSubTextField);

	this.timeline.addTween(cjs.Tween.get(this.characterFunctionSubTextField).wait(1));

	// statementTextField
	this.statementTextField = new cjs.Text("[You greet the [Ministry of Health official] who responds warmly. She tells you that officially there are no cases in the country yet, but she too has seen the news and is worried. However, the issue has become politically sensitive. \n\nShe offers to send on the national response plan but warns that it isn’t really designed for this eventuality. \n\nShe concludes by asking you to stay in touch. As you hang up, you’re glad you called—an email might have received a more bureaucratic and less informative response.]\n", "24px 'Work Sans'", "#2C3C3C");
	this.statementTextField.name = "statementTextField";
	this.statementTextField.lineHeight = 26;
	this.statementTextField.lineWidth = 639;
	this.statementTextField.parent = this;
	this.statementTextField.setTransform(263.05,-344.75);
ranj.TextOffsetFixer.fix(this.statementTextField);

	this.timeline.addTween(cjs.Tween.get(this.statementTextField).wait(1));

	// continueButton
	this.continueButton = new lib.ContinueButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(749.75,468.5);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// imageMask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EhHtBLKQlcAAj2j2Qj2j2AAlcMAAAh8DQAAlcD2j2QD2j2FcAAMCPbAAAQFcAAD2D2QD2D2AAFcMAAAB8DQAAFcj2D2Qj2D2lcAAg");
	mask.setTransform(-344,16);

	// imageContainer
	this.imageContainer = new lib.DecisionImageContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(-344,16);

	var maskedShapeInstanceList = [this.imageContainer];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	// background
	this.bg = new lib.DecisionScreenBackgroun();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationStatementScreenSkin, new cjs.Rectangle(-960.5,-540.5,1921,1081), null);


(lib.BriefingScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// continueButton
	this.ContinueButton = new lib.ContinueButton();
	this.ContinueButton.name = "ContinueButton";
	this.ContinueButton.setTransform(267.25,353.3);

	this.timeline.addTween(cjs.Tween.get(this.ContinueButton).wait(1));

	// headerTextField
	this.CWeekNumber = new cjs.Text("Week 1", "50px 'Work Sans Light'");
	this.CWeekNumber.name = "CWeekNumber";
	this.CWeekNumber.lineHeight = 61;
	this.CWeekNumber.lineWidth = 247;
	this.CWeekNumber.parent = this;
	this.CWeekNumber.setTransform(-352.45,-369.05);
ranj.TextOffsetFixer.fix(this.CWeekNumber);

	this.BulletPoint = new cjs.Text("• ", "50px 'Work Sans Light'");
	this.BulletPoint.name = "BulletPoint";
	this.BulletPoint.lineHeight = 61;
	this.BulletPoint.lineWidth = 22;
	this.BulletPoint.parent = this;
	this.BulletPoint.setTransform(-394.2,-369.05);
ranj.TextOffsetFixer.fix(this.BulletPoint);

	this.ChapterTitle = new cjs.Text("Bacterial Meningitis or Something More?", "bold 50px 'Work Sans'");
	this.ChapterTitle.name = "ChapterTitle";
	this.ChapterTitle.lineHeight = 61;
	this.ChapterTitle.lineWidth = 1050;
	this.ChapterTitle.parent = this;
	this.ChapterTitle.setTransform(-642.55,-313.9);
ranj.TextOffsetFixer.fix(this.ChapterTitle);

	this.ChapterNumber = new cjs.Text("Chapter 1:", "50px 'Work Sans Light'");
	this.ChapterNumber.name = "ChapterNumber";
	this.ChapterNumber.lineHeight = 61;
	this.ChapterNumber.lineWidth = 247;
	this.ChapterNumber.parent = this;
	this.ChapterNumber.setTransform(-642.55,-369.05);
ranj.TextOffsetFixer.fix(this.ChapterNumber);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.ChapterNumber},{t:this.ChapterTitle},{t:this.BulletPoint},{t:this.CWeekNumber}]}).wait(1));

	// contentTextField
	this.ChapterContent = new cjs.Text("You just left a sub-national Health Coordination Group meeting, chaired by the Ministry of Health (MoH), with attendees from health organizations in Murelle and nearby areas.\n\nThe meeting discussed 12 cases of suspected bacterial meningitis with respiratory symptoms in the district hospital over the past 3 weeks. One non-governmental organization (NGO) Health Coordinator mentioned a similar outbreak caused by the Enni Virus (EnV) in Kwaland a few years ago, spread by infected bats, simberri sap and respiratory droplets. Other organizations suggested it may be a common seasonal respiratory disease but were concerned about the altered level of consciousness in patients.\n\nThe MoH is conducting further testing in the main national laboratory in the capital city of Myro in an effort to sequence the pathogen responsible for these recent cases. The MoH says the additional testing is a precautionary measure, and that there is no cause for alarm, but everyone must monitor the situation closely.", "24px 'Work Sans'");
	this.ChapterContent.name = "ChapterContent";
	this.ChapterContent.lineHeight = 30;
	this.ChapterContent.lineWidth = 1013;
	this.ChapterContent.parent = this;
	this.ChapterContent.setTransform(-642.55,-212);
ranj.TextOffsetFixer.fix(this.ChapterContent);

	this.timeline.addTween(cjs.Tween.get(this.ChapterContent).wait(1));

	// Layer_2
	this.ChapterContentContainer = new lib.ChapterContentContainer();
	this.ChapterContentContainer.name = "ChapterContentContainer";
	this.ChapterContentContainer.setTransform(-209.1,-73.4,1,1,0,0,0,557,353.5);

	this.timeline.addTween(cjs.Tween.get(this.ChapterContentContainer).wait(1));

	// horizontal_bars
	this.BriefingTimelineSmallBar = new lib.BriefingTimelineSmallBar();
	this.BriefingTimelineSmallBar.name = "BriefingTimelineSmallBar";
	this.BriefingTimelineSmallBar.setTransform(-792.35,453,1,1,0,0,0,80,36.5);

	this.BriefingTimelineSmallBar_1 = new lib.BriefingTimelineSmallBar();
	this.BriefingTimelineSmallBar_1.name = "BriefingTimelineSmallBar_1";
	this.BriefingTimelineSmallBar_1.setTransform(-792.35,-422,1,1,0,0,0,80,36.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.BriefingTimelineSmallBar_1},{t:this.BriefingTimelineSmallBar}]}).wait(1));

	// black_bar
	this.BriefingTimelineBar = new lib.BriefingTimelineBar();
	this.BriefingTimelineBar.name = "BriefingTimelineBar";
	this.BriefingTimelineBar.setTransform(-795.8,63.5,1,1,0,0,0,18.5,341);

	this.timeline.addTween(cjs.Tween.get(this.BriefingTimelineBar).wait(1));

	// Timeline
	this.BriefingTimelineBackground = new lib.BriefingTimelineBackground_1();
	this.BriefingTimelineBackground.name = "BriefingTimelineBackground";
	this.BriefingTimelineBackground.setTransform(-792.8,3.7,1,1,0,0,0,36,561);

	this.timeline.addTween(cjs.Tween.get(this.BriefingTimelineBackground).wait(1));

	// bg
	this.instance = new lib.BriefingBackground();
	this.instance.setTransform(-960,-540);

	this.bg = new lib.BriefingBackground_1();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BriefingScreenSkin, new cjs.Rectangle(-960.5,-557.3,1921.5,1122), null);


(lib.NPCPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// continueButton
	this.continueButton = new lib.continueButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(206,-56.4,1,1,0,0,0,50,15.5);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// npcNamePanel
	this.npcNamePanel = new lib.NPCLabelPanel();
	this.npcNamePanel.name = "npcNamePanel";
	this.npcNamePanel.setTransform(-231.5,-16.4);

	this.timeline.addTween(cjs.Tween.get(this.npcNamePanel).wait(1));

	// npcTextPanel
	this.npcTextPanel = new lib.NpcTextPanel();
	this.npcTextPanel.name = "npcTextPanel";
	this.npcTextPanel.setTransform(0,0.4,1,1,0,0,0,0,0.9);

	this.timeline.addTween(cjs.Tween.get(this.npcTextPanel).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NPCPanel, new cjs.Rectangle(-330,-71.9,765,360.4), null);


(lib.PlanComposerKeyDecision_SubmitButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Submit", "28px 'Work Sans SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-73.2,-15.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Submit", "28px 'Work Sans SemiBold'", "#D1D2C6");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-73.2,-15.65);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Submit", "28px 'Work Sans SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-73.2,-15.65);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Submit", "28px 'Work Sans SemiBold'", "#324141");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-73.2,-15.65);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.PlanComposerKeyDecision_SubmitIcon();
	this.instance.setTransform(-113.6,5.85,1,1,0,0,0,22,22);

	this.instance_1 = new lib.PlanComposerKeyDecision_ButtonUp();
	this.instance_1.setTransform(36.5,7,1,1,0,0,0,191,38.5);

	this.instance_2 = new lib.PlanComposerKeyDecision_ButtonOver();
	this.instance_2.setTransform(36.55,6.45,1,1,0,0,0,191,38.5);

	this.instance_3 = new lib.PlanComposerKeyDecision_ButtonDown();
	this.instance_3.setTransform(36.55,6.45,1,1,0,0,0,191,38.5);

	this.instance_4 = new lib.PlanComposerKeyDecision_ButtonDisabled();
	this.instance_4.setTransform(37.5,6.6,1,1,0,0,0,191,38.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance}]},1).to({state:[{t:this.instance_3},{t:this.instance}]},1).to({state:[{t:this.instance_4},{t:this.instance}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-154.5,-32,383,77.5);


(lib.PlanComposerKeyDecision_AnswerButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,"selecteUp":4,"selectedOver":5,"SelectedDown":6,"SelectedDisabled":7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance ", "24px 'Work Sans'", "#2C3C3C");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 30;
	this.upLabelTextField.lineWidth = 717;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(62.4,16.55);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(8));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Unlock by gathering more inforamtion", "24px 'Work Sans'", "#98A0A0");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 30;
	this.disabledLabelTextField.lineWidth = 717;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(62.4,16.55);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(8));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance ", "24px 'Work Sans'", "#2C3C3C");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 30;
	this.downLabelTextField.lineWidth = 717;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(62.4,16.55);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(8));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance ", "24px 'Work Sans'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 30;
	this.overLabelTextField.lineWidth = 717;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(62.4,16.55);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(8));

	// bg
	this.instance = new lib.PlanComposerKeyDecision_AnswerUp();
	this.instance.setTransform(411.65,78.5,1,1,0,0,0,416,80.5);

	this.instance_1 = new lib.PlanComposerKeyDecision_AnswerOver();
	this.instance_1.setTransform(411.65,78.5,1,1,0,0,0,416,80.5);

	this.instance_2 = new lib.ContinueButtonHi();
	this.instance_2.setTransform(43,22);

	this.instance_3 = new lib.PlanComposerKeyDecision_AnswerDown();
	this.instance_3.setTransform(434.15,84.5,1,1,0,0,0,438.5,84.5);

	this.instance_4 = new lib.PlanComposerKeyDecision_AnswerLocked();
	this.instance_4.setTransform(411.65,88.5,1,1,0,0,0,416,80.5);

	this.instance_5 = new lib.ContinueButtonDisabled();
	this.instance_5.setTransform(43,24);

	this.instance_6 = new lib.keyDecisionPlanComposer_AnswerSelectedUp();
	this.instance_6.setTransform(403.5,68,1,1,0,0,0,403.5,68);

	this.instance_7 = new lib.keyDecisionPlanComposer_AnswerSelectedOver();
	this.instance_7.setTransform(403.3,67.9,1,1,0,0,0,403.5,68);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2,p:{x:43,y:22}},{t:this.instance_1}]},1).to({state:[{t:this.instance_2,p:{x:49,y:24}},{t:this.instance_3}]},1).to({state:[{t:this.instance_5},{t:this.instance_4}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_2,p:{x:49,y:24}},{t:this.instance_3}]},1).to({state:[{t:this.instance_5},{t:this.instance_4}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-4.3,-2,877,171);


(lib.KDContinueButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#EEEAE5");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#DE7824");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Continue", "28px 'Work Sans'", "#DE7824");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.KDContinueUp();
	this.instance.setTransform(10.5,1,1,1,0,0,0,165,32.5);

	this.instance_1 = new lib.KDContinueOver();
	this.instance_1.setTransform(10.5,1,1,1,0,0,0,165,32.5);

	this.instance_2 = new lib.KDContinueDisabled();
	this.instance_2.setTransform(10.5,1,1,1,0,0,0,165,32.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-154.5,-31.5,330,65);


(lib.FeedbackToggleButtonWhiteScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Show optimal answers", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 320;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Show optimal answers", "28px 'Work Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 320;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Show optimal answers", "28px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 320;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Show optimal answers", "28px 'Work Sans'", "#84A346");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 320;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// bg
	this.instance = new lib.FeedbackOptimalUp();
	this.instance.setTransform(15.4,10.35,1,1,0,0,0,223,45.5);

	this.instance_1 = new lib.FeedbackOptimalOver();
	this.instance_1.setTransform(10.9,5.35,1,1,0,0,0,218.5,40.5);

	this.instance_2 = new lib.FeedbackOptimalDown();
	this.instance_2.setTransform(16.4,5.35,1,1,0,0,0,224,40.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-207.6,-35.1,410,66);


(lib.FeedbackToggleButtonBlackScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Hide optimal answers", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 320;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.upLabelTextField_1 = new cjs.Text("Hide optimal answers", "28px 'Work Sans'", "#324141");
	this.upLabelTextField_1.name = "upLabelTextField_1";
	this.upLabelTextField_1.lineHeight = 35;
	this.upLabelTextField_1.lineWidth = 320;
	this.upLabelTextField_1.parent = this;
	this.upLabelTextField_1.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField_1);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField_1).wait(4));

	// downLabelTextField
	this.upLabelTextField_2 = new cjs.Text("Hide optimal answers", "28px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField_2.name = "upLabelTextField_2";
	this.upLabelTextField_2.lineHeight = 35;
	this.upLabelTextField_2.lineWidth = 320;
	this.upLabelTextField_2.parent = this;
	this.upLabelTextField_2.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField_2);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField_2).wait(4));

	// overLabelTextField
	this.upLabelTextField_3 = new cjs.Text("Hide optimal answers", "28px 'Work Sans'", "#324141");
	this.upLabelTextField_3.name = "upLabelTextField_3";
	this.upLabelTextField_3.lineHeight = 35;
	this.upLabelTextField_3.lineWidth = 320;
	this.upLabelTextField_3.parent = this;
	this.upLabelTextField_3.setTransform(-137,-22.65);
ranj.TextOffsetFixer.fix(this.upLabelTextField_3);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField_3).wait(4));

	// bg
	this.instance = new lib.FeedbackPlayerChoiceUp();
	this.instance.setTransform(15.4,10.35,1,1,0,0,0,223,45.5);

	this.instance_1 = new lib.FeedbackPlayerChoiceOver();
	this.instance_1.setTransform(10.9,5.35,1,1,0,0,0,218.5,40.5);

	this.instance_2 = new lib.FeedbackPlayerChoiceDown();
	this.instance_2.setTransform(16.4,5.35,1,1,0,0,0,224,40.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-207.6,-35.1,410,66);


(lib.FeedbackButtonOptimal = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#324141");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 21;
	this.upLabelTextField.lineWidth = 440;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#324141");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 21;
	this.disabledLabelTextField.lineWidth = 440;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#324141");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 21;
	this.downLabelTextField.lineWidth = 440;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#324141");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 21;
	this.overLabelTextField.lineWidth = 440;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Stars_and_expand
	this.instance = new lib.FeedbackOptimalStars();
	this.instance.setTransform(-180.45,24.35,1,1,0,0,0,36.6,9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// bg
	this.instance_1 = new lib.FeedbackOptimalAnswerUp();
	this.instance_1.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.instance_2 = new lib.FeedbackOptimalAnswerOver();
	this.instance_2.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-238.9,-31.5,586,95);


(lib.FeedbackButtonMedium = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 21;
	this.upLabelTextField.lineWidth = 440;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 21;
	this.disabledLabelTextField.lineWidth = 440;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 21;
	this.downLabelTextField.lineWidth = 440;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 21;
	this.overLabelTextField.lineWidth = 440;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Stars_and_expand
	this.instance = new lib.FeedbackMediumStars();
	this.instance.setTransform(-180.45,24.35,1,1,0,0,0,36.6,9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// bg
	this.instance_1 = new lib.FeedbackMediumUp();
	this.instance_1.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.instance_2 = new lib.FeedbackMediumOver();
	this.instance_2.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-238.9,-31.5,586,95);


(lib.FeedbackButtonGood = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 21;
	this.upLabelTextField.lineWidth = 440;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 21;
	this.disabledLabelTextField.lineWidth = 440;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 21;
	this.downLabelTextField.lineWidth = 440;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 21;
	this.overLabelTextField.lineWidth = 440;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Stars_and_expand
	this.instance = new lib.FeedbackGoodStars();
	this.instance.setTransform(-180.45,24.35,1,1,0,0,0,36.6,9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// bg
	this.instance_1 = new lib.FeedbackGoodUp();
	this.instance_1.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.instance_2 = new lib.FeedbackGoodOver();
	this.instance_2.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-238.9,-31.5,586,95);


(lib.FeedbackButtonBad = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 21;
	this.upLabelTextField.lineWidth = 440;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 21;
	this.disabledLabelTextField.lineWidth = 440;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 21;
	this.downLabelTextField.lineWidth = 440;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Immediately notify MoH of cases in READY clinics and request guidance. Immediately notify MoH of cases in...", "20px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 21;
	this.overLabelTextField.lineWidth = 440;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-131.4,-24.4);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Stars_and_expand
	this.instance = new lib.FeedbackBadStars();
	this.instance.setTransform(-180.45,24.35,1,1,0,0,0,36.6,9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// bg
	this.instance_1 = new lib.FeedbackBadUp();
	this.instance_1.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.instance_2 = new lib.FeedbackBadOver();
	this.instance_2.setTransform(130.05,33,1,1,0,0,0,369,64.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_2}]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-238.9,-31.5,586,95);


(lib.TopBarCloseWindowButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hitArea
	this.hitArea = new lib.EmptySquare();
	this.hitArea.name = "hitArea";

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	// Layer_2
	this.instance = new lib.CloseButtonBase();
	this.instance.setTransform(0.5,0.5);
	var instanceFilter_1 = new cjs.ColorFilter(0,0,0,1,83,71,65,0);
	this.instance.filters = [instanceFilter_1];
	this.instance.cache(-10,-10,21,21);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2).to({scaleX:0.8235,scaleY:0.8235,x:0.4,y:0.4},0).wait(1).to({scaleX:1,scaleY:1,x:0.5,y:0.5},0).wait(1));
	this.timeline.addTween(cjs.Tween.get(instanceFilter_1).wait(2).to(new cjs.ColorFilter(0,0,0,1,103,102,111,0), 0).wait(1).to(new cjs.ColorFilter(0,0,0,1,235,234,234,0), 0).wait(1));

	this.filterCacheList = [];
	this.filterCacheList.push({instance: this.instance, startFrame:2, endFrame:2, x:-10, y:-10, w:21, h:21});
	this.filterCacheList.push({instance: this.instance, startFrame:0, endFrame:0, x:-10, y:-10, w:21, h:21});
	this.filterCacheList.push({instance: this.instance, startFrame:3, endFrame:3, x:-10, y:-10, w:21, h:21});
	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22,-22,44,44);


(lib.AbortButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Start", "28px 'Work Sans'", "#A0A0A0");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 35;
	this.disabledLabelTextField.lineWidth = 112;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-112,-13.3);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Start", "28px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 35;
	this.downLabelTextField.lineWidth = 112;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-112,-13.3);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Start", "28px 'Work Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 35;
	this.overLabelTextField.lineWidth = 112;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-112,-13.3);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Start", "28px 'Work Sans'", "#2C3C3C");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 35;
	this.upLabelTextField.lineWidth = 112;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-112,-13.3);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// bg
	this.instance = new lib.BackUp_1();
	this.instance.setTransform(-114.85,28.9,1,1,0,0,0,108.5,54.5);

	this.instance_1 = new lib.BackOver_1();
	this.instance_1.setTransform(-115.85,28.35,1,1,0,0,0,108,54);

	this.instance_2 = new lib.BackDisabled_1();
	this.instance_2.setTransform(-115.55,29.2,1,1,0,0,0,108,54);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-223.8,-25.6,201.5,62.800000000000004);


(lib.MapNodeInformationPopupPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// descriptionTextField
	this.descriptionTextField = new cjs.Text("[Description]", "48px 'Open Sans'");
	this.descriptionTextField.name = "descriptionTextField";
	this.descriptionTextField.textAlign = "center";
	this.descriptionTextField.lineHeight = 67;
	this.descriptionTextField.lineWidth = 940;
	this.descriptionTextField.parent = this;
	this.descriptionTextField.setTransform(0,-136.15);
ranj.TextOffsetFixer.fix(this.descriptionTextField);

	this.timeline.addTween(cjs.Tween.get(this.descriptionTextField).wait(1));

	// titleTextField
	this.titleTextField = new cjs.Text("[Title]", "72px 'Open Sans'");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.textAlign = "center";
	this.titleTextField.lineHeight = 100;
	this.titleTextField.lineWidth = 940;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(0,-238.2);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.timeline.addTween(cjs.Tween.get(this.titleTextField).wait(1));

	// closeButton
	this.closeButton = new lib.PlaceholderCloseButton();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(544.85,-285.15);

	this.timeline.addTween(cjs.Tween.get(this.closeButton).wait(1));

	// continueButton
	this.continueButton = new lib.HUBTeaCornerButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(0,161.8,1,1,0,0,0,0,20);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// panel
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EhVIgqaMCqRAAAMAAABU1MiqRAAAg");
	this.shape.setTransform(0,-0.025);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#999999").s().p("EhVIAqbMAAAhU1MCqRAAAMAAABU1g");
	this.shape_1.setTransform(0,-0.025);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MapNodeInformationPopupPanel, new cjs.Rectangle(-545.8,-330.6,1136.1,603.1), null);


(lib.KeyDecisionAvailablePanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.instance = new lib.KeyDecDown();
	this.instance.setTransform(-515,-296);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(219,120,35,0.518)").ss(1,1,1).p("Egv5AN2MBfzAAAEgv5gN1MBfzAAA");
	this.shape.setTransform(-226.8,-76.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Laag_1
	this.KDbackButton = new lib.KDBackButton();
	this.KDbackButton.name = "KDbackButton";
	this.KDbackButton.setTransform(-352.1,330.4,1,1,0,0,0,10.5,1);

	this.continueButton = new lib.KDContinueButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(-112.6,330.1);

	this.disclaimerTextField = new cjs.Text("You can always exit the Key Decision for further investigation.", "18px 'Work Sans Medium'", "#DD7823");
	this.disclaimerTextField.name = "disclaimerTextField";
	this.disclaimerTextField.lineHeight = 19;
	this.disclaimerTextField.lineWidth = 562;
	this.disclaimerTextField.parent = this;
	this.disclaimerTextField.setTransform(-506.35,375.55);
ranj.TextOffsetFixer.fix(this.disclaimerTextField);

	this.keyDecisionTextfield = new cjs.Text("Determine your first priority steps when hearing of the outbreak. Determine your first priority steps when hearing of the outbreak. Determine your first priority steps when hearing of the outbreak.", "bold 24px 'Work Sans ExtraBold'", "#FFFFFF");
	this.keyDecisionTextfield.name = "keyDecisionTextfield";
	this.keyDecisionTextfield.lineHeight = 33;
	this.keyDecisionTextfield.lineWidth = 583;
	this.keyDecisionTextfield.parent = this;
	this.keyDecisionTextfield.setTransform(-518,-160.5);
ranj.TextOffsetFixer.fix(this.keyDecisionTextfield);

	this.headerTextField = new cjs.Text("Key decision", "bold 50px 'Work Sans ExtraBold'", "#FFFFFF");
	this.headerTextField.name = "headerTextField";
	this.headerTextField.lineHeight = 74;
	this.headerTextField.lineWidth = 336;
	this.headerTextField.parent = this;
	this.headerTextField.setTransform(-367.05,-284.1);
ranj.TextOffsetFixer.fix(this.headerTextField);

	this.descriptionTextField = new cjs.Text("You have received a message of concern from a Clinic Supervisor from the IDP. It is important to figure out how best to act on this. If there appears to be an outbreak of a new virus, it is vital to prioritize. Think carefully about your choices before you send them out.", "24px 'Work Sans Medium'", "#FFFFFF");
	this.descriptionTextField.name = "descriptionTextField";
	this.descriptionTextField.lineHeight = 28;
	this.descriptionTextField.lineWidth = 582;
	this.descriptionTextField.parent = this;
	this.descriptionTextField.setTransform(-518,24.4);
ranj.TextOffsetFixer.fix(this.descriptionTextField);

	this.bg = new lib.KeyDecPopUpBG();
	this.bg.name = "bg";
	this.bg.setTransform(550.75,351,1,1,0,0,0,552,350.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.descriptionTextField},{t:this.headerTextField},{t:this.keyDecisionTextfield},{t:this.disclaimerTextField},{t:this.continueButton},{t:this.KDbackButton}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecisionAvailablePanel, new cjs.Rectangle(-553.2,-350.5,660,809), null);


(lib.KeyDecButtonUp_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// States
	this.instance = new lib.KeyDecButtonUp();
	this.instance.setTransform(3,-1);

	this.instance_1 = new lib.KeyDecButtonOver();
	this.instance_1.setTransform(108,107,1,1,0,0,0,107,107);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(1,-1,119,116);


(lib.KeyDecButton_Dialog = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Icon
	this.instance = new lib.KeyDecDialogueUp();
	this.instance.setTransform(13,10);

	this.instance_1 = new lib.KeyDecDialogueOver();
	this.instance_1.setTransform(10,8);

	this.instance_2 = new lib.KeyDecDialogueDown();
	this.instance_2.setTransform(18,16);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// States
	this.instance_3 = new lib.KeyDecButtonUp();

	this.instance_4 = new lib.KeyDecButtonOver();
	this.instance_4.setTransform(104,105,1,1,0,0,0,107,107);

	this.instance_5 = new lib.KeyDecButtonDown_1();
	this.instance_5.setTransform(102,100,1,1,0,0,0,92,93.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3}]}).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3,-2,129,126);


(lib.InternalStakeholders = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// internalStakeholder4
	this.internalStakeholder1 = new lib.InternalStakeholder1Button();
	this.internalStakeholder1.name = "internalStakeholder1";
	this.internalStakeholder1.setTransform(-345.3,-57.5,1,1,0,0,0,-95.5,-7.5);

	this.internalStakeholder2 = new lib.InternalStakeholder2Button();
	this.internalStakeholder2.name = "internalStakeholder2";
	this.internalStakeholder2.setTransform(-167.45,-57.5,1,1,0,0,0,-95.5,-7.5);

	this.internalStakeholder3 = new lib.InternalStakeholder3Button();
	this.internalStakeholder3.name = "internalStakeholder3";
	this.internalStakeholder3.setTransform(10.4,-57.5,1,1,0,0,0,-95.5,-7.5);

	this.internalStakeholder4 = new lib.InternalStakeholder4Button();
	this.internalStakeholder4.name = "internalStakeholder4";
	this.internalStakeholder4.setTransform(188.25,-57.5,1,1,0,0,0,-95.5,-7.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.internalStakeholder4},{t:this.internalStakeholder3},{t:this.internalStakeholder2},{t:this.internalStakeholder1}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.InternalStakeholders, new cjs.Rectangle(-335.8,-318.4,709.6,287.29999999999995), null);


(lib.HudSmartphoneButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// newIndicator
	this.newIndicator = new lib.HubButtonNewIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(63.25,-58.15);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(4));

	// bg
	this.instance = new lib.HUBSmartphoneUp();
	this.instance.setTransform(-89,-121);

	this.instance_1 = new lib.HUBSmartphoneOver();
	this.instance_1.setTransform(-89,-121);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-89,-121,194.3,311.4);


(lib.HudLaptopButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// newIndicator
	this.newIndicator = new lib.HubButtonNewIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(112.25,-73.15);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(4));

	// bg
	this.instance = new lib.HUBLaptopUp();
	this.instance.setTransform(-141,-99);

	this.instance_1 = new lib.HUBLaptopOver();
	this.instance_1.setTransform(-161,-119);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-161,-119,320,309.2);


(lib.HubKeyDecisionNotification_Mail = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.button = new lib.KeyDecButtonUp_1();
	this.button.name = "button";
	this.button.setTransform(15.15,19.25,1,1,0,0,0,107,107);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubKeyDecisionNotification_Mail, new cjs.Rectangle(-88.8,-88.7,113,109), null);


(lib.HubKeyDecisionNotification_Generic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// NewKDAnim
	this.NewKDAnim = new lib.NewKDAnim();
	this.NewKDAnim.name = "NewKDAnim";
	this.NewKDAnim.setTransform(-32.5,-34.5,1,1,0,0,0,56.5,54.5);

	this.timeline.addTween(cjs.Tween.get(this.NewKDAnim).to({_off:true},1).wait(6));

	// NewIndicator
	this.newKeyDecision = new lib.newKeyDecIcon();
	this.newKeyDecision.name = "newKeyDecision";
	this.newKeyDecision.setTransform(18.9,-69.5,1,1,0,0,0,25,22.5);
	this.newKeyDecision._off = true;

	this.timeline.addTween(cjs.Tween.get(this.newKeyDecision).wait(1).to({_off:false},0).wait(1).to({_off:true},1).wait(4));

	// ActiveKD
	this.button = new lib.HubKeyDecisionNotification_Mail();
	this.button.name = "button";
	this.button.setTransform(0,-0.95);
	this.button._off = true;

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1).to({_off:false},0).wait(3).to({_off:true},1).wait(2));

	// Pointer
	this.pointer = new lib.KDPopUpPointer();
	this.pointer.name = "pointer";
	this.pointer.setTransform(-95,-36.5,1,1,0,0,0,12,23.5);
	this.pointer._off = true;

	this.timeline.addTween(cjs.Tween.get(this.pointer).wait(4).to({_off:false},0).to({_off:true},1).wait(2));

	// NewIndicator
	this.panel = new lib.NewKDLabel_1();
	this.panel.name = "panel";
	this.panel.setTransform(-265.65,-29.35,1,1,0,0,0,203.5,44);
	this.panel._off = true;

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1).to({_off:false},0).to({_off:true},1).wait(5));

	// KDCompleted
	this.button_1 = new lib.KeyDecButtonCompleted_1();
	this.button_1.name = "button_1";
	this.button_1.setTransform(-33.15,-33.9,1,1,0,0,0,31.5,31.5);
	this.button_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.button_1).wait(6).to({_off:false},0).wait(1));

	// KDLocked
	this.button_2 = new lib.KeyDecButtonLocked_1();
	this.button_2.name = "button_2";
	this.button_2.setTransform(-33.15,-33.5,1,1,0,0,0,31,31);
	this.button_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.button_2).wait(5).to({_off:false},0).to({_off:true},1).wait(1));

	// Layer_2
	this.panel2 = new lib.KeyDecInfoBar();
	this.panel2.name = "panel2";
	this.panel2.setTransform(-222.45,-3.75,1,1,0,0,0,368,79);
	this.panel2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.panel2).wait(3).to({_off:false},0).to({_off:true},1).wait(3));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-590.4,-152.1,634.3,205.2);


(lib.HubKeyDecisionNotification_Dialog = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.button = new lib.KeyDecButton_Dialog();
	this.button.name = "button";
	this.button.setTransform(-2.95,4,1,1,0,0,0,107,107);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// panel
	this.panel = new lib.KeyDecInfoBar();
	this.panel.name = "panel";
	this.panel.setTransform(-160.65,-1.2,1,1,0,0,0,368,79);

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubKeyDecisionNotification_Dialog, new cjs.Rectangle(-528.6,-103,570,126.8), null);


(lib.HubKeyDecisionNotification_Composer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Dividers
	this.dividerActive = new lib.KeyDecDivider_1();
	this.dividerActive.name = "dividerActive";
	this.dividerActive.setTransform(-35.25,35.25,1,1,0,0,0,20,6.5);

	this.dividerInactive = new lib.KeyDecDivider_1();
	this.dividerInactive.name = "dividerInactive";
	this.dividerInactive.setTransform(-35.25,9.1,1,1,0,0,0,20,6.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dividerActive}]}).to({state:[{t:this.dividerInactive}]},2).wait(2));

	// NewIndicator
	this.newKeyDecision = new lib.newKeyDecIcon();
	this.newKeyDecision.name = "newKeyDecision";
	this.newKeyDecision.setTransform(12,-69.5,1,1,0,0,0,25,22.5);

	this.timeline.addTween(cjs.Tween.get(this.newKeyDecision).to({_off:true},1).wait(3));

	// KDCompleted
	this.CompletedKeyDecision = new lib.KeyDecButtonCompleted_1();
	this.CompletedKeyDecision.name = "CompletedKeyDecision";
	this.CompletedKeyDecision.setTransform(-33.15,-33.9,1,1,0,0,0,31.5,31.5);
	this.CompletedKeyDecision._off = true;

	this.timeline.addTween(cjs.Tween.get(this.CompletedKeyDecision).wait(3).to({_off:false},0).wait(1));

	// KDLocked
	this.LockedKeyDecision = new lib.KeyDecButtonLocked_1();
	this.LockedKeyDecision.name = "LockedKeyDecision";
	this.LockedKeyDecision.setTransform(-33.15,-33.5,1,1,0,0,0,31,31);
	this.LockedKeyDecision._off = true;

	this.timeline.addTween(cjs.Tween.get(this.LockedKeyDecision).wait(2).to({_off:false},0).to({_off:true},1).wait(1));

	// button
	this.button = new lib.KeyDecButtonUp_1();
	this.button.name = "button";
	this.button.setTransform(15.15,18.75,1,1,0,0,0,107,107);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1).to({_off:true},1).wait(2));

	// panel
	this.panel = new lib.KeyDecInfoBar();
	this.panel.name = "panel";
	this.panel.setTransform(-216.45,-2.8,1,1,0,0,0,368,79);

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1).to({_off:true},1).wait(2));

	// ActiveBar
	this.activeBar = new lib.KeyDecActiveBar();
	this.activeBar.name = "activeBar";
	this.activeBar.setTransform(-35.2,-31.95,1,1,0,0,0,8,70);

	this.instance = new lib.KeyDecActiveBar();
	this.instance.setTransform(-35.2,-31.95,1,1,0,0,0,8,70);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.activeBar}]}).to({state:[{t:this.instance}]},1).to({state:[]},1).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-584.4,-96.8,621.4,138.6);


(lib.FeedbackKeyDecisionNotification_Generic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// NewKDAnim
	this.instance = new lib.NewKDAnim();
	this.instance.setTransform(-32.5,-34.5,1,1,0,0,0,56.5,54.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},1).wait(6));

	// NewIndicator
	this.newKeyDecision = new lib.newKeyDecIcon();
	this.newKeyDecision.name = "newKeyDecision";
	this.newKeyDecision.setTransform(18.9,-69.5,1,1,0,0,0,25,22.5);
	this.newKeyDecision._off = true;

	this.timeline.addTween(cjs.Tween.get(this.newKeyDecision).wait(1).to({_off:false},0).wait(1).to({_off:true},1).wait(4));

	// ActiveKD
	this.button = new lib.HubKeyDecisionNotification_Mail();
	this.button.name = "button";
	this.button.setTransform(0,-0.95);
	this.button._off = true;

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1).to({_off:false},0).to({_off:true},2).wait(1).to({_off:false},0).to({_off:true},1).wait(2));

	// Pointer
	this.pointer = new lib.FeedbackPointerWhite();
	this.pointer.name = "pointer";
	this.pointer.setTransform(35.85,-36,1,1,0,0,0,12.5,24);
	this.pointer._off = true;

	this.timeline.addTween(cjs.Tween.get(this.pointer).wait(4).to({_off:false},0).to({_off:true},1).wait(2));

	// NewIndicator
	this.panel = new lib.NewKDLabel_1();
	this.panel.name = "panel";
	this.panel.setTransform(-265.65,-29.35,1,1,0,0,0,203.5,44);
	this.panel._off = true;

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1).to({_off:false},0).to({_off:true},1).wait(5));

	// KDCompleted
	this.button_1 = new lib.KeyDecButtonCompleted_1();
	this.button_1.name = "button_1";
	this.button_1.setTransform(-33.15,-33.9,1,1,0,0,0,31.5,31.5);
	this.button_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.button_1).wait(6).to({_off:false},0).wait(1));

	// KDLocked
	this.button_2 = new lib.KeyDecButtonLocked_1();
	this.button_2.name = "button_2";
	this.button_2.setTransform(-33.15,-33.5,1,1,0,0,0,31,31);
	this.button_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.button_2).wait(5).to({_off:false},0).to({_off:true},1).wait(1));

	// Layer_4
	this.buttonFeedbackInactive = new lib.FeedbackInactiveKDstate();
	this.buttonFeedbackInactive.name = "buttonFeedbackInactive";
	this.buttonFeedbackInactive.setTransform(-34.25,-36.3,1,1,0,0,0,24,24.5);
	this.buttonFeedbackInactive._off = true;

	this.timeline.addTween(cjs.Tween.get(this.buttonFeedbackInactive).wait(3).to({_off:false},0).to({_off:true},1).wait(3));

	// Layer_2
	this.panel2 = new lib.FeedbackTimelineInfoBar();
	this.panel2.name = "panel2";
	this.panel2.setTransform(248.95,-31,1,1,0,0,0,254,48);
	this.panel2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.panel2).wait(3).to({_off:false},0).to({_off:true},1).wait(3));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-469.1,-152.1,972.1,205.2);


(lib.FeedbackKeyDecisionElaboration = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.button = new lib.KeyDecButtonUp_1();
	this.button.name = "button";
	this.button.setTransform(15.15,19.25,1,1,0,0,0,107,107);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackKeyDecisionElaboration, new cjs.Rectangle(-88.8,-88.7,113,109), null);


(lib.FeedbackKeyDecisionContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// KDLocked
	this.instance = new lib.FeedbackKDInactiveButton();
	this.instance.setTransform(-63.65,-35.5,1,1,0,0,0,29.5,28.5);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2).to({_off:false},0).to({_off:true},1).wait(3));

	// FeedbackPointer
	this.FeedbackPointer = new lib.FeedbackPointer_1();
	this.FeedbackPointer.name = "FeedbackPointer";
	this.FeedbackPointer.setTransform(18.5,-36,1,1,0,0,0,21.5,48);

	this.timeline.addTween(cjs.Tween.get(this.FeedbackPointer).to({_off:true},2).wait(4));

	// ActiveKD_s
	this.instance_1 = new lib.FeedbackKeyDecisionElaboration();
	this.instance_1.setTransform(187.8,-34.15,1,1,0,0,0,214.8,-33.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({_off:true},2).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-584.4,-96.8,624.4,133);


(lib.TopicButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// New_Topic_Indicator
	this.newIndicator = new lib.newIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(190,-10);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(4));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("When will we be able to test the ", "18px 'Arial'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 22;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(18,8);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("When will we be able to test the ", "18px 'Arial'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 22;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(18,8);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("When will we be able to test the ", "18px 'Arial'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 22;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(18,8);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("When will we be able to test the ", "18px 'Arial'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 22;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(18,8);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_3
	this.instance = new lib.TopicButtonUpBG();
	this.instance.setTransform(117.5,32);

	this.instance_1 = new lib.TopicButtonDownBG();
	this.instance_1.setTransform(117.5,32);

	this.instance_2 = new lib.TopicButtonDisabledBG();
	this.instance_2.setTransform(117.5,32);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-10,245,102.2);


(lib.RightAnimationMC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_23 = function() {
		//stop();
		///* js 
		//this.stop(); 
		//*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(23).call(this.frame_23).wait(1));

	// Layer_4 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EgmMAFUIAAqnMBMZAAAIAAKng");
	mask.setTransform(241,31.5);

	// Layer_3_copy
	this.instance = new lib.AnswerShineMC();
	this.instance.setTransform(-73,55,1,1,0,0,0,95.1,147.7);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({x:20.4},0).wait(1).to({x:113.85},0).wait(1).to({x:207.25},0).wait(1).to({x:300.7},0).wait(1).to({x:394.1},0).wait(1).to({x:487.55},0).wait(1).to({x:581},0).wait(6).to({x:-107},0).wait(1).to({x:-10.05},0).wait(1).to({x:86.95},0).wait(1).to({x:183.95},0).wait(1).to({x:280.95},0).wait(1).to({x:377.95},0).wait(1).to({x:474.95},0).wait(1).to({x:572},0).wait(4));

	// Green
	this.instance_1 = new lib.DialogButtonRight();

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(24));

	// Layer_2
	this.instance_2 = new lib.UnderlineMC();
	this.instance_2.setTransform(241.5,32,1,1,0,0,0,244.5,34);
	this.instance_2.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1).to({alpha:0.25},0).wait(1).to({alpha:0.5},0).wait(1).to({alpha:0.75},0).wait(1).to({alpha:1},0).wait(16).to({alpha:0.75},0).wait(1).to({alpha:0.5},0).wait(1).to({alpha:0.25},0).wait(1).to({alpha:0},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-202.1,-92.7,878.2,295.5);


(lib.Map_Chapter3_Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.text = new cjs.Text("Tamdu PHC", "bold 28px 'Work Sans'", "#324141");
	this.text.lineHeight = 35;
	this.text.lineWidth = 325;
	this.text.parent = this;
	this.text.setTransform(-321.6,266.25);
ranj.TextOffsetFixer.fix(this.text);

	this.text_1 = new cjs.Text("IDP Settlement 1 PHC", "bold 28px 'Work Sans'", "#324141");
	this.text_1.lineHeight = 35;
	this.text_1.lineWidth = 325;
	this.text_1.parent = this;
	this.text_1.setTransform(-395,95.25);
ranj.TextOffsetFixer.fix(this.text_1);

	this.instance = new lib.MapLocationNode();
	this.instance.setTransform(-339.6,260.25);

	this.text_2 = new cjs.Text("MoH Office", "bold 28px 'Work Sans'", "#324141");
	this.text_2.lineHeight = 35;
	this.text_2.lineWidth = 325;
	this.text_2.parent = this;
	this.text_2.setTransform(253.6,150.15);
ranj.TextOffsetFixer.fix(this.text_2);

	this.instance_1 = new lib.MapLocationNode();
	this.instance_1.setTransform(235.6,133.15);

	this.text_3 = new cjs.Text("Thisland Relief", "bold 28px 'Work Sans'", "#324141");
	this.text_3.lineHeight = 35;
	this.text_3.lineWidth = 227;
	this.text_3.parent = this;
	this.text_3.setTransform(-49.4,-52.6);
ranj.TextOffsetFixer.fix(this.text_3);

	this.text_4 = new cjs.Text("Murelle PHC", "28px 'Work Sans'", "#6B4731");
	this.text_4.lineHeight = 35;
	this.text_4.lineWidth = 192;
	this.text_4.alpha = 0.60000000;
	this.text_4.parent = this;
	this.text_4.setTransform(-98.8,-184.75);
ranj.TextOffsetFixer.fix(this.text_4);

	this.text_5 = new cjs.Text("IDP Settlement 4 PHC", "28px 'Work Sans'", "#6B4731");
	this.text_5.lineHeight = 35;
	this.text_5.lineWidth = 325;
	this.text_5.alpha = 0.60000000;
	this.text_5.parent = this;
	this.text_5.setTransform(284.25,58.2);
ranj.TextOffsetFixer.fix(this.text_5);

	this.text_6 = new cjs.Text("IDP Settlement 3 PHC", "28px 'Work Sans'", "#6B4731");
	this.text_6.lineHeight = 35;
	this.text_6.lineWidth = 325;
	this.text_6.alpha = 0.60000000;
	this.text_6.parent = this;
	this.text_6.setTransform(156.05,-267.85);
ranj.TextOffsetFixer.fix(this.text_6);

	this.text_7 = new cjs.Text("District hospital", "28px 'Work Sans'", "#6B4731");
	this.text_7.lineHeight = 35;
	this.text_7.lineWidth = 238;
	this.text_7.alpha = 0.60000000;
	this.text_7.parent = this;
	this.text_7.setTransform(181.75,-118.5);
ranj.TextOffsetFixer.fix(this.text_7);

	this.text_8 = new cjs.Text("Bakuna PHC", "28px 'Work Sans'", "#6B4731");
	this.text_8.lineHeight = 35;
	this.text_8.lineWidth = 375;
	this.text_8.alpha = 0.60000000;
	this.text_8.parent = this;
	this.text_8.setTransform(116,-429.45);
ranj.TextOffsetFixer.fix(this.text_8);

	this.text_9 = new cjs.Text("IDP Settlement 2 PHC", "28px 'Work Sans'", "#6B4731");
	this.text_9.lineHeight = 35;
	this.text_9.lineWidth = 325;
	this.text_9.alpha = 0.60000000;
	this.text_9.parent = this;
	this.text_9.setTransform(-408.95,-228.8);
ranj.TextOffsetFixer.fix(this.text_9);

	this.text_10 = new cjs.Text("Simberry Farms", "28px 'Work Sans'", "#6B4731");
	this.text_10.lineHeight = 35;
	this.text_10.lineWidth = 228;
	this.text_10.alpha = 0.60000000;
	this.text_10.parent = this;
	this.text_10.setTransform(-698.85,214.75);
ranj.TextOffsetFixer.fix(this.text_10);

	this.text_11 = new cjs.Text("Murelle", "bold 42px 'Work Sans'", "#6B4731");
	this.text_11.lineHeight = 51;
	this.text_11.lineWidth = 169;
	this.text_11.alpha = 0.60000000;
	this.text_11.parent = this;
	this.text_11.setTransform(188.75,-172.8);
ranj.TextOffsetFixer.fix(this.text_11);

	this.instance_2 = new lib.MapNodeSmall();
	this.instance_2.setTransform(95.9,-421.25,1,1,0,0,0,10.2,10.2);
	this.instance_2.alpha = 0.4297;

	this.instance_3 = new lib.MapNodeSmall();
	this.instance_3.setTransform(-460.35,244.05,1,1,0,0,0,10.2,10.2);
	this.instance_3.alpha = 0.4297;

	this.instance_4 = new lib.MapNodeSmall();
	this.instance_4.setTransform(-439.95,-228.45,1,1,0,0,0,10.2,10.2);
	this.instance_4.alpha = 0.4297;

	this.instance_5 = new lib.MapNodeSmall();
	this.instance_5.setTransform(157.25,-99.8,1,1,0,0,0,10.2,10.2);
	this.instance_5.alpha = 0.4297;

	this.instance_6 = new lib.MapNodeSmall();
	this.instance_6.setTransform(136.85,-280.05,1,1,0,0,0,10.2,10.2);
	this.instance_6.alpha = 0.4297;

	this.instance_7 = new lib.MapNodeSmall();
	this.instance_7.setTransform(258.5,60.8,1,1,0,0,0,10.2,10.2);
	this.instance_7.alpha = 0.4297;

	this.instance_8 = new lib.MapLocationNode();
	this.instance_8.setTransform(-419.95,143.8);

	this.instance_9 = new lib.MapNodeSmall();
	this.instance_9.setTransform(31.55,-130.7,1,1,0,0,0,10.2,10.2);

	this.instance_10 = new lib.MapLocationNode();
	this.instance_10.setTransform(90.1,-77.35);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.text_11},{t:this.text_10},{t:this.text_9},{t:this.text_8},{t:this.text_7},{t:this.text_6},{t:this.text_5},{t:this.text_4},{t:this.text_3},{t:this.instance_1},{t:this.text_2},{t:this.instance},{t:this.text_1},{t:this.text}]}).wait(1));

	// MapBG
	this.instance_11 = new lib.HUBmapCh1jpgcopy();
	this.instance_11.setTransform(-962,-541);

	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Map_Chapter3_Background, new cjs.Rectangle(-962,-541,1922,1081), null);


(lib.Map_Chapter2_Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.text = new cjs.Text("Simberri Farms", "bold 28px 'Work Sans'", "#324141");
	this.text.textAlign = "center";
	this.text.lineHeight = 35;
	this.text.lineWidth = 272;
	this.text.parent = this;
	this.text.setTransform(-66.55,256.8);
ranj.TextOffsetFixer.fix(this.text);

	this.text_1 = new cjs.Text("Community Meeting Space", "bold 28px 'Work Sans'", "#324141");
	this.text_1.textAlign = "center";
	this.text_1.lineHeight = 35;
	this.text_1.lineWidth = 215;
	this.text_1.parent = this;
	this.text_1.setTransform(245.2,144.5);
ranj.TextOffsetFixer.fix(this.text_1);

	this.text_2 = new cjs.Text("Ready PHC", "bold 28px 'Work Sans'", "#324141");
	this.text_2.lineHeight = 35;
	this.text_2.lineWidth = 205;
	this.text_2.parent = this;
	this.text_2.setTransform(348.75,47.85);
ranj.TextOffsetFixer.fix(this.text_2);

	this.text_3 = new cjs.Text("IDP Female Head of Household", "bold 28px 'Work Sans'", "#324141");
	this.text_3.textAlign = "center";
	this.text_3.lineHeight = 35;
	this.text_3.lineWidth = 259;
	this.text_3.parent = this;
	this.text_3.setTransform(-232.65,-86.2);
ranj.TextOffsetFixer.fix(this.text_3);

	this.text_4 = new cjs.Text("Ready PHC", "bold 28px 'Work Sans'", "#324141");
	this.text_4.lineHeight = 35;
	this.text_4.lineWidth = 205;
	this.text_4.parent = this;
	this.text_4.setTransform(41.8,-203.9);
ranj.TextOffsetFixer.fix(this.text_4);

	this.text_5 = new cjs.Text("Community Meeting Space", "bold 28px 'Work Sans'", "#324141");
	this.text_5.textAlign = "center";
	this.text_5.lineHeight = 35;
	this.text_5.lineWidth = 215;
	this.text_5.parent = this;
	this.text_5.setTransform(19.6,-18.6);
ranj.TextOffsetFixer.fix(this.text_5);

	this.text_6 = new cjs.Text("KALDOMA REGION", "40px 'Work Sans Light'", "#324141");
	this.text_6.lineHeight = 49;
	this.text_6.lineWidth = 373;
	this.text_6.parent = this;
	this.text_6.setTransform(-666.8,144.5);
ranj.TextOffsetFixer.fix(this.text_6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text_6},{t:this.text_5},{t:this.text_4},{t:this.text_3},{t:this.text_2},{t:this.text_1},{t:this.text}]}).wait(1));

	// MapNodes
	this.text_7 = new cjs.Text("IDP Settlement 1", "bold 42px 'Work Sans'", "#6B4731");
	this.text_7.lineHeight = 51;
	this.text_7.lineWidth = 419;
	this.text_7.alpha = 0.60000000;
	this.text_7.parent = this;
	this.text_7.setTransform(6.8,-287.3);
ranj.TextOffsetFixer.fix(this.text_7);

	this.instance = new lib.MapLocationNode();
	this.instance.setTransform(313.2,70.1);

	this.instance_1 = new lib.MapLocationNode();
	this.instance_1.setTransform(221.2,124.35);

	this.instance_2 = new lib.MapLocationNode();
	this.instance_2.setTransform(23.8,-38.9);

	this.instance_3 = new lib.MapLocationNode();
	this.instance_3.setTransform(-87.9,-87.85);

	this.text_8 = new cjs.Text("Tamdu", "bold 42px 'Work Sans'", "#6B4731");
	this.text_8.lineHeight = 51;
	this.text_8.lineWidth = 169;
	this.text_8.alpha = 0.60000000;
	this.text_8.parent = this;
	this.text_8.setTransform(204.2,223.05);
ranj.TextOffsetFixer.fix(this.text_8);

	this.instance_4 = new lib.MapNodeSmall();
	this.instance_4.setTransform(-170.45,240.85,1,1,0,0,0,10.2,10.2);
	this.instance_4.alpha = 0.4297;

	this.instance_5 = new lib.MapLocationNode();
	this.instance_5.setTransform(23.8,-159.65);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.text_8},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance},{t:this.text_7}]}).wait(1));

	// MapBG
	this.instance_6 = new lib.HUBmapCh1_1();
	this.instance_6.setTransform(-961,-541);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Map_Chapter2_Background, new cjs.Rectangle(-961,-541,1921,1081), null);


(lib.Map_Chapter1_Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.text = new cjs.Text("Tamdu PHC", "bold 28px 'Work Sans'", "#324141");
	this.text.lineHeight = 35;
	this.text.lineWidth = 325;
	this.text.parent = this;
	this.text.setTransform(-321.6,266.25);
ranj.TextOffsetFixer.fix(this.text);

	this.text_1 = new cjs.Text("Murelle PHC", "28px 'Work Sans'", "#6B4731");
	this.text_1.lineHeight = 35;
	this.text_1.lineWidth = 192;
	this.text_1.alpha = 0.60000000;
	this.text_1.parent = this;
	this.text_1.setTransform(-98.8,-184.75);
ranj.TextOffsetFixer.fix(this.text_1);

	this.text_2 = new cjs.Text("IDP Settlement 1 PHC", "bold 28px 'Work Sans'", "#324141");
	this.text_2.lineHeight = 35;
	this.text_2.lineWidth = 325;
	this.text_2.parent = this;
	this.text_2.setTransform(-395,95.25);
ranj.TextOffsetFixer.fix(this.text_2);

	this.text_3 = new cjs.Text("Thisland Relief", "bold 28px 'Work Sans'", "#324141");
	this.text_3.lineHeight = 35;
	this.text_3.lineWidth = 227;
	this.text_3.parent = this;
	this.text_3.setTransform(-49.4,-52.6);
ranj.TextOffsetFixer.fix(this.text_3);

	this.text_4 = new cjs.Text("IDP Settlement 4 PHC", "28px 'Work Sans'", "#6B4731");
	this.text_4.lineHeight = 35;
	this.text_4.lineWidth = 325;
	this.text_4.alpha = 0.60000000;
	this.text_4.parent = this;
	this.text_4.setTransform(284.25,58.2);
ranj.TextOffsetFixer.fix(this.text_4);

	this.text_5 = new cjs.Text("IDP Settlement 3 PHC", "28px 'Work Sans'", "#6B4731");
	this.text_5.lineHeight = 35;
	this.text_5.lineWidth = 325;
	this.text_5.alpha = 0.60000000;
	this.text_5.parent = this;
	this.text_5.setTransform(156.05,-267.85);
ranj.TextOffsetFixer.fix(this.text_5);

	this.text_6 = new cjs.Text("District hospital", "28px 'Work Sans'", "#6B4731");
	this.text_6.lineHeight = 35;
	this.text_6.lineWidth = 238;
	this.text_6.alpha = 0.60000000;
	this.text_6.parent = this;
	this.text_6.setTransform(181.75,-118.5);
ranj.TextOffsetFixer.fix(this.text_6);

	this.text_7 = new cjs.Text("Bakuna PHC", "28px 'Work Sans'", "#6B4731");
	this.text_7.lineHeight = 35;
	this.text_7.lineWidth = 375;
	this.text_7.alpha = 0.60000000;
	this.text_7.parent = this;
	this.text_7.setTransform(116,-429.45);
ranj.TextOffsetFixer.fix(this.text_7);

	this.text_8 = new cjs.Text("IDP Settlement 2 PHC", "28px 'Work Sans'", "#6B4731");
	this.text_8.lineHeight = 35;
	this.text_8.lineWidth = 325;
	this.text_8.alpha = 0.60000000;
	this.text_8.parent = this;
	this.text_8.setTransform(-408.95,-228.8);
ranj.TextOffsetFixer.fix(this.text_8);

	this.text_9 = new cjs.Text("Simberry Farms", "28px 'Work Sans'", "#6B4731");
	this.text_9.lineHeight = 35;
	this.text_9.lineWidth = 228;
	this.text_9.alpha = 0.60000000;
	this.text_9.parent = this;
	this.text_9.setTransform(-698.85,214.75);
ranj.TextOffsetFixer.fix(this.text_9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.text_9},{t:this.text_8},{t:this.text_7},{t:this.text_6},{t:this.text_5},{t:this.text_4},{t:this.text_3},{t:this.text_2},{t:this.text_1},{t:this.text}]}).wait(1));

	// MapNodes
	this.text_10 = new cjs.Text("Murelle", "bold 42px 'Work Sans'", "#6B4731");
	this.text_10.lineHeight = 51;
	this.text_10.lineWidth = 169;
	this.text_10.alpha = 0.60000000;
	this.text_10.parent = this;
	this.text_10.setTransform(188.75,-172.8);
ranj.TextOffsetFixer.fix(this.text_10);

	this.instance = new lib.MapNodeSmall();
	this.instance.setTransform(95.9,-421.25,1,1,0,0,0,10.2,10.2);
	this.instance.alpha = 0.4297;

	this.instance_1 = new lib.MapNodeSmall();
	this.instance_1.setTransform(-460.35,244.05,1,1,0,0,0,10.2,10.2);
	this.instance_1.alpha = 0.4297;

	this.instance_2 = new lib.MapNodeSmall();
	this.instance_2.setTransform(-439.95,-228.45,1,1,0,0,0,10.2,10.2);
	this.instance_2.alpha = 0.4297;

	this.instance_3 = new lib.MapNodeSmall();
	this.instance_3.setTransform(157.25,-99.8,1,1,0,0,0,10.2,10.2);
	this.instance_3.alpha = 0.4297;

	this.instance_4 = new lib.MapNodeSmall();
	this.instance_4.setTransform(136.85,-280.05,1,1,0,0,0,10.2,10.2);
	this.instance_4.alpha = 0.4297;

	this.instance_5 = new lib.MapNodeSmall();
	this.instance_5.setTransform(258.5,60.8,1,1,0,0,0,10.2,10.2);
	this.instance_5.alpha = 0.4297;

	this.instance_6 = new lib.MapLocationNode();
	this.instance_6.setTransform(-339.6,260.25);

	this.instance_7 = new lib.MapLocationNode();
	this.instance_7.setTransform(-419.95,143.8);

	this.instance_8 = new lib.MapNodeSmall();
	this.instance_8.setTransform(31.55,-130.7,1,1,0,0,0,10.2,10.2);

	this.instance_9 = new lib.MapLocationNode();
	this.instance_9.setTransform(90.1,-77.35);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance},{t:this.text_10}]}).wait(1));

	// MapBG
	this.instance_10 = new lib.HUBmapCh1();
	this.instance_10.setTransform(-961,-541);

	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Map_Chapter1_Background, new cjs.Rectangle(-961,-541,1922,1081), null);


(lib.PlaceholderPoiImage = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,"selectedUp":4,"selectedOver":5,"selectedDown":6,"selectedDisabled":7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AgxJ+IlSlSQgVgVAAgdIAAnzQAAgdAVgVIFSlSQAVgUAcgBQAeABATAUIFTFSQAVAVAAAdIAAHzQAAAdgVAVIlTFSQgTAVgeAAQgcAAgVgVg");
	mask.setTransform(0.025,-26.45);

	// Laag_3
	this.locationContainer = new lib.locationContainer();
	this.locationContainer.name = "locationContainer";
	this.locationContainer.setTransform(-24.15,19.75,1,1,0,0,0,41,65);

	var maskedShapeInstanceList = [this.locationContainer];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.locationContainer).wait(8));

	// disabledNodeColor
	this.instance = new lib.NodeColor07();
	this.instance.setTransform(-40,-39);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(3).to({_off:false},0).to({_off:true},1).wait(3).to({_off:false},0).wait(1));

	// NodeColor06
	this.NodeColor06 = new lib.NodeColor06();
	this.NodeColor06.name = "NodeColor06";
	this.NodeColor06.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor06).wait(8));

	// NodeColor05
	this.NodeColor05 = new lib.NodeColor05();
	this.NodeColor05.name = "NodeColor05";
	this.NodeColor05.setTransform(-1,0.5,1,1,0,0,0,39,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor05).wait(8));

	// NodeColor04
	this.NodeColor04 = new lib.NodeColor04();
	this.NodeColor04.name = "NodeColor04";
	this.NodeColor04.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor04).wait(8));

	// NodeColor03
	this.NodeColor03 = new lib.NodeColor03();
	this.NodeColor03.name = "NodeColor03";
	this.NodeColor03.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.instance_1 = new lib.POI_NodeColor01();
	this.instance_1.setTransform(-40,-39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.NodeColor03}]}).wait(8));

	// NodeColor02
	this.NodeColor02 = new lib.NodeColor02();
	this.NodeColor02.name = "NodeColor02";
	this.NodeColor02.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.instance_2 = new lib.POI_NodeColor01();
	this.instance_2.setTransform(-40,-39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.NodeColor02}]}).wait(8));

	// NodeColor01
	this.NodeColor01 = new lib.NodeColor01();
	this.NodeColor01.name = "NodeColor01";
	this.NodeColor01.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor01).wait(8));

	// Laag_1
	this.instance_3 = new lib.PoILabel3Up();
	this.instance_3.setTransform(-60,-68);

	this.instance_4 = new lib.PoILabel3Over();
	this.instance_4.setTransform(-60,-68);

	this.instance_5 = new lib.TopLeftDisabled();
	this.instance_5.setTransform(-61,-69);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3}]}).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_3},{t:this.instance_5}]},2).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_3},{t:this.instance_5}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-61,-69,120,139);


(lib.PlaceholderPoiCharacter = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"over":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// iconMask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AgxJ+IlSlSQgVgVAAgdIAAnzQAAgdAVgVIFSlSQAVgUAcgBQAeABATAUIFTFSQAVAVAAAdIAAHzQAAAdgVAVIlTFSQgTAVgeAAQgcAAgVgVg");
	mask.setTransform(0.025,-26.45);

	// icon
	this.characterContainer = new lib.PoiCharacterIconContainer();
	this.characterContainer.name = "characterContainer";
	this.characterContainer.setTransform(4,-7);

	var maskedShapeInstanceList = [this.characterContainer];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.characterContainer).wait(4));

	// NodeColor06
	this.NodeColor06 = new lib.NodeColor06();
	this.NodeColor06.name = "NodeColor06";
	this.NodeColor06.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor06).wait(4));

	// NodeColor05
	this.NodeColor05 = new lib.NodeColor05();
	this.NodeColor05.name = "NodeColor05";
	this.NodeColor05.setTransform(-1,0.5,1,1,0,0,0,39,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor05).wait(4));

	// NodeColor04
	this.NodeColor04 = new lib.NodeColor04();
	this.NodeColor04.name = "NodeColor04";
	this.NodeColor04.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor04).wait(4));

	// NodeColor03
	this.NodeColor03 = new lib.NodeColor03();
	this.NodeColor03.name = "NodeColor03";
	this.NodeColor03.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.instance = new lib.POI_NodeColor01();
	this.instance.setTransform(-40,-39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.NodeColor03}]}).wait(4));

	// NodeColor02
	this.NodeColor02 = new lib.NodeColor02();
	this.NodeColor02.name = "NodeColor02";
	this.NodeColor02.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.instance_1 = new lib.POI_NodeColor01();
	this.instance_1.setTransform(-40,-39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.NodeColor02}]}).wait(4));

	// NodeColor01
	this.NodeColor01 = new lib.NodeColor01();
	this.NodeColor01.name = "NodeColor01";
	this.NodeColor01.setTransform(-0.5,0.5,1,1,0,0,0,39.5,39.5);

	this.timeline.addTween(cjs.Tween.get(this.NodeColor01).wait(4));

	// bitmap
	this.instance_2 = new lib.PoILabel0Up();
	this.instance_2.setTransform(-60,-68);

	this.instance_3 = new lib.PoILabel0Over();
	this.instance_3.setTransform(-60,-68);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-60,-72,119,142);


(lib.PlanComposerKeyDecision_Topic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.ExplanationTextField = new cjs.Text("Drag three options to compose your plan", "24px 'Work Sans'", "#2C3C3C");
	this.ExplanationTextField.name = "ExplanationTextField";
	this.ExplanationTextField.textAlign = "center";
	this.ExplanationTextField.lineHeight = 30;
	this.ExplanationTextField.lineWidth = 805;
	this.ExplanationTextField.parent = this;
	this.ExplanationTextField.setTransform(414.95,450.15);
ranj.TextOffsetFixer.fix(this.ExplanationTextField);

	this.Answer6 = new lib.PlanComposerKeyDecision_AnswerButton();
	this.Answer6.name = "Answer6";
	this.Answer6.setTransform(1123.7,754.8,1,1,0,0,0,212.2,31.3);

	this.Answer5 = new lib.PlanComposerKeyDecision_AnswerButton();
	this.Answer5.name = "Answer5";
	this.Answer5.setTransform(1123.7,608.5,1,1,0,0,0,212.2,31.3);

	this.Answer4 = new lib.PlanComposerKeyDecision_AnswerButton();
	this.Answer4.name = "Answer4";
	this.Answer4.setTransform(1123.7,462.2,1,1,0,0,0,212.2,31.3);

	this.Answer3 = new lib.PlanComposerKeyDecision_AnswerButton();
	this.Answer3.name = "Answer3";
	this.Answer3.setTransform(1123.7,315.9,1,1,0,0,0,212.2,31.3);

	this.Answer2 = new lib.PlanComposerKeyDecision_AnswerButton();
	this.Answer2.name = "Answer2";
	this.Answer2.setTransform(1123.7,169.6,1,1,0,0,0,212.2,31.3);

	this.Answer1 = new lib.PlanComposerKeyDecision_AnswerButton();
	this.Answer1.name = "Answer1";
	this.Answer1.setTransform(1123.7,23.3,1,1,0,0,0,212.2,31.3);

	this.topicQuestionTextField = new cjs.Text("What first priority steps do you need to take when hearing of a possible outbreak?  What first priority steps do you need to take when hearing of a possible outbreak?  What first priority steps do you need to take when hearing of a possible outbreak?  ", "24px 'Work Sans'", "#2C3C3C");
	this.topicQuestionTextField.name = "topicQuestionTextField";
	this.topicQuestionTextField.lineHeight = 30;
	this.topicQuestionTextField.lineWidth = 761;
	this.topicQuestionTextField.parent = this;
	this.topicQuestionTextField.setTransform(32.85,68.45);
ranj.TextOffsetFixer.fix(this.topicQuestionTextField);

	this.DropZone3 = new lib.PlanComposerKeyDecision_AnsweSlot();
	this.DropZone3.name = "DropZone3";
	this.DropZone3.setTransform(414.75,601.6,1,1,0,0,0,403.5,68.5);

	this.DropZone2 = new lib.PlanComposerKeyDecision_AnsweSlot();
	this.DropZone2.name = "DropZone2";
	this.DropZone2.setTransform(414.75,461.25,1,1,0,0,0,403.5,68.5);

	this.DropZone1 = new lib.PlanComposerKeyDecision_AnsweSlot();
	this.DropZone1.name = "DropZone1";
	this.DropZone1.setTransform(414.75,320.95,1,1,0,0,0,403.5,68.5);

	this.AnswerContainer = new lib.PlanComposerKeyDecision_AnswerContainerInactive();
	this.AnswerContainer.name = "AnswerContainer";
	this.AnswerContainer.setTransform(415.5,461.05,1,1,0,0,0,415.5,222.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.AnswerContainer},{t:this.DropZone1},{t:this.DropZone2},{t:this.DropZone3},{t:this.topicQuestionTextField},{t:this.Answer1},{t:this.Answer2},{t:this.Answer3},{t:this.Answer4},{t:this.Answer5},{t:this.Answer6},{t:this.ExplanationTextField}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerKeyDecision_Topic, new cjs.Rectangle(0,-10,1739.2,892.5), null);


(lib.FeedbackWhiteScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Titles
	this.READYfeedbackTitle = new cjs.Text("READY feedback", "28px 'Work Sans SemiBold'", "#324141");
	this.READYfeedbackTitle.name = "READYfeedbackTitle";
	this.READYfeedbackTitle.lineHeight = 35;
	this.READYfeedbackTitle.lineWidth = 252;
	this.READYfeedbackTitle.parent = this;
	this.READYfeedbackTitle.setTransform(789,343.4);
ranj.TextOffsetFixer.fix(this.READYfeedbackTitle);

	this.yourAnswersTitle = new cjs.Text("Your answers", "28px 'Work Sans SemiBold'", "#324141");
	this.yourAnswersTitle.name = "yourAnswersTitle";
	this.yourAnswersTitle.lineHeight = 35;
	this.yourAnswersTitle.lineWidth = 252;
	this.yourAnswersTitle.parent = this;
	this.yourAnswersTitle.setTransform(101.55,343.4);
ranj.TextOffsetFixer.fix(this.yourAnswersTitle);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.yourAnswersTitle},{t:this.READYfeedbackTitle}]}).wait(1));

	// feedback
	this.AnswerFeedback4 = new cjs.Text("Decide how recruitment of Community Health Workers should proceed as the number of infections increases. Decide how recruitment of Community Health Workers should proceed as the number of infections increases. ", "20px 'Work Sans'", "#2C3C3C");
	this.AnswerFeedback4.name = "AnswerFeedback4";
	this.AnswerFeedback4.lineHeight = 23;
	this.AnswerFeedback4.lineWidth = 931;
	this.AnswerFeedback4.parent = this;
	this.AnswerFeedback4.setTransform(789,807,0.9999,1);
ranj.TextOffsetFixer.fix(this.AnswerFeedback4);

	this.AnswerFeedback3 = new cjs.Text("Virtual training may not be effective for training CHWs on EnVD response. Focusing on general precautions and notifying RRT about all possible cases may dilute focus on actual EnVD cases.", "20px 'Work Sans'", "#2C3C3C");
	this.AnswerFeedback3.name = "AnswerFeedback3";
	this.AnswerFeedback3.lineHeight = 23;
	this.AnswerFeedback3.lineWidth = 931;
	this.AnswerFeedback3.parent = this;
	this.AnswerFeedback3.setTransform(789,676,0.9999,1);
ranj.TextOffsetFixer.fix(this.AnswerFeedback3);

	this.AnswerFeedback2 = new cjs.Text("Waiting for a week to gather the paper line list data from CHWs can lead to a delay in identifying and addressing any emerging trends, which can result in a missed opportunity for early intervention.", "20px 'Work Sans'", "#2C3C3C");
	this.AnswerFeedback2.name = "AnswerFeedback2";
	this.AnswerFeedback2.lineHeight = 23;
	this.AnswerFeedback2.lineWidth = 931;
	this.AnswerFeedback2.parent = this;
	this.AnswerFeedback2.setTransform(789,545.5,0.9999,1);
ranj.TextOffsetFixer.fix(this.AnswerFeedback2);

	this.AnswerFeedback1 = new cjs.Text("Pausing all other CHW activities can have negative consequences. It can lead to a disruption of essential health services, which may be critical to the health and well-being of the community.", "20px 'Work Sans'", "#2C3C3C");
	this.AnswerFeedback1.name = "AnswerFeedback1";
	this.AnswerFeedback1.lineHeight = 23;
	this.AnswerFeedback1.lineWidth = 931;
	this.AnswerFeedback1.parent = this;
	this.AnswerFeedback1.setTransform(789,417,0.9999,1);
ranj.TextOffsetFixer.fix(this.AnswerFeedback1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.AnswerFeedback1},{t:this.AnswerFeedback2},{t:this.AnswerFeedback3},{t:this.AnswerFeedback4}]}).wait(1));

	// answers
	this.ButtonAnswerGood4 = new lib.FeedbackButtonGood();
	this.ButtonAnswerGood4.name = "ButtonAnswerGood4";
	this.ButtonAnswerGood4.setTransform(468.6,869.5,1,1,0,0,0,130.1,33);

	this.ButtonAnswerGood3 = new lib.FeedbackButtonGood();
	this.ButtonAnswerGood3.name = "ButtonAnswerGood3";
	this.ButtonAnswerGood3.setTransform(468.6,739,1,1,0,0,0,130.1,33);

	this.ButtonAnswerGood2 = new lib.FeedbackButtonGood();
	this.ButtonAnswerGood2.name = "ButtonAnswerGood2";
	this.ButtonAnswerGood2.setTransform(468.6,608,1,1,0,0,0,130.1,33);

	this.ButtonAnswerGood1 = new lib.FeedbackButtonGood();
	this.ButtonAnswerGood1.name = "ButtonAnswerGood1";
	this.ButtonAnswerGood1.setTransform(468.6,479,1,1,0,0,0,130.1,33);

	this.ButtonAnswerMedium4 = new lib.FeedbackButtonMedium();
	this.ButtonAnswerMedium4.name = "ButtonAnswerMedium4";
	this.ButtonAnswerMedium4.setTransform(468.6,869.5,1,1,0,0,0,130.1,33);

	this.ButtonAnswerMedium3 = new lib.FeedbackButtonMedium();
	this.ButtonAnswerMedium3.name = "ButtonAnswerMedium3";
	this.ButtonAnswerMedium3.setTransform(468.6,739,1,1,0,0,0,130.1,33);

	this.ButtonAnswerMedium2 = new lib.FeedbackButtonMedium();
	this.ButtonAnswerMedium2.name = "ButtonAnswerMedium2";
	this.ButtonAnswerMedium2.setTransform(468.65,608,1,1,0,0,0,130.1,33);

	this.ButtonAnswerMedium1 = new lib.FeedbackButtonMedium();
	this.ButtonAnswerMedium1.name = "ButtonAnswerMedium1";
	this.ButtonAnswerMedium1.setTransform(468.6,479,1,1,0,0,0,130.1,33);

	this.ButtonAnswerBad4 = new lib.FeedbackButtonBad();
	this.ButtonAnswerBad4.name = "ButtonAnswerBad4";
	this.ButtonAnswerBad4.setTransform(468.6,869.5,1,1,0,0,0,130.1,33);

	this.ButtonAnswerBad3 = new lib.FeedbackButtonBad();
	this.ButtonAnswerBad3.name = "ButtonAnswerBad3";
	this.ButtonAnswerBad3.setTransform(468.6,739,1,1,0,0,0,130.1,33);

	this.ButtonAnswerBad2 = new lib.FeedbackButtonBad();
	this.ButtonAnswerBad2.name = "ButtonAnswerBad2";
	this.ButtonAnswerBad2.setTransform(468.6,608,1,1,0,0,0,130.1,33);

	this.ButtonAnswerBad1 = new lib.FeedbackButtonBad();
	this.ButtonAnswerBad1.name = "ButtonAnswerBad1";
	this.ButtonAnswerBad1.setTransform(468.6,479,1,1,0,0,0,130.1,33);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.ButtonAnswerBad1},{t:this.ButtonAnswerBad2},{t:this.ButtonAnswerBad3},{t:this.ButtonAnswerBad4},{t:this.ButtonAnswerMedium1},{t:this.ButtonAnswerMedium2},{t:this.ButtonAnswerMedium3},{t:this.ButtonAnswerMedium4},{t:this.ButtonAnswerGood1},{t:this.ButtonAnswerGood2},{t:this.ButtonAnswerGood3},{t:this.ButtonAnswerGood4}]}).wait(1));

	// lines
	this.instance = new lib.FeedbackDividerWhiteScreen();
	this.instance.setTransform(911.4,786.65,1.0018,1,0,0,0,809.2,0);

	this.instance_1 = new lib.FeedbackDividerWhiteScreen();
	this.instance_1.setTransform(911.4,656.65,1.0018,1,0,0,0,809.2,0);

	this.instance_2 = new lib.FeedbackDividerWhiteScreen();
	this.instance_2.setTransform(911.4,526.45,1.0018,1,0,0,0,809.2,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// answersbg
	this.instance_3 = new lib.FeedbackAnswerBGWhite();
	this.instance_3.setTransform(911,660.5,1,1,0,0,0,864,273.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackWhiteScreen, new cjs.Rectangle(47,341.4,1728,592.6), null);


(lib.FeedbackToggle = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.ShowOptimal = new lib.FeedbackToggleButtonWhiteScreen();
	this.ShowOptimal.name = "ShowOptimal";
	this.ShowOptimal.setTransform(207.6,35.15);

	this.HideOptimal = new lib.FeedbackToggleButtonBlackScreen();
	this.HideOptimal.name = "HideOptimal";
	this.HideOptimal.setTransform(207.6,35.15);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.ShowOptimal}]}).to({state:[{t:this.HideOptimal}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,409,66);


(lib.FeedbackTimeline = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.FeedbackTimelineDivider = new lib.FeedbackTimelineDivider();
	this.FeedbackTimelineDivider.name = "FeedbackTimelineDivider";
	this.FeedbackTimelineDivider.setTransform(37.5,749.35,1,1,0,0,0,25.5,7);

	this.instance = new lib.FeedbackKDstates();
	this.instance.setTransform(432,772.15,1,1,0,0,0,432,162.5);

	this.FeedbackTimelineDivider_1 = new lib.FeedbackTimelineDivider();
	this.FeedbackTimelineDivider_1.name = "FeedbackTimelineDivider_1";
	this.FeedbackTimelineDivider_1.setTransform(37.5,641.55,1,1,0,0,0,25.5,7);

	this.instance_1 = new lib.FeedbackKDstates();
	this.instance_1.setTransform(432,664.35,1,1,0,0,0,432,162.5);

	this.FeedbackTimelineDivider_2 = new lib.FeedbackTimelineDivider();
	this.FeedbackTimelineDivider_2.name = "FeedbackTimelineDivider_2";
	this.FeedbackTimelineDivider_2.setTransform(37.5,533.75,1,1,0,0,0,25.5,7);

	this.instance_2 = new lib.FeedbackKDstates();
	this.instance_2.setTransform(432,556.55,1,1,0,0,0,432,162.5);

	this.FeedbackTimelineDivider_3 = new lib.FeedbackTimelineDivider();
	this.FeedbackTimelineDivider_3.name = "FeedbackTimelineDivider_3";
	this.FeedbackTimelineDivider_3.setTransform(37.5,428,1,1,0,0,0,25.5,7);

	this.instance_3 = new lib.FeedbackKDstates();
	this.instance_3.setTransform(432,279.5,1,1,0,0,0,432,162.5);

	this.FeedbackTimelineDivider_4 = new lib.FeedbackTimelineDivider();
	this.FeedbackTimelineDivider_4.name = "FeedbackTimelineDivider_4";
	this.FeedbackTimelineDivider_4.setTransform(37.5,254,1,1,0,0,0,25.5,7);

	this.FeedbackTimelineDivider_5 = new lib.FeedbackTimelineDivider();
	this.FeedbackTimelineDivider_5.name = "FeedbackTimelineDivider_5";
	this.FeedbackTimelineDivider_5.setTransform(37.5,152.7,1,1,0,0,0,25.5,7);

	this.instance_4 = new lib.FeedbackKDstates();
	this.instance_4.setTransform(432,417,1,1,0,0,0,432,162.5);

	this.instance_5 = new lib.FeedbackTimelineBlackBar();
	this.instance_5.setTransform(36,341,1,1,0,0,0,11,87);

	this.FeedbackTimelineBG = new lib.FeedbackTimelineBG();
	this.FeedbackTimelineBG.name = "FeedbackTimelineBG";
	this.FeedbackTimelineBG.setTransform(36.5,540,1,1,0,0,0,10.5,540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.FeedbackTimelineBG},{t:this.instance_5},{t:this.instance_4},{t:this.FeedbackTimelineDivider_5},{t:this.FeedbackTimelineDivider_4},{t:this.instance_3},{t:this.FeedbackTimelineDivider_3},{t:this.instance_2},{t:this.FeedbackTimelineDivider_2},{t:this.instance_1},{t:this.FeedbackTimelineDivider_1},{t:this.instance},{t:this.FeedbackTimelineDivider}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTimeline, new cjs.Rectangle(0,0,77,1080), null);


(lib.FeedbackTimeline_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackKeyDecisionContainer();
	this.instance.setTransform(131.3,189.2,1,1,0,0,0,-65.8,-49.5);

	this.instance_1 = new lib.TimelineBG();
	this.instance_1.setTransform(118.45,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackTimeline_1, new cjs.Rectangle(81.3,0,155.8,577), null);


(lib.FeedbackBlackScreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.READYfeedbackTitle = new cjs.Text("READY feedback", "28px 'Work Sans SemiBold'", "#324141");
	this.READYfeedbackTitle.name = "READYfeedbackTitle";
	this.READYfeedbackTitle.lineHeight = 35;
	this.READYfeedbackTitle.lineWidth = 252;
	this.READYfeedbackTitle.parent = this;
	this.READYfeedbackTitle.setTransform(789,343.4);
ranj.TextOffsetFixer.fix(this.READYfeedbackTitle);

	this.optimalAnswersTitle = new cjs.Text("Optimal answers", "28px 'Work Sans SemiBold'", "#324141");
	this.optimalAnswersTitle.name = "optimalAnswersTitle";
	this.optimalAnswersTitle.lineHeight = 35;
	this.optimalAnswersTitle.lineWidth = 252;
	this.optimalAnswersTitle.parent = this;
	this.optimalAnswersTitle.setTransform(101.55,343.4);
ranj.TextOffsetFixer.fix(this.optimalAnswersTitle);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.optimalAnswersTitle},{t:this.READYfeedbackTitle}]}).wait(1));

	// feedback
	this.AnswerFeedback4 = new cjs.Text("Virtual training may not be effective for training CHWs on EnVD response. Focusing on general precautions and notifying RRT about all possible cases may dilute focus on actual EnVD cases.", "20px 'Work Sans'", "#FFFFFF");
	this.AnswerFeedback4.name = "AnswerFeedback4";
	this.AnswerFeedback4.lineHeight = 23;
	this.AnswerFeedback4.lineWidth = 931;
	this.AnswerFeedback4.parent = this;
	this.AnswerFeedback4.setTransform(789,807);
ranj.TextOffsetFixer.fix(this.AnswerFeedback4);

	this.AnswerFeedback3 = new cjs.Text("Decide how recruitment of Community Health Workers should proceed as the number of infections increases. Decide how recruitment of Community Health Workers should proceed as the number of infections increases. ", "20px 'Work Sans'", "#FFFFFF");
	this.AnswerFeedback3.name = "AnswerFeedback3";
	this.AnswerFeedback3.lineHeight = 23;
	this.AnswerFeedback3.lineWidth = 931;
	this.AnswerFeedback3.parent = this;
	this.AnswerFeedback3.setTransform(789,676);
ranj.TextOffsetFixer.fix(this.AnswerFeedback3);

	this.AnswerFeedback2 = new cjs.Text("Waiting for a week to gather the paper line list data from CHWs can lead to a delay in identifying and addressing any emerging trends, which can result in a missed opportunity for early intervention.", "20px 'Work Sans'", "#FFFFFF");
	this.AnswerFeedback2.name = "AnswerFeedback2";
	this.AnswerFeedback2.lineHeight = 23;
	this.AnswerFeedback2.lineWidth = 931;
	this.AnswerFeedback2.parent = this;
	this.AnswerFeedback2.setTransform(789,545.5);
ranj.TextOffsetFixer.fix(this.AnswerFeedback2);

	this.AnswerFeedback1 = new cjs.Text("Pausing all other CHW activities can have negative consequences. It can lead to a disruption of essential health services, which may be critical to the health and well-being of the community.", "20px 'Work Sans'", "#FFFFFF");
	this.AnswerFeedback1.name = "AnswerFeedback1";
	this.AnswerFeedback1.lineHeight = 23;
	this.AnswerFeedback1.lineWidth = 931;
	this.AnswerFeedback1.parent = this;
	this.AnswerFeedback1.setTransform(789,417);
ranj.TextOffsetFixer.fix(this.AnswerFeedback1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.AnswerFeedback1},{t:this.AnswerFeedback2},{t:this.AnswerFeedback3},{t:this.AnswerFeedback4}]}).wait(1));

	// answers
	this.ButtonAnswerGood4 = new lib.FeedbackButtonOptimal();
	this.ButtonAnswerGood4.name = "ButtonAnswerGood4";
	this.ButtonAnswerGood4.setTransform(468.6,869.5,1,1,0,0,0,130.1,33);

	this.ButtonAnswerGood3 = new lib.FeedbackButtonOptimal();
	this.ButtonAnswerGood3.name = "ButtonAnswerGood3";
	this.ButtonAnswerGood3.setTransform(468.6,739,1,1,0,0,0,130.1,33);

	this.ButtonAnswerGood2 = new lib.FeedbackButtonOptimal();
	this.ButtonAnswerGood2.name = "ButtonAnswerGood2";
	this.ButtonAnswerGood2.setTransform(468.6,608,1,1,0,0,0,130.1,33);

	this.ButtonAnswerGood1 = new lib.FeedbackButtonOptimal();
	this.ButtonAnswerGood1.name = "ButtonAnswerGood1";
	this.ButtonAnswerGood1.setTransform(468.6,479,1,1,0,0,0,130.1,33);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.ButtonAnswerGood1},{t:this.ButtonAnswerGood2},{t:this.ButtonAnswerGood3},{t:this.ButtonAnswerGood4}]}).wait(1));

	// lines
	this.instance = new lib.FeedbackDividerBlackScreen();
	this.instance.setTransform(909.95,787.5,1.0059,1,0,0,0,809.2,0);

	this.instance_1 = new lib.FeedbackDividerBlackScreen();
	this.instance_1.setTransform(909.95,657.45,1.0059,1,0,0,0,809.2,0);

	this.instance_2 = new lib.FeedbackDividerBlackScreen();
	this.instance_2.setTransform(909.95,528.25,1.0059,1,0,0,0,809.2,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// answerBG
	this.instance_3 = new lib.FeedbackAnswerBGBlack();
	this.instance_3.setTransform(910.2,700.2,1,1,0,0,0,863.2,313.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackBlackScreen, new cjs.Rectangle(47,341.4,1728,592.6), null);


(lib.DashboardTab1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.Graph2 = new lib.Graph();
	this.Graph2.name = "Graph2";
	this.Graph2.setTransform(778,442.85);

	this.Graph1 = new lib.Graph();
	this.Graph1.name = "Graph1";
	this.Graph1.setTransform(778,127.1);

	this.LabelGraph2 = new cjs.Text("Number of new cases", "bold 18px 'Work Sans'", "#295B6D");
	this.LabelGraph2.name = "LabelGraph2";
	this.LabelGraph2.lineHeight = 23;
	this.LabelGraph2.lineWidth = 298;
	this.LabelGraph2.parent = this;
	this.LabelGraph2.setTransform(797.85,347.2);
ranj.TextOffsetFixer.fix(this.LabelGraph2);

	this.LabelGraph1 = new cjs.Text("Number of new cases", "bold 18px 'Work Sans'", "#295B6D");
	this.LabelGraph1.name = "LabelGraph1";
	this.LabelGraph1.lineHeight = 23;
	this.LabelGraph1.lineWidth = 303;
	this.LabelGraph1.parent = this;
	this.LabelGraph1.setTransform(797.85,46.6);
ranj.TextOffsetFixer.fix(this.LabelGraph1);

	this.LabelTab1 = new cjs.Text("Showing data from Northeast region of Thisland (total population 4.2m)", "italic 20px 'Work Sans Light'", "#295B6D");
	this.LabelTab1.name = "LabelTab1";
	this.LabelTab1.lineHeight = 31;
	this.LabelTab1.lineWidth = 708;
	this.LabelTab1.parent = this;
	this.LabelTab1.setTransform(2,2);
ranj.TextOffsetFixer.fix(this.LabelTab1);

	this.instance = new lib.GraphTitleLabel();
	this.instance.setTransform(946.85,360.25,1,1,0,0,0,170,20.5);

	this.instance_1 = new lib.GraphTitleLabel();
	this.instance_1.setTransform(946.85,60.7,1,1,0,0,0,170,20.5);

	this.instance_2 = new lib.DashboardLogoGHO();
	this.instance_2.setTransform(1386.15,191.45,1,1,0,0,0,55.5,45.5);

	this.DataElement8 = new lib.DataElement();
	this.DataElement8.name = "DataElement8";
	this.DataElement8.setTransform(466.05,557.2,1,1,0,0,0,184.2,86.5);

	this.DataElement7 = new lib.DataElement();
	this.DataElement7.name = "DataElement7";
	this.DataElement7.setTransform(137.15,557.2,1,1,0,0,0,184.2,86.5);

	this.DataElement6 = new lib.DataElement();
	this.DataElement6.name = "DataElement6";
	this.DataElement6.setTransform(466.05,406.75,1,1,0,0,0,184.2,86.5);

	this.DataElement5 = new lib.DataElement();
	this.DataElement5.name = "DataElement5";
	this.DataElement5.setTransform(137.15,406.75,1,1,0,0,0,184.2,86.5);

	this.DataElement4 = new lib.DataElement();
	this.DataElement4.name = "DataElement4";
	this.DataElement4.setTransform(466.05,258.75,1,1,0,0,0,184.2,86.5);

	this.DataElement3 = new lib.DataElement();
	this.DataElement3.name = "DataElement3";
	this.DataElement3.setTransform(137.15,258.75,1,1,0,0,0,184.2,86.5);

	this.DataElement2 = new lib.DataElement();
	this.DataElement2.name = "DataElement2";
	this.DataElement2.setTransform(466.05,144.4,1,1,0,0,0,184.2,86.5);

	this.DataElement1 = new lib.DataElement();
	this.DataElement1.name = "DataElement1";
	this.DataElement1.setTransform(137.15,144.4,1,1,0,0,0,184.2,86.5);

	this.DashboardTabLogo = new lib.DashboardLogoWHO();
	this.DashboardTabLogo.name = "DashboardTabLogo";
	this.DashboardTabLogo.setTransform(1383.15,59,1,1,0,0,0,59.5,59);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#295B6D").ss(1,1,1).p("EgtWgL2MBatAAAEgtWAL3MBatAAA");
	this.shape.setTransform(290.3,372.425);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.DashboardTabLogo},{t:this.DataElement1},{t:this.DataElement2},{t:this.DataElement3},{t:this.DataElement4},{t:this.DataElement5},{t:this.DataElement6},{t:this.DataElement7},{t:this.DataElement8},{t:this.instance_2},{t:this.instance_1},{t:this.instance},{t:this.LabelTab1},{t:this.LabelGraph1},{t:this.LabelGraph2},{t:this.Graph1},{t:this.Graph2}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DashboardTab1, new cjs.Rectangle(-1,0,1443.7,592.6), null);


(lib.TopicAnswerButtonPanelSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {state1:0,animIn:1,state2:14,animOut:15};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_14 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(14).call(this.frame_14).wait(13));

	// dialogOptionButton1
	this.topicsOptionButton8 = new lib.TopicButton();
	this.topicsOptionButton8.name = "topicsOptionButton8";
	this.topicsOptionButton8.setTransform(875.5,161,1,1,0,0,0,122.5,27);

	this.topicsOptionButton4 = new lib.TopicButton();
	this.topicsOptionButton4.name = "topicsOptionButton4";
	this.topicsOptionButton4.setTransform(875.5,87,1,1,0,0,0,122.5,27);

	this.topicsOptionButton7 = new lib.TopicButton();
	this.topicsOptionButton7.name = "topicsOptionButton7";
	this.topicsOptionButton7.setTransform(629.5,161,1,1,0,0,0,122.5,27);

	this.topicsOptionButton3 = new lib.TopicButton();
	this.topicsOptionButton3.name = "topicsOptionButton3";
	this.topicsOptionButton3.setTransform(629.5,87,1,1,0,0,0,122.5,27);

	this.topicsOptionButton6 = new lib.TopicButton();
	this.topicsOptionButton6.name = "topicsOptionButton6";
	this.topicsOptionButton6.setTransform(379.5,161,1,1,0,0,0,122.5,27);

	this.topicsOptionButton2 = new lib.TopicButton();
	this.topicsOptionButton2.name = "topicsOptionButton2";
	this.topicsOptionButton2.setTransform(379.5,87,1,1,0,0,0,122.5,27);

	this.topicsOptionButton5 = new lib.TopicButton();
	this.topicsOptionButton5.name = "topicsOptionButton5";
	this.topicsOptionButton5.setTransform(133.5,161,1,1,0,0,0,122.5,27);

	this.topicsOptionButton1 = new lib.TopicButton();
	this.topicsOptionButton1.name = "topicsOptionButton1";
	this.topicsOptionButton1.setTransform(133.5,87,1,1,0,0,0,122.5,27);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.topicsOptionButton1},{t:this.topicsOptionButton5},{t:this.topicsOptionButton2},{t:this.topicsOptionButton6},{t:this.topicsOptionButton3},{t:this.topicsOptionButton7},{t:this.topicsOptionButton4},{t:this.topicsOptionButton8}]}).wait(27));

	// Button
	this.endButton = new lib.BackButton();
	this.endButton.name = "endButton";
	this.endButton.setTransform(20,25,1,1,0,0,0,20,20);

	this.timeline.addTween(cjs.Tween.get(this.endButton).wait(27));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,5,998,221.2);


(lib.PlanComposerScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// PlanComposerButton
	this.SubmitButton = new lib.PlanComposerKeyDecision_SubmitButton();
	this.SubmitButton.name = "SubmitButton";
	this.SubmitButton.setTransform(-426.8,422.6,1,1,0,0,0,36.5,7);

	this.Topic2Button = new lib.TabButtonPlanComposer();
	this.Topic2Button.name = "Topic2Button";
	this.Topic2Button.setTransform(-217.65,-332.45,1,1,0,0,0,194.5,34.6);

	this.Topic1Button = new lib.TabButtonPlanComposer();
	this.Topic1Button.name = "Topic1Button";
	this.Topic1Button.setTransform(-628.15,-332.45,1,1,0,0,0,194.5,34.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.Topic1Button},{t:this.Topic2Button},{t:this.SubmitButton}]}).wait(1));

	// Topic2
	this.Topic2 = new lib.PlanComposerKeyDecision_Topic();
	this.Topic2.name = "Topic2";
	this.Topic2.setTransform(17.65,74.9,1,1,0,0,0,851.9,446.2);

	this.timeline.addTween(cjs.Tween.get(this.Topic2).wait(1));

	// Topic1
	this.Topic1 = new lib.PlanComposerKeyDecision_Topic();
	this.Topic1.name = "Topic1";
	this.Topic1.setTransform(17.65,84.7,1,1,0,0,0,851.9,446.2);

	this.timeline.addTween(cjs.Tween.get(this.Topic1).wait(1));

	// PlanComposerShell
	this.DecisionContainer = new lib.PlanComposerKeyDecision_AnswerBackground();
	this.DecisionContainer.name = "DecisionContainer";
	this.DecisionContainer.setTransform(-411.85,94.2,1,1,0,0,0,460,423);

	this.timeline.addTween(cjs.Tween.get(this.DecisionContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlanComposerScreenSkin, new cjs.Rectangle(-961.5,-548.2,1925,1088.7), null);


(lib.MapNodeInformationPopupSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// panel
	this.panel = new lib.MapNodeInformationPopupPanel();
	this.panel.name = "panel";

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	// overlay
	this.overlay = new lib.PopupOverlayBackground();
	this.overlay.name = "overlay";

	this.timeline.addTween(cjs.Tween.get(this.overlay).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MapNodeInformationPopupSkin, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.KeyDecisionOverlayScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// fader
	this.fader = new lib.KeyDecisionOverlayFader();
	this.fader.name = "fader";

	this.timeline.addTween(cjs.Tween.get(this.fader).wait(1));

	// abortButton
	this.abortButton = new lib.AbortButton();
	this.abortButton.name = "abortButton";
	this.abortButton.setTransform(-878.15,-445.9,1,1,0,0,0,-141.5,14.5);

	this.timeline.addTween(cjs.Tween.get(this.abortButton).wait(1));

	// Layer_2
	this.keyDecisionPanel = new lib.KeyDecLabel_1();
	this.keyDecisionPanel.name = "keyDecisionPanel";
	this.keyDecisionPanel.setTransform(-0.5,-456,1,1,0,0,0,422.5,87);

	this.timeline.addTween(cjs.Tween.get(this.keyDecisionPanel).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecisionOverlayScreenSkin, new cjs.Rectangle(-961,-548,1922,1089), null);


(lib.KeyDecisionAvailableScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// panel
	this.panel = new lib.KeyDecisionAvailablePanel();
	this.panel.name = "panel";
	this.panel.setTransform(726.15,-71.5);

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	// overlay
	this.keyDecisionsContainer = new lib.HubKeyDecisionNotificationContainer();
	this.keyDecisionsContainer.name = "keyDecisionsContainer";
	this.keyDecisionsContainer.setTransform(917.4,-177.25);

	this.overlay = new lib.KeyDecisionAvailableBackdrop();
	this.overlay.name = "overlay";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.overlay},{t:this.keyDecisionsContainer}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.KeyDecisionAvailableScreenSkin, new cjs.Rectangle(-960,-540,1920,1080), null);


(lib.HubScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// internalStakeholders
	this.internalStakeholders = new lib.InternalStakeholders();
	this.internalStakeholders.name = "internalStakeholders";
	this.internalStakeholders.setTransform(548.6,539.7);

	this.timeline.addTween(cjs.Tween.get(this.internalStakeholders).wait(1));

	// TimeIndicator
	this.TimingBG = new lib.TimingBG_1();
	this.TimingBG.name = "TimingBG";
	this.TimingBG.setTransform(641.75,-428.75,1,1,0,0,0,215.5,75);

	this.timeline.addTween(cjs.Tween.get(this.TimingBG).wait(1));

	// timerKeyDecision
	this.timerKeyDecision = new lib.timerKeyDecision();
	this.timerKeyDecision.name = "timerKeyDecision";
	this.timerKeyDecision.setTransform(596.15,-354.45,1,1,0,0,0,137.5,22.5);

	this.timeline.addTween(cjs.Tween.get(this.timerKeyDecision).wait(1));

	// teaCorner
	this.dashboardButton = new lib.DataDashboardIcon();
	this.dashboardButton.name = "dashboardButton";
	this.dashboardButton.setTransform(-290.65,413);

	this.teaCorner = new lib.HUBTeaCornerButton();
	this.teaCorner.name = "teaCorner";
	this.teaCorner.setTransform(9.5,478.5,1,1,0,0,0,-95.5,-7.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.teaCorner},{t:this.dashboardButton}]}).wait(1));

	// keyDecisionContainer
	this.hubTimeline = new lib.HubTimeline();
	this.hubTimeline.name = "hubTimeline";
	this.hubTimeline.setTransform(851.65,-118.5,1,1,0,0,0,102.1,288.5);

	this.timeline.addTween(cjs.Tween.get(this.hubTimeline).wait(1));

	// smartphoneButton
	this.smartphoneButton = new lib.HudSmartphoneButton();
	this.smartphoneButton.name = "smartphoneButton";
	this.smartphoneButton.setTransform(-803.2,418);

	this.timeline.addTween(cjs.Tween.get(this.smartphoneButton).wait(1));

	// laptopButton
	this.laptopButton = new lib.HudLaptopButton();
	this.laptopButton.name = "laptopButton";
	this.laptopButton.setTransform(-562.95,413);

	this.timeline.addTween(cjs.Tween.get(this.laptopButton).wait(1));

	// mapContainer
	this.mapContainer = new lib.MapContainer();
	this.mapContainer.name = "mapContainer";

	this.timeline.addTween(cjs.Tween.get(this.mapContainer).wait(1));

	// bg
	this.bg = new lib.HubBackground();
	this.bg.name = "bg";
	this.bg.setTransform(0,-13);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HubScreenSkin, new cjs.Rectangle(-961,-553.5,1921.5,1091.5), null);


(lib.DashboardScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Tab3
	this.DashboardTab3 = new lib.DashboardTab3();
	this.DashboardTab3.name = "DashboardTab3";
	this.DashboardTab3.setTransform(-25.95,-223.75,1,1,0,0,0,726.6,37.2);

	this.timeline.addTween(cjs.Tween.get(this.DashboardTab3).wait(1));

	// Tab2
	this.DashboardTab2 = new lib.DashboardTab2();
	this.DashboardTab2.name = "DashboardTab2";
	this.DashboardTab2.setTransform(11.25,29.25,1,1,0,0,0,726.4,265.2);

	this.timeline.addTween(cjs.Tween.get(this.DashboardTab2).wait(1));

	// Tab1
	this.DashboardTab1 = new lib.DashboardTab1();
	this.DashboardTab1.name = "DashboardTab1";
	this.DashboardTab1.setTransform(5.95,60.25,1,1,0,0,0,721.1,296.2);

	this.timeline.addTween(cjs.Tween.get(this.DashboardTab1).wait(1));

	// CloseButton
	this.closeButton = new lib.TopBarCloseWindowButton();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(715.2,-395.95);

	this.timeline.addTween(cjs.Tween.get(this.closeButton).wait(1));
	this.closeButton.addEventListener("tick", AdobeAn.handleFilterCache);

	// titleTextfield
	this.TitleLightTextField = new cjs.Text("dashboard ", "48px 'Work Sans Light'", "#1A3168");
	this.TitleLightTextField.name = "TitleLightTextField";
	this.TitleLightTextField.lineHeight = 58;
	this.TitleLightTextField.lineWidth = 303;
	this.TitleLightTextField.parent = this;
	this.TitleLightTextField.setTransform(-509.15,-415.2);
ranj.TextOffsetFixer.fix(this.TitleLightTextField);

	this.TitleExtraBoldTextField = new cjs.Text("Enni Virus ", "bold 48px 'Work Sans ExtraBold'", "#1A3168");
	this.TitleExtraBoldTextField.name = "TitleExtraBoldTextField";
	this.TitleExtraBoldTextField.lineHeight = 72;
	this.TitleExtraBoldTextField.lineWidth = 251;
	this.TitleExtraBoldTextField.parent = this;
	this.TitleExtraBoldTextField.setTransform(-766.3,-415.95);
ranj.TextOffsetFixer.fix(this.TitleExtraBoldTextField);

	this.TitleSubTextField = new cjs.Text("Thisland, week 4", "24px 'Work Sans'", "#1A3168");
	this.TitleSubTextField.name = "TitleSubTextField";
	this.TitleSubTextField.lineHeight = 30;
	this.TitleSubTextField.lineWidth = 634;
	this.TitleSubTextField.parent = this;
	this.TitleSubTextField.setTransform(-763.2,-359.1);
ranj.TextOffsetFixer.fix(this.TitleSubTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.TitleSubTextField},{t:this.TitleExtraBoldTextField},{t:this.TitleLightTextField}]}).wait(1));

	// TabDividers
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#295B6D").s().p("AgfABIAAgBIA/AAIAAABg");
	this.shape.setTransform(-295.7,-272.85);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#78A5AF").s().p("EAi+AD9IAAn5IBBAAIAAH5gEgj9AD9IAAn5IA/AAIAAH5g");
	this.shape_1.setTransform(-68.65,-298.225);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	// TabButton
	this.TabButton3 = new lib.TabButton();
	this.TabButton3.name = "TabButton3";
	this.TabButton3.setTransform(384.9,-299,1,1,0,0,0,223.7,25.3);

	this.TabButton2 = new lib.TabButton();
	this.TabButton2.name = "TabButton2";
	this.TabButton2.setTransform(-68.8,-299,1,1,0,0,0,223.7,25.3);

	this.TabButton1 = new lib.TabButton();
	this.TabButton1.name = "TabButton1";
	this.TabButton1.setTransform(-522.5,-299,1,1,0,0,0,223.7,25.3);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("Egi8gD8MBF5AAAIAAH5MhF5AAAg");
	this.shape_2.setTransform(-553.8,-298.975);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.TabButton1},{t:this.TabButton2},{t:this.TabButton3}]}).wait(1));

	// TabBar
	this.instance = new lib.TabsBar();
	this.instance.setTransform(-19.2,-297.8,1,1,0,0,0,781.4,25.3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// imageMask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EhHtBLKQlcAAj2j2Qj2j2AAlcMAAAh8DQAAlcD2j2QD2j2FcAAMCPbAAAQFcAAD2D2QD2D2AAFcMAAAB8DQAAFcj2D2Qj2D2lcAAg");
	mask.setTransform(-344,16);

	// imageContainer
	this.imageContainer = new lib.DecisionImageContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(-344,16);

	var maskedShapeInstanceList = [this.imageContainer];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	// background
	this.DashboardBG = new lib.DashboardBG_1();
	this.DashboardBG.name = "DashboardBG";
	this.DashboardBG.setTransform(-14.25,-0.25,1,1,0,0,0,801.5,451.5);

	this.timeline.addTween(cjs.Tween.get(this.DashboardBG).wait(1));

	// Layer_2
	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiV/hUXMEr/AAAMAAACovMkr/AAAg");
	this.shape_3.setTransform(0.15,-0.75);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("rgba(0,0,0,0.6)").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");
	this.shape_4.setTransform(0.15,-0.75);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_4},{t:this.shape_3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DashboardScreenSkin, new cjs.Rectangle(-960.8,-541.7,1922,1082), null);


(lib.DialogAnswerCorrection = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {correct:0,incorrect:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.RightAnimationMC();
	this.instance.setTransform(241.5,31.5,1,1,0,0,0,241.5,31.5);

	this.instance_1 = new lib.DialogButtonWrong();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-168.1,-92.7,654.1,295.5);


(lib.DialogButtoncopy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,"selectedUp":4,"selectedOver":5,"selectedDown":6,"selectedDisabled":7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Lorem ipsum \ndolor \nsit amet", "24px 'Work Sans'", "#2C3C3C");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 20;
	this.disabledLabelTextField.lineWidth = 653;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-325.95,-28);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(8));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Lorem ipsum \ndolor \nsit amet", "24px 'Work Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 20;
	this.downLabelTextField.lineWidth = 654;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-323,-30.4);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(8));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Lorem ipsum \ndolor \nsit amet", "24px 'Work Sans'", "#2C3C3C");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 20;
	this.overLabelTextField.lineWidth = 654;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-323,-31.2);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(8));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Lorem ipsum \ndolor \nsit amet", "24px 'Work Sans'", "#2C3C3C");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 20;
	this.upLabelTextField.lineWidth = 654;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-327,-28);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(8));

	// correction
	this.correction = new lib.DialogAnswerCorrection();
	this.correction.name = "correction";
	this.correction.setTransform(-281.55,-43.5);

	this.timeline.addTween(cjs.Tween.get(this.correction).wait(8));

	// BG
	this.instance = new lib.DialogButtonUp();
	this.instance.setTransform(-374,-57);

	this.instance_1 = new lib.AnswerContainerOver();
	this.instance_1.setTransform(-369,-60);

	this.instance_2 = new lib.AnswerContainerDown();
	this.instance_2.setTransform(-369,-60);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance}]},1).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-449.6,-136.2,1016.6,295.5);


(lib.PlaceholderMapNode = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.NewCharacterAvailable = new lib.newKeyDecIcon();
	this.NewCharacterAvailable.name = "NewCharacterAvailable";
	this.NewCharacterAvailable.setTransform(-4.1,-82.15,1,1,0,0,0,25,22.5);

	this.timeline.addTween(cjs.Tween.get(this.NewCharacterAvailable).wait(4));

	// image
	this.locationImage = new lib.PlaceholderPoiImage();
	this.locationImage.name = "locationImage";
	this.locationImage.setTransform(-52,-52.5);

	this.timeline.addTween(cjs.Tween.get(this.locationImage).wait(4));

	// node
	this.node = new lib.MapLocationNode();
	this.node.name = "node";

	this.timeline.addTween(cjs.Tween.get(this.node).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-461,-144.8,481.9,274);


(lib.MapLocationCharacterMenu = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// images
	this.image2 = new lib.PlaceholderPoiCharacter();
	this.image2.name = "image2";
	this.image2.setTransform(-52,58.65,1,1,0,0,0,0,-0.5);

	this.image1 = new lib.PlaceholderPoiCharacter();
	this.image1.name = "image1";
	this.image1.setTransform(-102.7,3.15,1,1,0,0,0,0,-0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.image1},{t:this.image2}]}).wait(1));

	// labels
	this.label2 = new lib.MapLocationCharacterMenuItemLabel();
	this.label2.name = "label2";
	this.label2.setTransform(-233.5,66);

	this.label1 = new lib.MapLocationCharacterMenuItemLabel();
	this.label1.name = "label1";
	this.label1.setTransform(-283.5,10);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.label1},{t:this.label2}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MapLocationCharacterMenu, new cjs.Rectangle(-461,-88.6,468,217.79999999999998), null);


(lib.FeedbackScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.hubTimeline = new lib.HubTimeline();
	this.hubTimeline.name = "hubTimeline";
	this.hubTimeline.setTransform(-839.65,-208.75,1,1,0,0,0,143.2,288.5);

	this.timeline.addTween(cjs.Tween.get(this.hubTimeline).wait(1));

	// containerblack
	this.FeedbackBlackScreen = new lib.FeedbackBlackScreen();
	this.FeedbackBlackScreen.name = "FeedbackBlackScreen";
	this.FeedbackBlackScreen.setTransform(-814.85,-539.15);

	this.timeline.addTween(cjs.Tween.get(this.FeedbackBlackScreen).wait(1));

	// containerwhite
	this.FeedbackWhiteScreen = new lib.FeedbackWhiteScreen();
	this.FeedbackWhiteScreen.name = "FeedbackWhiteScreen";
	this.FeedbackWhiteScreen.setTransform(-959.85,-539.15,1,1,0,0,0,-145,0);

	this.timeline.addTween(cjs.Tween.get(this.FeedbackWhiteScreen).wait(1));

	// Buttons
	this.FeedbackToggle = new lib.FeedbackToggle();
	this.FeedbackToggle.name = "FeedbackToggle";
	this.FeedbackToggle.setTransform(92.25,468.5,1,1,0,0,0,204.5,33);

	this.FeedbackNext = new lib.FeedbackNextButtonWhiteScreen();
	this.FeedbackNext.name = "FeedbackNext";
	this.FeedbackNext.setTransform(765.35,470.65);

	this.FeedbackPrevious = new lib.FeedbackPreviousButtonWhiteScreen();
	this.FeedbackPrevious.name = "FeedbackPrevious";
	this.FeedbackPrevious.setTransform(-560.25,471.15);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.FeedbackPrevious},{t:this.FeedbackNext},{t:this.FeedbackToggle}]}).wait(1));

	// Layer_3
	this.instance = new lib.FeedbackIcon_1();
	this.instance.setTransform(-686.85,-410.4,1,1,0,0,0,27,21);

	this.FeedbackKDdescription = new cjs.Text("The MoH has requested that Thisland Relief add active EnVD case finding to the existing community-based surveillance conducted by the CHWs in the areas where they currently operate. The MoH has shared the additional reporting tools. Thisland Relief is seeking support and guidance from READY to operationalize the MoH’s request.", "24px 'Work Sans'", "#2C3C3C");
	this.FeedbackKDdescription.name = "FeedbackKDdescription";
	this.FeedbackKDdescription.lineHeight = 30;
	this.FeedbackKDdescription.lineWidth = 1621;
	this.FeedbackKDdescription.parent = this;
	this.FeedbackKDdescription.setTransform(-712.85,-325.15);
ranj.TextOffsetFixer.fix(this.FeedbackKDdescription);

	this.FeedbackDisclaimer = new cjs.Text("Disclaimer: answers marked as optimal in the sim don’t always have to be optimal in reality.", "italic 18px 'Work Sans'", "#93A5A4");
	this.FeedbackDisclaimer.name = "FeedbackDisclaimer";
	this.FeedbackDisclaimer.lineHeight = 28;
	this.FeedbackDisclaimer.lineWidth = 1104;
	this.FeedbackDisclaimer.parent = this;
	this.FeedbackDisclaimer.setTransform(-712.85,-357.15);
ranj.TextOffsetFixer.fix(this.FeedbackDisclaimer);

	this.FeedbackTitle = new cjs.Text("Key Decision feedback", "bold 50px 'Work Sans'", "#2C3C3C");
	this.FeedbackTitle.name = "FeedbackTitle";
	this.FeedbackTitle.lineHeight = 61;
	this.FeedbackTitle.lineWidth = 586;
	this.FeedbackTitle.parent = this;
	this.FeedbackTitle.setTransform(-642.85,-451.15);
ranj.TextOffsetFixer.fix(this.FeedbackTitle);

	this.instance_1 = new lib.FeedbackContentContainer();
	this.instance_1.setTransform(-815,-539);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.FeedbackTitle},{t:this.FeedbackDisclaimer},{t:this.FeedbackKDdescription},{t:this.instance}]}).wait(1));

	// bg
	this.instance_2 = new lib.FeedbackBackground();
	this.instance_2.setTransform(-960,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackScreenSkin, new cjs.Rectangle(-960,-540,1920.2,1081), null);


(lib.DialogAnswerButtonPanelSkincopy = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// backButton
	this.backButton = new lib.ReturnButton();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-449.65,-24.5,1,1,0,0,0,44.5,23.5);

	this.timeline.addTween(cjs.Tween.get(this.backButton).wait(1));

	// answerTimer
	this.answerTimer = new lib.AnswerTimer();
	this.answerTimer.name = "answerTimer";
	this.answerTimer.setTransform(7.85,-24.55,1,1,0,0,0,502,23.6);

	this.timeline.addTween(cjs.Tween.get(this.answerTimer).wait(1));

	// dialogOptionButton
	this.dialogOptionButton4 = new lib.DialogButtoncopy();
	this.dialogOptionButton4.name = "dialogOptionButton4";
	this.dialogOptionButton4.setTransform(0.5,429.75);

	this.timeline.addTween(cjs.Tween.get(this.dialogOptionButton4).wait(1));

	// dialogOptionButton3
	this.dialogOptionButton3 = new lib.DialogButtoncopy();
	this.dialogOptionButton3.name = "dialogOptionButton3";
	this.dialogOptionButton3.setTransform(0.5,307.5);

	this.timeline.addTween(cjs.Tween.get(this.dialogOptionButton3).wait(1));

	// dialogOptionButton2
	this.dialogOptionButton2 = new lib.DialogButtoncopy();
	this.dialogOptionButton2.name = "dialogOptionButton2";
	this.dialogOptionButton2.setTransform(0.5,183.75);

	this.timeline.addTween(cjs.Tween.get(this.dialogOptionButton2).wait(1));

	// dialogOptionButton1
	this.dialogOptionButton1 = new lib.DialogButtoncopy();
	this.dialogOptionButton1.name = "dialogOptionButton1";
	this.dialogOptionButton1.setTransform(0.5,60);

	this.timeline.addTween(cjs.Tween.get(this.dialogOptionButton1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DialogAnswerButtonPanelSkincopy, new cjs.Rectangle(-494.1,-76.2,1004,665.2), null);


(lib.DialogPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Topic
	this.topicSelectionButtonPanel = new lib.TopicAnswerButtonPanelSkin();
	this.topicSelectionButtonPanel.name = "topicSelectionButtonPanel";
	this.topicSelectionButtonPanel.setTransform(-6.8,-83,1,1,0,0,0,496.2,99.5);

	this.timeline.addTween(cjs.Tween.get(this.topicSelectionButtonPanel).wait(1));

	// _Dialog
	this.dialogAnswerButtonPanel = new lib.DialogAnswerButtonPanelSkincopy();
	this.dialogAnswerButtonPanel.name = "dialogAnswerButtonPanel";
	this.dialogAnswerButtonPanel.setTransform(0,-199.5);

	this.timeline.addTween(cjs.Tween.get(this.dialogAnswerButtonPanel).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DialogPanel, new cjs.Rectangle(-503,-275.7,1012.9,665.2), null);


(lib.Map_Chapter3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// node_3_CH1
	this.node_3 = new lib.PlaceholderMapNode();
	this.node_3.name = "node_3";
	this.node_3.setTransform(-420.2,137.2);

	this.timeline.addTween(cjs.Tween.get(this.node_3).wait(1));

	// node_2_CH1
	this.node_2 = new lib.PlaceholderMapNode();
	this.node_2.name = "node_2";
	this.node_2.setTransform(90.05,-84.05);

	this.timeline.addTween(cjs.Tween.get(this.node_2).wait(1));

	// node_1_CH1
	this.node_1 = new lib.PlaceholderMapNode();
	this.node_1.name = "node_1";
	this.node_1.setTransform(-339.7,254.2);

	this.timeline.addTween(cjs.Tween.get(this.node_1).wait(1));

	// Map_Inset_Chapter1
	this.mapInsetChapter1 = new lib.mapInsetChapter1();
	this.mapInsetChapter1.name = "mapInsetChapter1";
	this.mapInsetChapter1.setTransform(-722.15,-336.6,1,1,0,0,0,217.5,182.5);

	this.timeline.addTween(cjs.Tween.get(this.mapInsetChapter1).wait(1));

	// Map_Chapter1_Background
	this.bg = new lib.Map_Chapter3_Background();
	this.bg.name = "bg";
	this.bg.setTransform(0,-6.25);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Map_Chapter3, new cjs.Rectangle(-962,-547.2,1922,1081), null);


(lib.Map_Chapter2w6 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// node_2_CH1
	this.node_2 = new lib.PlaceholderMapNode();
	this.node_2.name = "node_2";
	this.node_2.setTransform(235.9,126.7);

	this.timeline.addTween(cjs.Tween.get(this.node_2).wait(1));

	// node_1_CH1
	this.node_1 = new lib.PlaceholderMapNode();
	this.node_1.name = "node_1";
	this.node_1.setTransform(90.7,-83.85);

	this.timeline.addTween(cjs.Tween.get(this.node_1).wait(1));

	// Map_Inset_Chapter1
	this.mapInsetChapter1 = new lib.mapInsetChapter1();
	this.mapInsetChapter1.name = "mapInsetChapter1";
	this.mapInsetChapter1.setTransform(-722.15,-336.6,1,1,0,0,0,217.5,182.5);

	this.timeline.addTween(cjs.Tween.get(this.mapInsetChapter1).wait(1));

	// Map_Chapter1_Background
	this.bg = new lib.Map_Chapter3_Background();
	this.bg.name = "bg";
	this.bg.setTransform(0,-6.25);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Map_Chapter2w6, new cjs.Rectangle(-962,-547.2,1922,1081), null);


(lib.Map_Chapter2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// node_4_CH1
	this.node_4 = new lib.PlaceholderMapNode();
	this.node_4.name = "node_4";
	this.node_4.setTransform(221.65,118.7);

	this.timeline.addTween(cjs.Tween.get(this.node_4).wait(1));

	// node_5_CH2
	this.node_5 = new lib.PlaceholderMapNode();
	this.node_5.name = "node_5";
	this.node_5.setTransform(312.5,63.45);

	this.timeline.addTween(cjs.Tween.get(this.node_5).wait(1));

	// node_3_CH1
	this.node_3 = new lib.PlaceholderMapNode();
	this.node_3.name = "node_3";
	this.node_3.setTransform(23.8,-44.25);

	this.timeline.addTween(cjs.Tween.get(this.node_3).wait(1));

	// node_2_CH1
	this.node_2 = new lib.PlaceholderMapNode();
	this.node_2.name = "node_2";
	this.node_2.setTransform(-88.1,-94.3);

	this.timeline.addTween(cjs.Tween.get(this.node_2).wait(1));

	// node_1_CH1
	this.node_1 = new lib.PlaceholderMapNode();
	this.node_1.name = "node_1";
	this.node_1.setTransform(23.8,-166.6);

	this.timeline.addTween(cjs.Tween.get(this.node_1).wait(1));

	// Map_Inset_Chapter1
	this.mapInsetChapter1 = new lib.mapInsetChapter2();
	this.mapInsetChapter1.name = "mapInsetChapter1";
	this.mapInsetChapter1.setTransform(-722.15,-336.6,1,1,0,0,0,217.5,182.5);

	this.timeline.addTween(cjs.Tween.get(this.mapInsetChapter1).wait(1));

	// Map_Chapter1_Background
	this.bg = new lib.Map_Chapter2_Background();
	this.bg.name = "bg";
	this.bg.setTransform(0,-6.25);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Map_Chapter2, new cjs.Rectangle(-961,-547.2,1921,1081), null);


(lib.Map_Chapter1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// node_3_CH1
	this.node_3 = new lib.PlaceholderMapNode();
	this.node_3.name = "node_3";
	this.node_3.setTransform(90.2,-83.55);

	this.timeline.addTween(cjs.Tween.get(this.node_3).wait(1));

	// node_2_CH1
	this.node_2 = new lib.PlaceholderMapNode();
	this.node_2.name = "node_2";
	this.node_2.setTransform(-339.5,253);

	this.timeline.addTween(cjs.Tween.get(this.node_2).wait(1));

	// node_1_CH1
	this.node_1 = new lib.PlaceholderMapNode();
	this.node_1.name = "node_1";
	this.node_1.setTransform(-419.6,137.35);

	this.timeline.addTween(cjs.Tween.get(this.node_1).wait(1));

	// Map_Inset_Chapter1
	this.mapInsetChapter1 = new lib.mapInsetChapter1();
	this.mapInsetChapter1.name = "mapInsetChapter1";
	this.mapInsetChapter1.setTransform(-722.15,-336.6,1,1,0,0,0,217.5,182.5);

	this.timeline.addTween(cjs.Tween.get(this.mapInsetChapter1).wait(1));

	// Map_Chapter1_Background
	this.bg = new lib.Map_Chapter1_Background();
	this.bg.name = "bg";
	this.bg.setTransform(0,-6.25);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Map_Chapter1, new cjs.Rectangle(-961,-547.2,1922,1081), null);


(lib.DialogScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// npcTextPanelFlipped
	this.npcPanelFlipped = new lib.NPCPanel();
	this.npcPanelFlipped.name = "npcPanelFlipped";
	this.npcPanelFlipped.setTransform(474.1,-242.05);

	this.timeline.addTween(cjs.Tween.get(this.npcPanelFlipped).wait(1));

	// npcTextPanel
	this.npcPanel = new lib.NPCPanel();
	this.npcPanel.name = "npcPanel";
	this.npcPanel.setTransform(-569.2,-286.6);

	this.timeline.addTween(cjs.Tween.get(this.npcPanel).wait(1));

	// Layer_6 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EhUwBUYMAAAiovMCpgAAAMAAACovg");
	mask.setTransform(415.1,0.05);

	// ImagePlaceholder
	this.ImagePlaceholder = new lib.CharacterPlaceholder();
	this.ImagePlaceholder.name = "ImagePlaceholder";
	this.ImagePlaceholder.setTransform(408.5,-0.5,1,1,0,0,0,554.5,540.5);

	var maskedShapeInstanceList = [this.ImagePlaceholder];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.ImagePlaceholder).wait(1));

	// DialogPanel
	this.dialogPanel = new lib.DialogPanel();
	this.dialogPanel.name = "dialogPanel";
	this.dialogPanel.setTransform(-538.7,184.1);

	this.timeline.addTween(cjs.Tween.get(this.dialogPanel).wait(1));

	// Timer
	this.dialogTimer = new lib.Timer();
	this.dialogTimer.name = "dialogTimer";
	this.dialogTimer.setTransform(822.2,-470.1,1,1,0,0,0,79,24);

	this.timeline.addTween(cjs.Tween.get(this.dialogTimer).wait(1));

	// background
	this.bg = new lib.DialogScreenBackground();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DialogScreenSkin, new cjs.Rectangle(-1041.7,-540.5,2004.7,1114.1), null);


// stage content:
(lib.MainAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);
// library properties:
lib.properties = {
	id: 'C1DF5F666281484DA9D1F4AEE495446B',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#FF00FF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/AnswerContainerDown.png", id:"MainAssets_AnswerContainerDown", bundle:"MainAssets"},
		{src:"assets/skins/images/AnswerContainerOver.png", id:"MainAssets_AnswerContainerOver", bundle:"MainAssets"},
		{src:"assets/skins/images/AnswerSlot.png", id:"MainAssets_AnswerSlot", bundle:"MainAssets"},
		{src:"assets/skins/images/BackDisabled.png", id:"MainAssets_BackDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/BackOver.png", id:"MainAssets_BackOver", bundle:"MainAssets"},
		{src:"assets/skins/images/BackUp.png", id:"MainAssets_BackUp", bundle:"MainAssets"},
		{src:"assets/skins/images/BadDown.png", id:"MainAssets_BadDown", bundle:"MainAssets"},
		{src:"assets/skins/images/BadOver.png", id:"MainAssets_BadOver", bundle:"MainAssets"},
		{src:"assets/skins/images/BadUp.png", id:"MainAssets_BadUp", bundle:"MainAssets"},
		{src:"assets/skins/images/BottomBar.png", id:"MainAssets_BottomBar", bundle:"MainAssets"},
		{src:"assets/skins/images/BriefingBackground.jpg", id:"MainAssets_BriefingBackground", bundle:"MainAssets"},
		{src:"assets/skins/images/BriefingBlackBar.png", id:"MainAssets_BriefingBlackBar", bundle:"MainAssets"},
		{src:"assets/skins/images/BriefingBodybackground.png", id:"MainAssets_BriefingBodybackground", bundle:"MainAssets"},
		{src:"assets/skins/images/BriefingTimeLine.png", id:"MainAssets_BriefingTimeLine", bundle:"MainAssets"},
		{src:"assets/skins/images/BriefingTimelineBackground.png", id:"MainAssets_BriefingTimelineBackground", bundle:"MainAssets"},
		{src:"assets/skins/images/BriefingTimelineBars.png", id:"MainAssets_BriefingTimelineBars", bundle:"MainAssets"},
		{src:"assets/skins/images/ButtonOverWhite.png", id:"MainAssets_ButtonOverWhite", bundle:"MainAssets"},
		{src:"assets/skins/images/ButtonOverWhitepngcopy.png", id:"MainAssets_ButtonOverWhitepngcopy", bundle:"MainAssets"},
		{src:"assets/skins/images/CloseButtonIcon.png", id:"MainAssets_CloseButtonIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/CompletedKDConfirmationScreen.png", id:"MainAssets_CompletedKDConfirmationScreen", bundle:"MainAssets"},
		{src:"assets/skins/images/ContinueButtonDisabled.png", id:"MainAssets_ContinueButtonDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/ContinueButtonHi.png", id:"MainAssets_ContinueButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/ContinueButtonUp.png", id:"MainAssets_ContinueButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/DashboardBG.png", id:"MainAssets_DashboardBG", bundle:"MainAssets"},
		{src:"assets/skins/images/DashboardButton.png", id:"MainAssets_DashboardButton", bundle:"MainAssets"},
		{src:"assets/skins/images/DashboardButtonOver.png", id:"MainAssets_DashboardButtonOver", bundle:"MainAssets"},
		{src:"assets/skins/images/DashboardGraphLabel.png", id:"MainAssets_DashboardGraphLabel", bundle:"MainAssets"},
		{src:"assets/skins/images/DecisionButtonHi.png", id:"MainAssets_DecisionButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/DecisionButtonUp.png", id:"MainAssets_DecisionButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogBackBackground.png", id:"MainAssets_DialogBackBackground", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogBackButtonDisabled.png", id:"MainAssets_DialogBackButtonDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogBackButtonDown.png", id:"MainAssets_DialogBackButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogBackButtonUp.png", id:"MainAssets_DialogBackButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogButtonRight.png", id:"MainAssets_DialogButtonRight", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogButtonUp.png", id:"MainAssets_DialogButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogButtonWrong.png", id:"MainAssets_DialogButtonWrong", bundle:"MainAssets"},
		{src:"assets/skins/images/DialogNPCTextFieldBG1.png", id:"MainAssets_DialogNPCTextFieldBG1", bundle:"MainAssets"},
		{src:"assets/skins/images/ExpandOptimal.png", id:"MainAssets_ExpandOptimal", bundle:"MainAssets"},
		{src:"assets/skins/images/ExpandPlayerChoice.png", id:"MainAssets_ExpandPlayerChoice", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackBackground.jpg", id:"MainAssets_FeedbackBackground", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackBGpointer.png", id:"MainAssets_FeedbackBGpointer", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackBlackBar.png", id:"MainAssets_FeedbackBlackBar", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackContentContainer.png", id:"MainAssets_FeedbackContentContainer", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackIcon.png", id:"MainAssets_FeedbackIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackInactiveKD.png", id:"MainAssets_FeedbackInactiveKD", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackInactiveKDOver.png", id:"MainAssets_FeedbackInactiveKDOver", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackKDInfoExpansion.png", id:"MainAssets_FeedbackKDInfoExpansion", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackKDOptimal.png", id:"MainAssets_FeedbackKDOptimal", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackKDPlayerChoice.png", id:"MainAssets_FeedbackKDPlayerChoice", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackKDSmall.png", id:"MainAssets_FeedbackKDSmall", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackLongBar.png", id:"MainAssets_FeedbackLongBar", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackPointer.png", id:"MainAssets_FeedbackPointer", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackSmallBar.png", id:"MainAssets_FeedbackSmallBar", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackToolTipBlackScreen.png", id:"MainAssets_FeedbackToolTipBlackScreen", bundle:"MainAssets"},
		{src:"assets/skins/images/FeedbackToolTipWhiteScreen.png", id:"MainAssets_FeedbackToolTipWhiteScreen", bundle:"MainAssets"},
		{src:"assets/skins/images/GoodDown.png", id:"MainAssets_GoodDown", bundle:"MainAssets"},
		{src:"assets/skins/images/GoodOver.png", id:"MainAssets_GoodOver", bundle:"MainAssets"},
		{src:"assets/skins/images/GoodUp.png", id:"MainAssets_GoodUp", bundle:"MainAssets"},
		{src:"assets/skins/images/HideOptimalDown.png", id:"MainAssets_HideOptimalDown", bundle:"MainAssets"},
		{src:"assets/skins/images/HideOptimalOver.png", id:"MainAssets_HideOptimalOver", bundle:"MainAssets"},
		{src:"assets/skins/images/HideOptimalUp.png", id:"MainAssets_HideOptimalUp", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBLaptopOver.png", id:"MainAssets_HUBLaptopOver", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBLaptopUp.png", id:"MainAssets_HUBLaptopUp", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBmapCh1.jpg", id:"MainAssets_HUBmapCh1", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBmapCh1jpgcopy.jpg", id:"MainAssets_HUBmapCh1jpgcopy", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBmapCh1_1.png", id:"MainAssets_HUBmapCh1_1", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBNewItemLabel1.png", id:"MainAssets_HUBNewItemLabel1", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBSmartphoneOver.png", id:"MainAssets_HUBSmartphoneOver", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBSmartphoneUp.png", id:"MainAssets_HUBSmartphoneUp", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBStakeholderButtonBGDisabled.png", id:"MainAssets_HUBStakeholderButtonBGDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBStakeholderButtonBGUp.png", id:"MainAssets_HUBStakeholderButtonBGUp", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBStakeholderButtonLabelDisabled.png", id:"MainAssets_HUBStakeholderButtonLabelDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBStakeholderButtonLabelOver.png", id:"MainAssets_HUBStakeholderButtonLabelOver", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBStakeholderButtonLabelUp.png", id:"MainAssets_HUBStakeholderButtonLabelUp", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBTeaCornerButtonBGDisabled.png", id:"MainAssets_HUBTeaCornerButtonBGDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBTeaCornerButtonBGUp.png", id:"MainAssets_HUBTeaCornerButtonBGUp", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBTeaCornerButtonLabelDisabled.png", id:"MainAssets_HUBTeaCornerButtonLabelDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBTeaCornerButtonLabelOver.png", id:"MainAssets_HUBTeaCornerButtonLabelOver", bundle:"MainAssets"},
		{src:"assets/skins/images/HUBTeaCornerButtonLabelUp.png", id:"MainAssets_HUBTeaCornerButtonLabelUp", bundle:"MainAssets"},
		{src:"assets/skins/images/KDExpansionPointer.png", id:"MainAssets_KDExpansionPointer", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecAvailableBG.png", id:"MainAssets_KeyDecAvailableBG", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecButtonCompleted.png", id:"MainAssets_KeyDecButtonCompleted", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecButtonDown.png", id:"MainAssets_KeyDecButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecButtonHover.png", id:"MainAssets_KeyDecButtonHover", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecButtonLocked.png", id:"MainAssets_KeyDecButtonLocked", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecButtonUp.png", id:"MainAssets_KeyDecButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecDialogueDown.png", id:"MainAssets_KeyDecDialogueDown", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecDialogueOver.png", id:"MainAssets_KeyDecDialogueOver", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecDialogueUp.png", id:"MainAssets_KeyDecDialogueUp", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecDivider.png", id:"MainAssets_KeyDecDivider", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecDown.png", id:"MainAssets_KeyDecDown", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_AnswerContainer.png", id:"MainAssets_keyDecisionPlanComposer_AnswerContainer", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_AnswerDisabled.png", id:"MainAssets_keyDecisionPlanComposer_AnswerDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_AnswerDown.png", id:"MainAssets_keyDecisionPlanComposer_AnswerDown", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_AnswerOver.png", id:"MainAssets_keyDecisionPlanComposer_AnswerOver", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_AnswerPlaced.png", id:"MainAssets_keyDecisionPlanComposer_AnswerPlaced", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_AnswerPlacedOver.png", id:"MainAssets_keyDecisionPlanComposer_AnswerPlacedOver", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_AnswerUp.png", id:"MainAssets_keyDecisionPlanComposer_AnswerUp", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_ButtonDisabled.png", id:"MainAssets_keyDecisionPlanComposer_ButtonDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_ButtonDown.png", id:"MainAssets_keyDecisionPlanComposer_ButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_ButtonOver.png", id:"MainAssets_keyDecisionPlanComposer_ButtonOver", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_ButtonUp.png", id:"MainAssets_keyDecisionPlanComposer_ButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_InputFieldActive.png", id:"MainAssets_keyDecisionPlanComposer_InputFieldActive", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_InputFieldInac.png", id:"MainAssets_keyDecisionPlanComposer_InputFieldInac", bundle:"MainAssets"},
		{src:"assets/skins/images/keyDecisionPlanComposer_SubmitPlanIcon.png", id:"MainAssets_keyDecisionPlanComposer_SubmitPlanIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/KeyDecLabel.png", id:"MainAssets_KeyDecLabel", bundle:"MainAssets"},
		{src:"assets/skins/images/LogoGOH.png", id:"MainAssets_LogoGOH", bundle:"MainAssets"},
		{src:"assets/skins/images/LogoMoH.png", id:"MainAssets_LogoMoH", bundle:"MainAssets"},
		{src:"assets/skins/images/LogoReady.png", id:"MainAssets_LogoReady", bundle:"MainAssets"},
		{src:"assets/skins/images/MapBGConfirmationjpgcopy.jpg", id:"MainAssets_MapBGConfirmationjpgcopy", bundle:"MainAssets"},
		{src:"assets/skins/images/MapInsetCh1.png", id:"MainAssets_MapInsetCh1", bundle:"MainAssets"},
		{src:"assets/skins/images/MapInsetCh2.png", id:"MainAssets_MapInsetCh2", bundle:"MainAssets"},
		{src:"assets/skins/images/MapNode.png", id:"MainAssets_MapNode", bundle:"MainAssets"},
		{src:"assets/skins/images/MediumDown.png", id:"MainAssets_MediumDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MediumOver.png", id:"MainAssets_MediumOver", bundle:"MainAssets"},
		{src:"assets/skins/images/MediumUp.png", id:"MainAssets_MediumUp", bundle:"MainAssets"},
		{src:"assets/skins/images/NewKDLabel.png", id:"MainAssets_NewKDLabel", bundle:"MainAssets"},
		{src:"assets/skins/images/NewKeyDecisionIndicator.png", id:"MainAssets_NewKeyDecisionIndicator", bundle:"MainAssets"},
		{src:"assets/skins/images/NewTopicIcon.png", id:"MainAssets_NewTopicIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/NodeColor07.png", id:"MainAssets_NodeColor07", bundle:"MainAssets"},
		{src:"assets/skins/images/NotificationBarEndpngcopy.png", id:"MainAssets_NotificationBarEndpngcopy", bundle:"MainAssets"},
		{src:"assets/skins/images/OptimalDown.png", id:"MainAssets_OptimalDown", bundle:"MainAssets"},
		{src:"assets/skins/images/OptimalOver.png", id:"MainAssets_OptimalOver", bundle:"MainAssets"},
		{src:"assets/skins/images/OptimalUp.png", id:"MainAssets_OptimalUp", bundle:"MainAssets"},
		{src:"assets/skins/images/PieletjeBlack.png", id:"MainAssets_PieletjeBlack", bundle:"MainAssets"},
		{src:"assets/skins/images/POI_NodeColor01.png", id:"MainAssets_POI_NodeColor01", bundle:"MainAssets"},
		{src:"assets/skins/images/POI_NodeColor02.png", id:"MainAssets_POI_NodeColor02", bundle:"MainAssets"},
		{src:"assets/skins/images/POI_NodeColor03.png", id:"MainAssets_POI_NodeColor03", bundle:"MainAssets"},
		{src:"assets/skins/images/POI_NodeColor04.png", id:"MainAssets_POI_NodeColor04", bundle:"MainAssets"},
		{src:"assets/skins/images/POI_NodeColor05.png", id:"MainAssets_POI_NodeColor05", bundle:"MainAssets"},
		{src:"assets/skins/images/POI_NodeColor06.png", id:"MainAssets_POI_NodeColor06", bundle:"MainAssets"},
		{src:"assets/skins/images/PoILabel0Over.png", id:"MainAssets_PoILabel0Over", bundle:"MainAssets"},
		{src:"assets/skins/images/PoILabel0Up.png", id:"MainAssets_PoILabel0Up", bundle:"MainAssets"},
		{src:"assets/skins/images/PoILabel3Over.png", id:"MainAssets_PoILabel3Over", bundle:"MainAssets"},
		{src:"assets/skins/images/PoILabel3Up.png", id:"MainAssets_PoILabel3Up", bundle:"MainAssets"},
		{src:"assets/skins/images/PoILTextLabelBGSmallWhite.png", id:"MainAssets_PoILTextLabelBGSmallWhite", bundle:"MainAssets"},
		{src:"assets/skins/images/PoIPLocationDummy.png", id:"MainAssets_PoIPLocationDummy", bundle:"MainAssets"},
		{src:"assets/skins/images/PopUpBackButtonDisabled.png", id:"MainAssets_PopUpBackButtonDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/PopUpBackButtonOver.png", id:"MainAssets_PopUpBackButtonOver", bundle:"MainAssets"},
		{src:"assets/skins/images/PopUpBackButtonUp.png", id:"MainAssets_PopUpBackButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/PrintButtonDisabled.png", id:"MainAssets_PrintButtonDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/PrintButtonDown.png", id:"MainAssets_PrintButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/PrintButtonUp.png", id:"MainAssets_PrintButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/ShowOptimalDown.png", id:"MainAssets_ShowOptimalDown", bundle:"MainAssets"},
		{src:"assets/skins/images/ShowOptimalOver.png", id:"MainAssets_ShowOptimalOver", bundle:"MainAssets"},
		{src:"assets/skins/images/ShowOptimalUp.png", id:"MainAssets_ShowOptimalUp", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_hasim.png", id:"MainAssets_stakeholder_hasim", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_hasim_disabled.png", id:"MainAssets_stakeholder_hasim_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_Nia.png", id:"MainAssets_stakeholder_Nia", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_nia_disabled.png", id:"MainAssets_stakeholder_nia_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_onneetse.png", id:"MainAssets_stakeholder_onneetse", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_onneetse_disabled.png", id:"MainAssets_stakeholder_onneetse_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_sarah.png", id:"MainAssets_stakeholder_sarah", bundle:"MainAssets"},
		{src:"assets/skins/images/stakeholder_sarah_disabled.png", id:"MainAssets_stakeholder_sarah_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/StarOptimal.png", id:"MainAssets_StarOptimal", bundle:"MainAssets"},
		{src:"assets/skins/images/StarPlayerChoiceEmpty.png", id:"MainAssets_StarPlayerChoiceEmpty", bundle:"MainAssets"},
		{src:"assets/skins/images/StarPlayerChoiceFilled.png", id:"MainAssets_StarPlayerChoiceFilled", bundle:"MainAssets"},
		{src:"assets/skins/images/Tab1.png", id:"MainAssets_Tab1", bundle:"MainAssets"},
		{src:"assets/skins/images/tab2.png", id:"MainAssets_tab2", bundle:"MainAssets"},
		{src:"assets/skins/images/Tab2BGElement.png", id:"MainAssets_Tab2BGElement", bundle:"MainAssets"},
		{src:"assets/skins/images/tab3.png", id:"MainAssets_tab3", bundle:"MainAssets"},
		{src:"assets/skins/images/Tab3StaticImage.png", id:"MainAssets_Tab3StaticImage", bundle:"MainAssets"},
		{src:"assets/skins/images/TeaCornerIcon.png", id:"MainAssets_TeaCornerIcon", bundle:"MainAssets"},
		{src:"assets/skins/images/TeaCornerIconDisabled.png", id:"MainAssets_TeaCornerIconDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/TimelineBG.png", id:"MainAssets_TimelineBG", bundle:"MainAssets"},
		{src:"assets/skins/images/TimerClock.png", id:"MainAssets_TimerClock", bundle:"MainAssets"},
		{src:"assets/skins/images/timerKeyDecision_Neutral.png", id:"MainAssets_timerKeyDecision_Neutral", bundle:"MainAssets"},
		{src:"assets/skins/images/timerKeyDecision_Urgent.png", id:"MainAssets_timerKeyDecision_Urgent", bundle:"MainAssets"},
		{src:"assets/skins/images/TimingBG.png", id:"MainAssets_TimingBG", bundle:"MainAssets"},
		{src:"assets/skins/images/TopBar.png", id:"MainAssets_TopBar", bundle:"MainAssets"},
		{src:"assets/skins/images/TopicButtonDisabled.png", id:"MainAssets_TopicButtonDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/TopicButtonDown.png", id:"MainAssets_TopicButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/TopicButtonUp.png", id:"MainAssets_TopicButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/TopLeftDisabled.png", id:"MainAssets_TopLeftDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/TrendDownGreen.png", id:"MainAssets_TrendDownGreen", bundle:"MainAssets"},
		{src:"assets/skins/images/TrendDownRed.png", id:"MainAssets_TrendDownRed", bundle:"MainAssets"},
		{src:"assets/skins/images/TrendUpGreen.png", id:"MainAssets_TrendUpGreen", bundle:"MainAssets"},
		{src:"assets/skins/images/TrendUpRed.png", id:"MainAssets_TrendUpRed", bundle:"MainAssets"},
		{src:"assets/skins/images/ViewKDDisabled.png", id:"MainAssets_ViewKDDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/ViewKDOver.png", id:"MainAssets_ViewKDOver", bundle:"MainAssets"},
		{src:"assets/skins/images/ViewKDUp.png", id:"MainAssets_ViewKDUp", bundle:"MainAssets"},
		{src:"assets/skins/images/Vinkje.png", id:"MainAssets_Vinkje", bundle:"MainAssets"},
		{src:"assets/skins/images/VinkjeHi.png", id:"MainAssets_VinkjeHi", bundle:"MainAssets"}
	],
	preloads: []
};



an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(lib.MainAssets = {}, images, ss, createjs, AdobeAn = AdobeAn||{});
var AdobeAn;
module.exports = lib.MainAssets;